/* how to get fly (v3.1, 2026-10-25). the whole client: feed, channel, block, user, brand archive, account, takedown,
   admin, moderation, the connect + add-block windows and the onboarding. loaded on every page from
   layout/theme.liquid (deferred, after mien-supabase.js), so the nav dot and the invite capture
   work site-wide; a view only renders where a section left a [data-fly-view] mount.

   data comes from the fly_* rpcs (supabase/fly/*.sql). nothing here trusts the client for
   anything that matters: the gate, the post cap, post status and admin powers are all
   enforced on the server. user text only ever reaches the dom through textContent. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ utils */
  var CATS = ['clothing', 'footwear', 'accessories', 'jewelry', 'objects', 'print', 'home', 'other'];
  var OLD_CATS = { tops: 'clothing', tees: 'clothing', shirts: 'clothing', hoodies: 'clothing', sweaters: 'clothing',
    knitwear: 'clothing', jackets: 'clothing', outerwear: 'clothing', pants: 'clothing', denim: 'clothing',
    shorts: 'clothing', hats: 'accessories', bags: 'accessories', accessories: 'accessories', jewelry: 'jewelry',
    necklaces: 'jewelry', bracelets: 'jewelry' };

  function h(tag, attrs) {
    var el = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      var v = attrs[k];
      if (v == null || v === false) continue;
      if (k === 'text') el.textContent = v;
      else if (k === 'on') for (var ev in v) el.addEventListener(ev, v[ev]);
      else if (k === 'html') el.innerHTML = v; /* static markup only, never user text */
      else el.setAttribute(k, v === true ? '' : v);
    }
    for (var i = 2; i < arguments.length; i++) add(el, arguments[i]);
    return el;
  }
  function add(el, c) {
    if (c == null || c === false) return;
    if (Array.isArray(c)) { c.forEach(function (x) { add(el, x); }); return; }
    el.appendChild(typeof c === 'string' || typeof c === 'number' ? document.createTextNode(String(c)) : c);
  }
  function qp(name) { try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function safeUrl(u) { u = String(u || ''); return (/^https?:\/\//i.test(u) || /^\/(?!\/)/.test(u)) ? u : null; }
  /* mien.css sets scroll-behavior:smooth on html. putting a page back where it was must jump, not glide */
  function jumpTo(y) {
    var d = document.documentElement, b = d.style.scrollBehavior;
    d.style.scrollBehavior = 'auto'; window.scrollTo(0, y); d.style.scrollBehavior = b;
  }
  function hostOf(u) { try { return new URL(u, location.origin).hostname.replace(/^www\./, ''); } catch (e) { return ''; } }
  function money(n, cur) {
    if (n == null || n === '') return '';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD', maximumFractionDigits: Number(n) % 1 ? 2 : 0 }).format(Number(n)); }
    catch (e) { return '$' + n; }
  }
  function ago(ts) {
    var s = (Date.now() - new Date(ts).getTime()) / 1000;
    if (s < 3600) return Math.max(1, Math.round(s / 60)) + 'm ago';
    if (s < 86400) return Math.round(s / 3600) + 'h ago';
    if (s < 86400 * 30) return Math.round(s / 86400) + 'd ago';
    return day(ts);
  }
  /* a plain date, "oct 27, 2026", or with the time, "oct 27, 8:15 pm" */
  function day(ts, withTime) {
    var d = new Date(ts);
    if (isNaN(d.getTime())) return '';
    return (withTime ? d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
      : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })).toLowerCase();
  }
  /* the screen's note sits inside a sentence of ours, so it loses its own full stop */
  function plainNote(s) { return String(s || '').trim().replace(/\.+$/, ''); }
  function errText(e) {
    var m = String((e && (e.message || e.error_description)) || e || '').toLowerCase();
    var map = {
      invite_required: 'mien is invite-only right now. enter an invite code first.',
      source_required: 'add the source link, or tick "own photo".', image_required: 'add an image.',
      daily_cap: "that's today's posting limit. come back tomorrow.", invalid_code: "that code doesn't exist.",
      code_used: 'that code was already used.', no_invites_left: 'no invites left on that link.',
      not_your_channel: "that isn't your channel.", title_required: 'give it a title.',
      embeds_are_house_only: 'pinterest embeds are for house accounts.', bad_pin_url: "that isn't a pinterest pin url.",
      profiles_handle_format: 'handles are 2 to 24 characters: a to z, 0 to 9, dots and underscores.',
      profiles_handle_key: 'that handle is taken.', fly_blocks_pin_once: 'that pin is already on mien.',
      account_paused: 'posting is paused on your account for now.', text_not_allowed: "some of that text isn't allowed. try different words.",
      handle_reserved: 'that handle is reserved.', image_must_be_uploaded: 'upload the image, or pull it from a link.',
      new_account_cap: 'new accounts can post 5 things on their first day.', channel_cap: "that's a lot of new channels today. try again tomorrow.",
      rate_limited: "that's a lot for one day. try again tomorrow.", own_block: "that's your own post. delete it from the post's page instead.",
      already_reported: 'you already reported this one. thanks.', image_too_big: 'that image is too big. try one under 3.5mb.',
      image_bad_type: 'use a jpg, png or webp image.',
      image_too_small: 'that picture is too small. use one at least 300 pixels on its short side.',
      bad_instagram: 'just the instagram handle, like @you: letters, numbers, dots and underscores.',
      block_not_found: "that one isn't up right now. it may already be getting checked again.",
      text_too_long: 'that name is too long. keep it under 60 characters.',
      'duplicate key': 'that one is taken.'
    };
    for (var k in map) if (m.indexOf(k) > -1) return map[k];
    return m || 'something went wrong. try again.';
  }

  var urls = {
    block: function (id) { return '/pages/block?id=' + encodeURIComponent(id); },
    channel: function (slug) { return '/pages/channel?c=' + encodeURIComponent(slug); },
    user: function (hd) { return '/pages/user?u=' + encodeURIComponent(hd); },
    brand: function (t) { return '/pages/brand?b=' + encodeURIComponent(t); },
    product: function (hd) { return '/products/' + encodeURIComponent(hd); }
  };

  /* every handle links to its user page; bot handles (they always end in .bot) carry a BOT label,
     or "(bot)" in running text like notifications */
  function isBot(hd) { return /\.bot$/.test(String(hd || '')); }
  function userLink(hd, paren) {
    if (!hd) return document.createTextNode('a member');
    var a = h('a', { href: urls.user(hd), text: '@' + hd });
    if (!isBot(hd)) return a;
    return h('span', { class: 'fl-who' }, a, paren ? ' (bot)' : h('span', { class: 'fl-botl', title: 'a bot run by mien', text: 'BOT' }));
  }

  /* ------------------------------------------------------------------ supabase */
  function whenMien(cb) {
    var t = 0;
    (function poll() {
      if (window.MIEN && MIEN.sb) { cb(); return; }
      if (++t < 100) setTimeout(poll, 100);
    })();
  }
  function rpc(name, args) {
    return MIEN.sb.rpc(name, args || {}).then(function (r) { if (r.error) throw r.error; return r.data; });
  }
  function token() {
    return MIEN.sb.auth.getSession().then(function (r) { return r && r.data && r.data.session ? r.data.session.access_token : null; });
  }
  function fn(name, body) {
    return token().then(function (t) {
      return fetch(MIEN.url + '/functions/v1/' + name, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: MIEN.key, Authorization: 'Bearer ' + (t || MIEN.key) },
        body: JSON.stringify(body || {})
      }).then(function (r) { return r.json(); });
    });
  }

  var me = null, meReady = null;
  function loadMe() {
    token().then(function (t) { Track.setToken(t); });
    meReady = rpc('my_fly_state').then(function (s) { me = s; paintDot(); return s; }, function () { me = null; return null; });
    return meReady;
  }

  /* signed out: the existing signup modal, then finish what they were doing */
  function requireAuth(then) {
    (meReady || loadMe()).then(function () {
      if (me) { then(); return; }
      if (!window.MienAuthModal) { location.href = '/pages/account'; return; }
      MienAuthModal.open({ mode: 'create', onSuccess: function () { loadMe().then(function () { if (me) then(); }); } });
    });
  }
  /* invite gate: signed in but not a member yet. a paused account gets a toast instead (an invite code would not
     help); onPaused lets a caller undo what it already showed */
  function requireMember(then, onPaused) {
    requireAuth(function () {
      if (me.can_act) then();
      else if (me.paused) { toast('posting is paused on your account' + (me.paused_until ? ' until ' + day(me.paused_until) : '') + '.'); if (onPaused) onPaused(); }
      else inviteWin(then);
    });
  }

  /* ------------------------------------------------------------------ window (os-style modal) */
  var openWins = [];
  function win(title, body, opts) {
    opts = opts || {};
    var close = function () {
      scrim.remove(); openWins = openWins.filter(function (w) { return w !== scrim; });
      if (!openWins.length) document.documentElement.style.overflow = '';
      if (opts.onClose) opts.onClose();
    };
    var w = h('div', { class: 'fl-win' + (opts.wide ? ' is-wide' : ''), role: 'dialog', 'aria-modal': 'true', 'aria-label': title },
      h('div', { class: 'fl-win-bar' },
        h('span', { class: 'fl-win-t', text: title }),
        h('button', { class: 'fl-win-btn', type: 'button', 'aria-label': 'close', text: '×', on: { click: close } })),
      h('div', { class: 'fl-win-body' }, body),
      opts.foot ? h('div', { class: 'fl-win-foot' }, opts.foot) : null);
    var scrim = h('div', { class: 'fl-scrim', on: { click: function (e) { if (e.target === scrim) close(); } } }, w);
    document.body.appendChild(scrim);
    openWins.push(scrim);
    document.documentElement.style.overflow = 'hidden';
    var onKey = function (e) { if (e.key === 'Escape' && openWins[openWins.length - 1] === scrim) { close(); document.removeEventListener('keydown', onKey); } };
    document.addEventListener('keydown', onKey);
    setTimeout(function () { var f = w.querySelector('input, textarea, select, button.fl-btn'); if (f) try { f.focus(); } catch (e) {} }, 30);
    return { close: close, el: w };
  }

  function inviteWin(then) {
    var input = h('input', { class: 'fl-in', type: 'text', placeholder: 'invite code or @handle', value: ls('fly_invite') || '', autocomplete: 'off', autocapitalize: 'off' });
    var err = h('p', { class: 'fl-err', hidden: true });
    var btn = h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'get in' });
    var form = h('form', { on: { submit: function (e) {
      e.preventDefault(); btn.disabled = true; err.hidden = true;
      rpc('claim_invite', { p_code: input.value }).then(function () {
        ls('fly_invite', null); return loadMe();
      }).then(function () { w.close(); if (then) then(); }, function (x) { btn.disabled = false; err.textContent = errText(x); err.hidden = false; });
    } } },
      h('p', { text: 'mien is invite-only for now. posting and saving into channels need an invite from someone already here. browsing never does.' }),
      h('label', { class: 'fl-lbl', text: 'your invite' }), input, err, h('div', { class: 'fl-btns' }, btn));
    var w = win('invite.txt', form);
  }

  /* ------------------------------------------------------------------ signals (fly_events)
     2026-10-27: each impression also becomes a VIEW for the poster's private stats: log_fly_events writes it to
     fly_block_views (one per viewer per block per day, never the poster's own, never a bot account). the batch goes
     every 4 seconds, and with keepalive when the page hides (fetch keepalive, not sendBeacon: the call needs the
     signed-in viewer's token in a header, which sendBeacon cannot send).
     what the ranking learns from: an impression is a block at least half on screen for 1s,
     once per page view; opens, dwell, saves, wants, click-outs and add-to-cart are logged where
     they happen. batched, sent with keepalive when the page hides. nothing at all is sent when the
     browser asks not to be tracked (do-not-track / global privacy control). */
  var Track = (function () {
    var off = navigator.doNotTrack === '1' || window.doNotTrack === '1' || navigator.globalPrivacyControl === true;
    var q = [], timer = null, seen = {}, tok = null, armed = false, waiters = [];
    /* the visitor key lasts across tabs and days (affinity, "already seen"); the seed is new every
       visit and every reload, so a refresh is a fresh mix */
    function sk() {
      var k = ls('fly_vk') || ss('fly_sk');
      if (!k) { k = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); }
      ls('fly_vk', k); ss('fly_sk', k);
      return k;
    }
    function seed() {
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
      var v = ss('fly_seed');
      if (!v || (nav.type === 'reload' && !seed._done)) { v = Math.random().toString(36).slice(2, 10); ss('fly_seed', v); }
      seed._done = true;
      return v;
    }
    /* crawlers render pages but never touch them: nothing is sent until a real pointer, key, wheel
       or scroll. until then events queue (capped, oldest impressions dropped first) */
    function arm(e) {
      if (armed || (e && e.isTrusted === false)) return;
      armed = true;
      ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'].forEach(function (t) { window.removeEventListener(t, arm, true); });
      flush();
      waiters.splice(0).forEach(function (cb) { try { cb(); } catch (x) {} });
    }
    ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'].forEach(function (t) { window.addEventListener(t, arm, { capture: true, passive: true }); });
    function log(b, t, ctx, pos, dwell) {
      if (off || !b) return;
      q.push({ b: b, t: t, c: ctx || null, p: pos != null ? String(pos) : null, d: dwell != null ? String(Math.round(dwell)) : null });
      if (!armed && q.length > 300) { var i = q.findIndex(function (x) { return x.t === 'impression'; }); q.splice(i > -1 ? i : 0, 1); }
      if (q.length >= 40) flush(); else if (!timer) timer = setTimeout(flush, 4000);
    }
    function flush(keep) {
      clearTimeout(timer); timer = null;
      if (!armed || !q.length || !window.MIEN || !MIEN.url) return;
      var batch = q.splice(0, 100);
      try {
        fetch(MIEN.url + '/rest/v1/rpc/log_fly_events', { method: 'POST', keepalive: !!keep,
          headers: { apikey: MIEN.key, Authorization: 'Bearer ' + (tok || MIEN.key), 'Content-Type': 'application/json' },
          body: JSON.stringify({ p_events: batch, p_session: sk() }) }).catch(function () {});
      } catch (e) {}
    }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var el = e.target, id = el.getAttribute('data-fly-id');
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          if (!el._flyT) el._flyT = setTimeout(function () {
            if (!seen[id]) { seen[id] = 1; log(id, 'impression', el.getAttribute('data-fly-ctx'), el.getAttribute('data-fly-pos')); }
            io.unobserve(el);
          }, 1000);
        } else if (el._flyT) { clearTimeout(el._flyT); el._flyT = null; }
      });
    }, { threshold: [0, 0.5] }) : null;
    function watch(el) { if (io && !off) io.observe(el); }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(true); });
    window.addEventListener('pagehide', function () { flush(true); });
    /* other logs (pieces-like impressions) wait for the same proof of a person */
    function whenArmed(cb) { if (off) return; if (armed) cb(); else waiters.push(cb); }
    return { log: log, watch: watch, flush: flush, session: sk, seed: seed, whenArmed: whenArmed, setToken: function (t) { tok = t; } };
  })();
  function tasteParam() { try { return JSON.parse(ls('fly_taste_picks') || 'null'); } catch (e) { return null; } }

  /* ------------------------------------------------------------------ images
     the catalogue images are 2000-3300px originals. the shopify cdn resizes on the fly, so every
     tile asks for roughly its own width and the browser picks from a srcset. */
  function sized(u, w) {
    if (!u || !/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) return u;
    var base = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function srcsetOf(u) {
    if (!u || !/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) return null;
    return [320, 480, 720, 1080].map(function (w) { return sized(u, w) + ' ' + w + 'w'; }).join(', ');
  }
  function pic(u, cls, alt, w, hh, sizes, eager) {
    var img = h('img', { class: cls + ' fl-fade', src: sized(u, 720), srcset: srcsetOf(u), sizes: srcsetOf(u) ? sizes : null,
      alt: alt || '', loading: eager ? 'eager' : 'lazy', decoding: 'async', width: w || null, height: hh || null });
    var done = function () { img.classList.add('is-in'); };
    if (img.complete && img.naturalWidth) done(); else { img.addEventListener('load', done); img.addEventListener('error', done); }
    return img;
  }

  /* ------------------------------------------------------------------ cart + toast */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      Array.prototype.forEach.call(document.querySelectorAll('.mhd-n'), function (n) { n.textContent = c.item_count; n.classList.toggle('is-zero', !c.item_count); });
      /* the bag is hidden while empty (.is-empty); fly pages don't load mien-feed.js, which used to clear it */
      Array.prototype.forEach.call(document.querySelectorAll('.mhd-cart'), function (el) {
        el.classList.toggle('is-empty', !c.item_count);
        el.classList.remove('fl-pulse'); void el.offsetWidth; el.classList.add('fl-pulse');
        setTimeout(function () { el.classList.remove('fl-pulse'); }, 900);
      });
    }).catch(function () {});
  }
  var toastEl = null, toastT = null;
  function toast(msg, actions) {
    if (toastEl) toastEl.remove();
    clearTimeout(toastT);
    var row = h('div', { class: 'fl-toast-a' });
    (actions || []).forEach(function (a) {
      row.appendChild(a.href ? h('a', { href: a.href, text: a.label })
        : h('button', { type: 'button', text: a.label, on: { click: function () { toastEl && toastEl.remove(); a.run(); } } }));
    });
    toastEl = h('div', { class: 'fl-toast', role: 'status' }, h('span', { text: msg }), (actions && actions.length) ? row : null);
    document.body.appendChild(toastEl);
    toastT = setTimeout(function () { if (toastEl) toastEl.remove(); toastEl = null; }, actions && actions.length ? 6000 : 3500);
  }

  /* ------------------------------------------------------------------ save (2026-10-27)
     every way of saving (the save button, a double tap, a long press, the closeup) opens one small window:
     save to your profile (your private "saved" channel, the saves tab) or to one of your channels.
     there is no separate "connect": saving into a channel is the only word for it. */
  function quickSave(c, btn, ctx) { saveWin(c, { btn: btn, ctx: ctx }); }

  /* ------------------------------------------------------------------ tiles + masonry */
  function ratioOf(c) {
    if (c.kind === 'pinterest_embed') return 1.6;
    if (c.kind === 'x_channel') return 1;
    if (c.kind === 'x_brand') return 1;
    if (c.kind === 'x_spot') return 1.12;
    if (c.kind === 'x_picked') return 1;
    return (c.w && c.h) ? Math.min(Math.max(c.h / c.w, 0.75), 1.6) : 1.25;
  }
  /* the crop a size gets: tall is a portrait crop, wide and hero are landscape on a wide screen and the
     picture's own shape (within reason) on a phone, where both run the full width */
  function sizeRatio(c, size, ncols) {
    var r = ratioOf(c);
    if (size === 'tall') return Math.max(r, 1.5);
    if (ncols <= 2) return Math.min(Math.max(r, 0.8), 1.25);
    if (size === 'hero') return ncols >= 4 ? 0.42 : 0.5;
    return 0.72;
  }
  var TILE_SIZES = '(max-width: 559px) calc(50vw - 14px), (max-width: 1099px) calc(33vw - 16px), 280px';
  /* what your own posts say while the automatic screen has them, or after it said no */
  var ST_LABEL = { pending: 'checking', rejected: 'not posted', removed: 'taken down' };
  /* a quick black "saved" over the tile, for the double tap */
  function flash(t, text) {
    var f = h('span', { class: 'fl-flash', text: text || 'saved', 'aria-hidden': 'true' });
    var m = t.querySelector('.fl-tile-media') || t;
    m.appendChild(f);
    setTimeout(function () { f.remove(); }, 900);
  }
  function tile(c, opts) {
    opts = opts || {};
    if (c.kind === 'x_channel' || c.kind === 'x_brand' || c.kind === 'x_spot' || c.kind === 'x_picked') return mixTile(c);
    var isProd = c.kind === 'product', isLink = c.kind === 'linkout_product';
    var href = isProd ? urls.product(c.handle) : urls.block(c.id);
    var t;
    if (c.kind === 'pinterest_embed') {
      t = h('div', { class: 'fl-tile is-embed' },
        h('div', { class: 'fl-embed' }, h('a', { 'data-pin-do': 'embedPin', 'data-pin-width': 'small', href: safeUrl(c.embed_url) })),
        h('a', { class: 'fl-tile-lab', href: urls.block(c.id) }, h('span', { text: '"pin"' }), h('span', { text: c.credit || '' })));
      loadPinit();
    } else {
      var size = opts.size || null;
      var r = size ? sizeRatio(c, size, opts.ncols || 2) : ratioOf(c);
      var big = size === 'hero' || size === 'wide';
      var media = h('span', { class: 'fl-tile-media', style: 'aspect-ratio:' + (1 / r).toFixed(4) },
        pic(c.img, 'fl-tile-img', c.title || c.brand || '', c.w, c.h, big ? '(max-width: 559px) 100vw, 66vw' : TILE_SIZES,
          (opts.pos != null && opts.pos < 4 && (opts.ctx === 'feed' || opts.ctx === 'related')) || big));
      if (opts.pos != null && opts.pos < 2) media.firstChild.setAttribute('fetchpriority', 'high');
      /* a product's price sits on the picture, bottom left, in the small type (with "on mien" when mien sells it) */
      if ((isProd || isLink) && c.price != null) media.appendChild(h('span', { class: 'fl-tile-price', text: money(c.price, c.currency) + (isProd ? ' \u00b7 on mien' : '') }));
      /* 2026-10-27: picked by mien (everyone sees it), and on a picture: its buy link's price, "shop this" when it has
         matches (opens them), and the poster's instagram */
      if (c.picked) media.appendChild(h('span', { class: 'fl-tile-pick', text: 'picked by mien' }));
      /* the latest tab says when each one went up and who posted it, so newest-first is something you can see */
      if (c._when && c.created_at) media.appendChild(h('span', { class: 'fl-tile-when', text: ago(c.created_at) + (c.owner && c.owner.handle ? ' \u00b7 @' + c.owner.handle : '') }));
      if (!isProd && !isLink) {
        var chips = h('span', { class: 'fl-tile-chips' });
        if (c.tag && c.tag.price != null) chips.appendChild(h('span', { class: 'fl-tile-chip', text: money(c.tag.price, c.tag.currency) + (c.tag.domain ? ' at ' + String(c.tag.domain).replace(/^www\./, '') : '') }));
        else if (c.shop) chips.appendChild(h('button', { class: 'fl-tile-chip fl-tile-shop', type: 'button', text: 'shop this', on: { click: function (e) {
          e.preventDefault(); e.stopPropagation(); openShop(c, opts);
        } } }));
        if (c.ig) chips.appendChild(h('span', { class: 'fl-tile-chip fl-tile-ig', role: 'link', tabindex: '0', text: '@' + c.ig, on: { click: function (e) {
          e.preventDefault(); e.stopPropagation(); window.open('https://www.instagram.com/' + encodeURIComponent(c.ig) + '/', '_blank', 'noopener');
        } } }));
        if (chips.firstChild) media.appendChild(chips);
      }
      /* a picture whose clothes are matched to pieces ("in this fit") carries a small dot */
      if (c.fit) media.appendChild(h('span', { class: 'fl-fitdot', title: 'in this fit', 'aria-label': 'has in this fit' }));
      t = h('a', { class: 'fl-tile fl-plain' + (c.status === 'pending' ? ' is-pending' : '') + (isProd || isLink ? ' is-prod' : '') + (size ? ' is-' + size : ''),
        href: href, 'data-fly-id': c.id, 'data-fly-ctx': opts.ctx || 'feed', 'data-fly-pos': opts.pos != null ? opts.pos : null }, media);
      /* no line of text under a tile (2026-10-26): the board is pictures edge to edge; who sells it is in the closeup */
      if (opts.label && (c.brand || c.title)) {
        t.appendChild(h('span', { class: 'fl-tile-cap', text: c.brand || c.title }));
      }
      /* shop your taste: the one place a tile says something under the picture */
      if (c.why) t.appendChild(h('span', { class: 'fl-tile-why', text: c.why }));
      if (opts.status && c.status !== 'approved') t.appendChild(h('span', { class: 'fl-tile-st', text: ST_LABEL[c.status] || c.status }));
      gestures(t, c, opts);
      Track.watch(t);
    }
    if (!opts.noConnect && c.status !== 'rejected' && c.status !== 'removed') {
      var sv = h('button', { class: 'fl-save', type: 'button', 'aria-label': 'save', on: { click: function (e) {
        e.preventDefault(); e.stopPropagation(); quickSave(c, sv, opts.ctx);
      } } }, h('span', { class: 'fl-save-t', text: 'save' }), h('span', { class: 'fl-save-p', 'aria-hidden': 'true', text: '+' }));
      t.appendChild(sv);
    }
    if (opts.onRemove) {
      t.appendChild(h('button', { class: 'fl-x', type: 'button', 'aria-label': 'remove from channel', text: '×', on: { click: function (e) {
        e.preventDefault(); e.stopPropagation(); opts.onRemove(c, t);
      } } }));
    }
    return t;
  }
  /* the feed's mixed-in tiles (2026-10-26): a channel (its three newest pictures as a mosaic) or a brand (its
     mark on a plain plate). they sit in the masonry like any other tile and link out to the channel or the
     brand archive; they are never saved, served or swiped through */
  function mixTile(c) {
    /* a poster to follow: four of their posts and their handle */
    if (c.kind === 'x_spot') {
      var grid4 = h('span', { class: 'fl-spot-grid', 'aria-hidden': 'true' });
      (c.items || []).slice(0, 4).forEach(function (it) { grid4.appendChild(pic(it.img, 'fl-chan-im', '', it.w, it.h, '160px')); });
      grid4.appendChild(h('span', { class: 'fl-mix-chip' }, h('span', { class: 'fl-mix-k', text: 'poster to follow' }), h('span', { class: 'fl-mix-t', text: '@' + c.handle })));
      return h('a', { class: 'fl-tile fl-plain fl-mix is-spot', href: urls.user(c.handle) }, grid4);
    }
    /* picked by mien: three picked posts; a tap walks all of them in the closeup */
    if (c.kind === 'x_picked') {
      var pm = h('span', { class: 'fl-chan-mos fl-mix-mos', 'aria-hidden': 'true' });
      (c.items || []).slice(0, 3).forEach(function (it, i) { pm.appendChild(pic(it.img, 'fl-chan-im', '', it.w, it.h, i ? '120px' : TILE_SIZES)); });
      pm.appendChild(h('span', { class: 'fl-mix-chip' }, h('span', { class: 'fl-mix-k', text: 'picked by mien' }), h('span', { class: 'fl-mix-t', text: (c.items || []).length + ' posts' })));
      var pa = h('a', { class: 'fl-tile fl-plain fl-mix is-picked', href: c.items && c.items[0] ? urls.block(c.items[0].id) : '/' }, pm);
      pa.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0 || !c.items || !c.items.length) return;
        e.preventDefault(); Closeup.open(c.items[0], 'feed', null, function () { return c.items; });
      });
      return pa;
    }
    if (c.kind === 'x_channel') {
      var mos = h('span', { class: 'fl-chan-mos fl-mix-mos', 'aria-hidden': 'true' });
      for (var i = 0; i < 3; i++) {
        var src = c.preview && c.preview[i];
        mos.appendChild(src ? pic(src, 'fl-chan-im', '', null, null, i ? '120px' : TILE_SIZES) : h('span', { class: 'fl-chan-im' }));
      }
      mos.appendChild(h('span', { class: 'fl-mix-chip' }, h('span', { class: 'fl-mix-k', text: 'channel' }), h('span', { class: 'fl-mix-t', text: c.title })));
      return h('a', { class: 'fl-tile fl-plain fl-mix is-chan', href: urls.channel(c.slug) }, mos);
    }
    return h('a', { class: 'fl-tile fl-plain fl-mix is-brand', href: urls.brand(c.tag) },
      h('span', { class: 'fl-mix-plate' }, c.logo ? h('img', { class: 'fl-mix-logo', src: c.logo, alt: c.name, loading: 'lazy' }) : h('span', { class: 'fl-mix-word', text: c.name }),
        h('span', { class: 'fl-mix-chip' }, h('span', { class: 'fl-mix-k', text: 'brand' }), h('span', { class: 'fl-mix-t', text: c.name }))));
  }
  /* "shop this": open the closeup and bring its matches ("in this fit" or "pieces like this") into view */
  function openShop(c, opts) {
    Closeup.open(c, (opts && opts.ctx) || 'feed', opts && opts.pos, (opts && opts.nav) || null);
    var tries = 0;
    (function look() {
      var el = document.querySelector('.fl-cu .fl-fit, .fl-cu .fl-pl:not([hidden]), .fl-cu .fl-match');
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (++tries < 30) setTimeout(look, 150);
    })();
  }
  /* one tap opens the closeup; two taps or a long press open the save window. the single tap
     waits a moment to be sure it is not the first of two; modified clicks keep the real link */
  function gestures(t, c, opts) {
    var last = 0, timer = null, press = null, pressed = false, sx = 0, sy = 0;
    t.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      if (pressed) { pressed = false; return; }
      if (c.status !== 'approved' && !opts.status) return;
      var now = Date.now();
      if (now - last < 320) {
        clearTimeout(timer); last = 0;
        quickSave(c, t.querySelector('.fl-save'), opts.ctx);
        return;
      }
      last = now;
      clearTimeout(timer);
      timer = setTimeout(function () { last = 0; if (opts.onOpen) opts.onOpen(c); Closeup.open(c, opts.ctx || 'feed', opts.pos, opts.nav || null); }, 260);
    });
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' || c.status !== 'approved' || opts.noConnect) return;
      sx = e.clientX; sy = e.clientY; pressed = false;
      clearTimeout(press);
      press = setTimeout(function () {
        pressed = true; clearTimeout(timer); last = 0;
        if (navigator.vibrate) try { navigator.vibrate(12); } catch (x) {}
        quickSave(c, t.querySelector('.fl-save'), opts.ctx);
      }, 520);
    });
    t.addEventListener('pointermove', function (e) { if (press && (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10)) { clearTimeout(press); press = null; } });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { t.addEventListener(ev, function () { clearTimeout(press); press = null; }); });
    t.addEventListener('contextmenu', function (e) { if (pressed) e.preventDefault(); });
  }

  /* columns sized like a pin board: ~250px wide, 2 on a phone, up to 6 on a wide screen. each new
     tile drops into the shortest column, so reading order stays roughly row by row.
     with opts.sizes (the feed), a stretch of tiles leads with one large tile, the best-scoring photo in it:
     a hero (full width) or a wide (two columns, the other columns run beside it), alternating, so the
     pattern has a beat and two large tiles never touch. a few portrait photos get the tall crop. */
  function colsFor(w) {
    if (w < 560) return 2;
    return Math.max(3, Math.min(6, Math.floor((w + 16) / 266)));
  }
  function leadOf(cards) {
    var best = null;
    cards.forEach(function (c) {
      if (c.kind !== 'image' || c.status === 'pending' || (c.w && c.w < 800)) return;
      if (!best || (Number(c.score) || 0) > (Number(best.score) || 0)) best = c;
    });
    return best;
  }
  function Masonry(root, opts) {
    opts = opts || {};
    var items = [], cols = [], heights = [], n = 0, pos = opts.start || 0, lead = null, leadSize = opts.lead || null;
    function place(it) {
      var i = heights.indexOf(Math.min.apply(null, heights));
      cols[i].appendChild(it.el);
      heights[i] += it.r + 0.03 + (opts.label || it.c.why ? 0.1 : 0);
    }
    function mk(c, size) {
      var o = {}; for (var k in opts) o[k] = opts[k];
      o.pos = c._pos; o.size = size || c._size || null; o.ncols = n;
      return tile(c, o);
    }
    function build() {
      n = colsFor(root.clientWidth || window.innerWidth);
      root.textContent = ''; cols = []; heights = [];
      root.classList.add('fl-mas');
      var grid = function () { return h('div', { class: 'fl-grid', style: 'grid-template-columns:repeat(' + n + ',minmax(0,1fr))' }); };
      var host = grid();
      function col(parent, h0) { var c = h('div', { class: 'fl-col' }); parent.appendChild(c); cols.push(c); heights.push(h0); }
      if (lead) {
        var hero = leadSize === 'hero' || n <= 2;
        lead.el = mk(lead.c, hero ? 'hero' : 'wide');
        if (hero) root.appendChild(h('div', { class: 'fl-lead' }, lead.el));
        else {
          /* the wide tile spans two grid columns, with two columns of its own under it */
          var under = h('div', { class: 'fl-grid', style: 'grid-template-columns:repeat(2,minmax(0,1fr))' });
          var dbl = h('div', { class: 'fl-dbl' }, lead.el, under);
          var wideH = 2 * sizeRatio(lead.c, 'wide', n) + 0.08;
          if (opts.side !== 'right') host.appendChild(dbl);
          col(under, wideH); col(under, wideH);
          for (var j = 0; j < n - 2; j++) col(host, 0);
          if (opts.side === 'right') host.appendChild(dbl);
        }
      }
      if (!cols.length) for (var i = 0; i < n; i++) col(host, 0);
      root.appendChild(host);
      items.forEach(function (it) { if (it !== lead) { it.el = mk(it.c); place(it); } });
    }
    build();
    var rt;
    function onResize() {
      if (!root.isConnected) { window.removeEventListener('resize', onResize); return; }
      clearTimeout(rt); rt = setTimeout(function () { if (colsFor(root.clientWidth || window.innerWidth) !== n) build(); }, 150);
    }
    window.addEventListener('resize', onResize);
    return {
      add: function (cards) {
        var rebuild = false;
        if (opts.sizes && !lead && !items.length) {
          var lc = leadOf(cards);
          if (lc) { lead = { c: lc, r: 0, prod: false }; rebuild = true; }
        }
        var k = 0;
        cards.forEach(function (c) {
          c._pos = pos++;
          /* a beat of tall crops: every third portrait photo */
          if (opts.sizes && c.kind === 'image' && ratioOf(c) >= 1.05 && (lead ? c !== lead.c : true) && (++k % 3 === 2)) c._size = 'tall';
          if (lead && c === lead.c) { items.unshift(lead); return; }
          var size = c._size || null;
          var it = { c: c, r: size ? sizeRatio(c, size, n) : ratioOf(c), prod: c.kind === 'product' || c.kind === 'linkout_product' };
          items.push(it);
          if (!rebuild) { it.el = mk(c); place(it); }
        });
        if (rebuild) build();
      },
      remove: function (el) { items = items.filter(function (it) { return it.el !== el; }); if (lead && lead.el === el) lead = null; build(); },
      clear: function () { items = []; lead = null; pos = opts.start || 0; build(); },
      size: function () { return items.length; },
      cards: function () { return items.map(function (it) { return it.c; }); }
    };
  }

  var pinitLoaded = false, pinitTimer = null;
  function loadPinit() {
    if (!pinitLoaded) {
      pinitLoaded = true;
      var s = document.createElement('script'); s.async = true; s.defer = true;
      s.src = 'https://assets.pinterest.com/js/pinit.js';
      document.body.appendChild(s);
    } else {
      clearTimeout(pinitTimer);
      pinitTimer = setTimeout(function () { try { if (window.PinUtils) PinUtils.build(); } catch (e) {} }, 200);
    }
  }

  function chanCard(ch) {
    var mos = h('div', { class: 'fl-chan-mos', 'aria-hidden': 'true' });
    for (var i = 0; i < 3; i++) {
      var src = ch.preview && ch.preview[i];
      mos.appendChild(src ? pic(src, 'fl-chan-im', '', null, null, i ? '120px' : '240px') : h('span', { class: 'fl-chan-im' }));
    }
    /* a div, not one big link: the title and the owner's handle are separate links */
    return h('div', { class: 'fl-chan' },
      h('a', { class: 'fl-chan-link', href: urls.channel(ch.slug) }, mos, h('p', { class: 'fl-chan-t', text: ch.title })),
      h('p', { class: 'fl-chan-m' }, String(ch.count || 0) + ' blocks',
        ch.owner && ch.owner.handle ? [' · ', userLink(ch.owner.handle)] : null,
        ch.visibility === 'private' ? ' · private' : ''));
  }

  /* infinite loader. keeps loading while the sentinel stays near the viewport, so a tall screen
     never stalls after the first page. */
  function moreLoader(container, load, margin) {
    var sent = h('div', { class: 'fl-more', 'aria-hidden': 'true' }, h('span', { class: 'fl-dots' }, h('i'), h('i'), h('i')));
    container.appendChild(sent);
    var busy = false, done = false, m = margin || 1600;
    function near() { if (!sent.isConnected) return false; var r = sent.getBoundingClientRect(); return r.top < window.innerHeight + m && r.bottom > -m; }
    function go() {
      if (busy || done) return;
      /* the closeup or the feed it belonged to was cleared: stop for good */
      if (!sent.isConnected) { done = true; io.disconnect(); return; }
      busy = true;
      Promise.resolve(load()).then(function (more) {
        busy = false;
        if (!more) { done = true; sent.remove(); io.disconnect(); return; }
        if (near()) setTimeout(go, 50);
      }, function () { busy = false; sent.textContent = ''; });
    }
    /* inside the closeup the layer is the scroller: observed against the window, its clip would hide
       the sentinel until it was actually on screen and the margin would never apply */
    var scroller = container.closest ? container.closest('.fl-cu') : null;
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) go(); }, { root: scroller, rootMargin: m + 'px 0px' });
    io.observe(sent);
    return { stop: function () { done = true; io.disconnect(); sent.remove(); }, kick: function () { if (!done) go(); } };
  }

  /* ------------------------------------------------------------------ the save window
     your profile first (the private "saved" channel behind the saves tab), then your channels, then a new one.
     every row is a toggle: tap again to take it back out. the save button on the tile turns on while it is saved anywhere. */
  function saveWin(c, o) {
    o = o || {};
    requireAuth(function () {
      var err = h('p', { class: 'fl-err', hidden: true });
      var prof = h('button', { type: 'button', 'aria-pressed': 'false' }, h('span', { class: 'fl-box' }),
        h('span', null, h('b', { text: 'save to your profile' }), ' ', h('span', { class: 'fl-small', text: 'only you see your saves' })));
      var list = h('ul', { class: 'fl-chlist' });
      var newIn = h('input', { class: 'fl-in', type: 'text', maxlength: '80', placeholder: 'new channel name' });
      var newForm = h('form', { class: 'fl-row', style: 'margin-top:12px', on: { submit: function (e) {
        e.preventDefault();
        if (!newIn.value.trim()) return;
        requireMember(function () {
          rpc('create_channel', { p_title: newIn.value, p_description: null, p_visibility: 'public' }).then(function (ch) {
            newIn.value = '';
            return rpc('connect_block', { p_block: c.id, p_channel: ch.id });
          }).then(function () { done(true); fill(); }, showErr);
        });
      } } }, newIn, h('button', { class: 'fl-btn', type: 'submit', text: 'make it', style: 'flex:0 0 auto' }));
      var body = h('div', { class: 'fl-savewin' },
        h('ul', { class: 'fl-chlist fl-save-prof' }, h('li', null, prof)),
        h('p', { class: 'fl-save-k', text: 'or save to a channel' }),
        list, newForm, err);
      var state = { def: null, on: {} };
      function showErr(x) { err.textContent = errText(x); err.hidden = false; }
      function setPressed(b, on) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.querySelector('.fl-box').textContent = on ? '✓' : ''; }
      function anyOn() { return Object.keys(state.on).some(function (k) { return state.on[k]; }); }
      function done(on) {
        if (on) Track.log(c.id, 'connect', o.ctx || 'closeup');
        if (o.btn) o.btn.classList.toggle('is-on', anyOn() || on);
      }
      function toggle(b, ch, run) {
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') !== 'true';
          setPressed(b, on); err.hidden = true;
          run(on).then(function () { state.on[ch.key] = on; done(on); }, function (x) { setPressed(b, !on); showErr(x); });
        });
      }
      function fill() {
        rpc('my_channels', { p_block: c.id }).then(function (chs) {
          list.textContent = '';
          var def = chs.filter(function (x) { return x.is_default; })[0] || null;
          state.def = def; state.on.def = !!(def && def.has_block);
          setPressed(prof, state.on.def);
          var mine = chs.filter(function (x) { return !x.is_default; });
          if (!mine.length) list.appendChild(h('li', { class: 'fl-small fl-save-none', text: 'no channels yet. name one below.' }));
          mine.forEach(function (ch) {
            ch.key = ch.id; state.on[ch.key] = !!ch.has_block;
            var b = h('button', { type: 'button', 'aria-pressed': 'false' }, h('span', { class: 'fl-box' }),
              h('span', null, h('b', { text: ch.title }), ' ', h('span', { class: 'fl-small', text: (ch.visibility === 'private' ? 'private · ' : '') + (ch.count || 0) + ' saved' })));
            setPressed(b, ch.has_block);
            toggle(b, ch, function (on) {
              return on ? new Promise(function (res, rej) { requireMember(function () { rpc('connect_block', { p_block: c.id, p_channel: ch.id }).then(res, rej); },
                  function () { rej(new Error('account_paused')); }); })
                : rpc('disconnect_block', { p_block: c.id, p_channel: ch.id });
            });
            list.appendChild(h('li', null, b));
          });
        }, showErr);
      }
      toggle(prof, { key: 'def' }, function (on) {
        if (on) return rpc('fly_save_block', { p_block: c.id }).then(function (r) { if (!state.def) state.def = { id: r.channel_id }; else state.def.id = r.channel_id; });
        return state.def && state.def.id ? rpc('disconnect_block', { p_block: c.id, p_channel: state.def.id }) : Promise.resolve();
      });
      fill();
      win('save', body);
    });
  }

  /* ------------------------------------------------------------------ add-block window */
  /* a big phone photo is shrunk to 1600px before upload: the screen, describe and analysis steps can only read images
     under about 3.6mb, the bucket refuses anything over 3.5mb, and the storage project cannot resize on the fly.
     gifs are not accepted any more (an animated image can't be checked); the gif skip below is left harmless.
     takes a file or a plain blob. the short side never drops under 300px, the screen's smallest */
  function shrink(f) {
    if (f.type === 'image/gif' || f.size <= 2500000 || !window.createImageBitmap) return Promise.resolve(f);
    return createImageBitmap(f).then(function (bm) {
      var k = Math.min(1, Math.max(1600 / Math.max(bm.width, bm.height), 300 / Math.min(bm.width, bm.height)));
      var c = document.createElement('canvas');
      c.width = Math.round(bm.width * k); c.height = Math.round(bm.height * k);
      c.getContext('2d').drawImage(bm, 0, 0, c.width, c.height);
      return new Promise(function (res) { c.toBlob(function (b) { res(b && b.size < f.size ? b : f); }, 'image/jpeg', 0.85); });
    }).catch(function () { return f; });
  }
  /* what an image really is, from its first bytes: a fetched blob can come back typed as octet-stream */
  function sniff(b) {
    if (/^image\//.test(b.type) || !b.slice || !window.Blob) return Promise.resolve(b);
    return new Response(b.slice(0, 12)).arrayBuffer().then(function (buf) {
      var x = new Uint8Array(buf), s = String.fromCharCode.apply(null, x);
      var t = x[0] === 0xff && x[1] === 0xd8 ? 'image/jpeg' : s.indexOf('\x89PNG') === 0 ? 'image/png'
        : s.indexOf('RIFF') === 0 && s.slice(8, 12) === 'WEBP' ? 'image/webp' : s.indexOf('GIF8') === 0 ? 'image/gif' : '';
      return t ? new Blob([b], { type: t }) : b;
    }, function () { return b; });
  }
  /* the picture's own size, or null when the browser can't read it (the screen still checks it) */
  function measure(u) {
    return new Promise(function (res) {
      var im = new Image();
      im.onload = function () { res(im.naturalWidth ? { w: im.naturalWidth, h: im.naturalHeight } : null); };
      im.onerror = function () { res(null); };
      im.src = u;
    });
  }
  function addWin(opts) {
    opts = opts || {};
    requireMember(function () {
      var state = { path: null, url: null, w: null, h: null };
      var err = h('p', { class: 'fl-err', hidden: true });
      /* posting (2026-10-26, rebuilt): step one is just "add a photo" or "paste a link". once there is a picture, step two
         shows it big with one caption line, the channel as chips, and post. brand, category and the source link live under
         "details" (the source link is only asked for when it is not your photo) */
      var drop = h('label', { class: 'fl-drop fl-post-drop' }, h('span', { class: 'fl-post-drop-t', text: 'add a photo' }), h('span', { class: 'fl-post-drop-s', text: 'from your camera roll' }));
      var file = h('input', { type: 'file', accept: 'image/jpeg,image/png,image/webp', class: 'fl-sr' });
      drop.appendChild(file);
      var link = h('input', { class: 'fl-in', type: 'url', placeholder: 'or paste a link to a product or a picture', inputmode: 'url' });
      var pull = h('button', { class: 'fl-btn', type: 'button', text: 'add' });
      var src = h('input', { class: 'fl-in', type: 'url', placeholder: 'where it came from (https://)', inputmode: 'url' });
      var own = h('input', { type: 'checkbox' });
      var title = h('input', { class: 'fl-in fl-post-cap', type: 'text', maxlength: '140', placeholder: 'say something about it (optional)' });
      var brand = h('input', { class: 'fl-in', type: 'text', maxlength: '60', placeholder: 'optional', autocapitalize: 'off' });
      var cat = h('select', { class: 'fl-sel' }, h('option', { value: '', text: 'category (optional)' }),
        CATS.map(function (c) { return h('option', { value: c, text: c }); }));
      var chan = h('select', { class: 'fl-sel' });
      var note = h('input', { class: 'fl-in', type: 'text', maxlength: '140', placeholder: 'year, story, one line' });
      var asOwner = h('select', { class: 'fl-sel' }, h('option', { value: '', text: 'post as me' }));
      var kind = h('select', { class: 'fl-sel', hidden: true }, h('option', { value: 'image', text: 'image' }));
      var submit = h('button', { class: 'btn-primary fl-post-go', type: 'submit', text: 'post' });
      var chips = h('div', { class: 'fl-post-chans', role: 'radiogroup', 'aria-label': 'channel' });
      /* buy link required (2026-10-27): everything on mien links to somewhere you can buy it. the link becomes the
         post's confirmed buy tag; a post without one is not taken */
      var BUY_ASK = 'paste the link to where you can buy it. a store, a brand, a resale listing.';
      var buy = h('input', { class: 'fl-in fl-post-buy', type: 'url', placeholder: 'where can you buy this? paste the link', inputmode: 'url', autocomplete: 'off', required: true });
      var buyNote = h('p', { class: 'fl-mono fl-post-buyn', text: BUY_ASK });
      var buySeq = 0;
      function checkBuy() {
        var u = safeUrl(buy.value.trim()), seq = ++buySeq;
        if (!u || !/^https?:/.test(u)) { buyNote.textContent = BUY_ASK; return; }
        buyNote.textContent = 'checking the link';
        fn('link-preview', { url: u }).then(function (r) {
          if (seq !== buySeq) return;
          var site = (r && r.site) || hostOf(u);
          buyNote.textContent = r && r.price != null ? money(r.price, r.currency) + ' at ' + String(site).toLowerCase() + '. this post will be buyable.'
            : 'no price found on that page, but the link goes on the post.';
        }, function () { if (seq === buySeq) buyNote.textContent = 'the link goes on the post.'; });
      }
      buy.addEventListener('change', checkBuy);
      buy.addEventListener('paste', function () { setTimeout(checkBuy, 0); });

      function setImage(url, w, hh, path) {
        state.url = url; state.path = path || null; state.w = w || null; state.h = hh || null;
        preview.textContent = ''; preview.appendChild(h('img', { src: url, alt: '' }));
        preview.appendChild(h('button', { class: 'fl-post-swap', type: 'button', text: 'change', on: { click: function () { step(1); } } }));
        step(2);
      }
      /* both ways in end here: a jpg, png or webp, at least 300px on its short side, shrunk, under 3.5mb, uploaded to
         fly-blocks in the member's own folder. the server takes only those storage paths from members, and the screen
         pins its own copy before a post goes live */
      function take(blob) {
        var objUrl = URL.createObjectURL(blob), dim = null;
        return measure(objUrl).then(function (d) {
          dim = d;
          if (d && Math.min(d.w, d.h) < 300) throw new Error('image_too_small');
          return shrink(blob);
        }).then(function (up) {
          if (!/^image\/(jpeg|png|webp)$/.test(up.type)) throw new Error('image_bad_type');
          if (up.size > 3500000) throw new Error('image_too_big');
          var path = me.id + '/' + (crypto.randomUUID ? crypto.randomUUID() : String(Date.now())) + '.' + up.type.split('/')[1].replace('jpeg', 'jpg');
          return MIEN.sb.storage.from('fly-blocks').upload(path, up, { contentType: up.type, upsert: false }).then(function (r) {
            if (r.error) throw r.error;
            setImage(objUrl, dim && dim.w, dim && dim.h, path);
            state.url = MIEN.sb.storage.from('fly-blocks').getPublicUrl(path).data.publicUrl;
          });
        });
      }
      file.addEventListener('change', function () {
        var f = file.files && file.files[0]; if (!f) return;
        /* accept is only a hint: "all files" can still pick a gif or a heic */
        if (!/^image\/(jpeg|png|webp)$/.test(f.type)) { err.textContent = errText('image_bad_type'); err.hidden = false; return; }
        if (f.size > 10 * 1024 * 1024) { err.textContent = 'images up to 10mb.'; err.hidden = false; return; }
        err.hidden = true; drop.firstChild.textContent = 'uploading';
        own.checked = true; srcBox.hidden = true;
        take(f).catch(function (x) { err.textContent = errText(x); err.hidden = false; drop.firstChild.textContent = 'add a photo'; });
      });
      /* link-preview finds the picture and hands back a public url; it is fetched and uploaded like a chosen file */
      pull.addEventListener('click', function () {
        var u = safeUrl(link.value.trim()); if (!u) { err.textContent = 'paste a full link.'; err.hidden = false; return; }
        err.hidden = true; pull.disabled = true; pull.textContent = 'pulling';
        var done = function () { pull.disabled = false; pull.textContent = 'add'; };
        var fail = function (x) {
          var m = String((x && x.message) || '');
          err.textContent = /^image_(bad_type|too_big|too_small)$/.test(m) ? errText(m) : "couldn't find an image there. upload one instead.";
          err.hidden = false; done();
        };
        fn('link-preview', { url: u }).then(function (r) {
          if (!r || r.error || !safeUrl(r.image_url)) { done(); err.textContent = (r && r.error) || "couldn't find an image there. upload one instead."; err.hidden = false; return; }
          return fetch(r.image_url).then(function (res) { if (!res.ok) throw new Error('fetch'); return res.blob(); }).then(sniff).then(take).then(function () {
            done();
            own.checked = false; srcBox.hidden = false;
            src.value = u;
            if (!buy.value) { buy.value = u; checkBuy(); }
            if (!title.value && r.title) title.value = r.title.slice(0, 140);
          });
        }).catch(fail);
      });
      kind.addEventListener('change', function () {
        var pin = kind.value === 'pinterest_embed';
        imgBox.hidden = pin; pinBox.hidden = !pin; postFoot.hidden = !pin && step2.hidden;
      });

      var pinUrl = h('input', { class: 'fl-in', type: 'url', placeholder: 'https://www.pinterest.com/pin/...' });
      link.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); pull.click(); } });
      link.addEventListener('paste', function () { setTimeout(function () { if (safeUrl(link.value.trim())) pull.click(); }, 0); });
      var preview = h('div', { class: 'fl-post-pv' });
      var srcBox = h('div', { hidden: true }, h('label', { class: 'fl-lbl', text: 'where it came from' }), src);
      own.addEventListener('change', function () { srcBox.hidden = own.checked; });
      var step1 = h('div', { class: 'fl-post-s1' }, drop, h('div', { class: 'fl-row fl-post-link' }, link, h('div', { style: 'flex:0 0 auto' }, pull)));
      var details = h('details', { class: 'fl-post-more' }, h('summary', { text: 'details' }),
        h('label', { class: 'fl-chk' }, own, h('span', { text: 'i took this photo' })), srcBox,
        h('div', { class: 'fl-row' }, h('div', null, h('label', { class: 'fl-lbl', text: 'brand' }), brand), h('div', null, h('label', { class: 'fl-lbl', text: 'category' }), cat)),
        (me.is_brand || me.is_admin) ? h('div', null, h('label', { class: 'fl-lbl', text: 'brand note' }), note) : null,
        h('label', { class: 'fl-lbl', text: 'channel' }), chan);
      var step2 = h('div', { class: 'fl-post-s2', hidden: true }, preview, buy, buyNote, title, h('p', { class: 'fl-post-k', text: 'add it to' }), chips, details);
      function step(n) { step1.hidden = n !== 1; step2.hidden = n !== 2; postFoot.hidden = n !== 2; if (n === 1) { drop.firstChild.textContent = 'add a photo'; } }
      var imgBox = h('div', null, step1, step2);
      var pinBox = h('div', { hidden: true }, h('label', { class: 'fl-lbl', text: 'pin url' }), pinUrl);

      var postFoot = h('div', { class: 'fl-post-foot', hidden: true }, submit,
        h('p', { class: 'fl-mono fl-post-say', text: 'post good stuff, get picked, get seen.' }),
        h('p', { class: 'fl-terms' }, 'checked automatically before it goes live. by posting you agree to the ', h('a', { href: '/pages/terms', target: '_blank', text: 'terms' }), '.'));
      var form = h('form', { class: 'fl-post', on: { submit: function (e) {
        e.preventDefault(); err.hidden = true;
        var isPin = kind.value === 'pinterest_embed';
        var payload = {
          kind: kind.value, image_path: isPin ? null : state.path, image_url: isPin || state.path ? null : state.url,
          embed_url: isPin ? pinUrl.value.trim() : null, source_url: isPin ? pinUrl.value.trim() : src.value.trim(),
          own_photo: !isPin && own.checked, title: title.value, brand_tag: brand.value, category: cat.value,
          brand_note: note.value, channel_id: chan.value || null, width: state.w, height: state.h, as_owner: asOwner.value || null
        };
        if (!isPin && !payload.image_path && !payload.image_url) { err.textContent = 'add an image.'; err.hidden = false; return; }
        if (!isPin && !/^https?:/.test(safeUrl(buy.value.trim()) || '')) { err.textContent = 'add the link to where you can buy it.'; err.hidden = false; buy.focus(); return; }
        if (!isPin && !payload.own_photo && !safeUrl(payload.source_url)) { details.open = true; srcBox.hidden = false; err.textContent = 'add where it came from, or tick "i took this photo".'; err.hidden = false; return; }
        submit.disabled = true; submit.textContent = 'posting';
        /* a member's post comes back pending: the screen edge function checks it while we wait (up to ~25s) and says
           approved, rejected, removed or still pending. an admin's post is approved already */
        var go = function () {
          rpc('create_block', { p: payload }).then(function (card) {
            w.close();
            afterPost(card, isPin ? null : safeUrl(buy.value.trim()));
            if (card.status !== 'pending') { screened(card, { status: card.status }); return; }
            toast('checking it. a few seconds.');
            fn('screen', { block_id: card.id }).then(function (r) { screened(card, r || {}); }, function () { screened(card, {}); });
          }, function (x) { submit.disabled = false; submit.textContent = 'post'; err.textContent = errText(x); err.hidden = false; });
        };
        /* an error or a timeout leaves it pending: it goes live when the screen gets to it. removed means it is gone */
        var screened = function (card, r) {
          var st = r.status;
          if (st === 'approved') toast('posted. it is live.');
          else if (st === 'rejected' || st === 'removed') toast("it didn't go up: " + (plainNote(r.note) || 'it did not pass the check') + '.');
          else toast('posted. it goes live as soon as it is checked.');
          if (st === 'approved' || st === 'rejected' || st === 'pending') card.status = st;
          if (st !== 'removed' && opts.onPosted) opts.onPosted(card);
        };
        if (!chan.value && chan.getAttribute('data-new') === '1') {
          rpc('create_channel', { p_title: 'my posts', p_description: null, p_visibility: 'public' }).then(function (ch) {
            /* the select now holds the new channel, so a retry after a failed post reuses it instead of making another */
            var o = chan.options[chan.selectedIndex] || chan.options[0];
            if (o) { o.value = ch.id; o.textContent = ch.title || 'my posts'; }
            chan.value = ch.id; chan.removeAttribute('data-new');
            payload.channel_id = ch.id; go();
          }, function (x) { submit.disabled = false; submit.textContent = 'post'; err.textContent = errText(x); err.hidden = false; });
        } else go();
      } } },
        me.is_admin ? h('div', { class: 'fl-row', style: 'margin-bottom:10px' }, asOwner, kind) : null,
        imgBox, pinBox,
        err,
        postFoot);

      rpc('my_channels').then(function (chs) {
        var pub = chs.filter(function (c) { return c.visibility === 'public'; });
        if (!pub.length) { chan.appendChild(h('option', { value: '', text: 'my posts (new channel)' })); chan.setAttribute('data-new', '1'); }
        /* public channels first, so a post lands on the feed unless you pick a private one on purpose */
        chs.slice().sort(function (x, y) { return (x.visibility === 'private') - (y.visibility === 'private'); }).forEach(function (c) {
          var o = h('option', { value: c.id, text: c.title + (c.visibility === 'private' ? ' (private)' : '') });
          if (opts.channelId === c.id) o.selected = true;
          chan.appendChild(o);
        });
        paintChips();
      });
      /* the channel as a row of chips (the select stays the source of truth, under details) */
      function paintChips() {
        chips.textContent = '';
        Array.prototype.forEach.call(chan.options, function (o, i) {
          chips.appendChild(h('button', { class: 'fl-post-chip', type: 'button', role: 'radio', 'aria-checked': String(chan.selectedIndex === i), text: o.textContent,
            on: { click: function () { chan.selectedIndex = i; paintChips(); } } }));
        });
      }
      chan.addEventListener('change', paintChips);
      if (me.is_admin) {
        MIEN.sb.from('profiles').select('id, handle').eq('is_house', true).then(function (r) {
          (r.data || []).forEach(function (p) { asOwner.appendChild(h('option', { value: p.id, text: 'post as @' + p.handle })); });
        });
        asOwner.addEventListener('change', function () {
          if (!asOwner.value) { rpc('my_channels').then(refillChans); return; }
          MIEN.sb.from('fly_channels').select('id, title, visibility').eq('owner_id', asOwner.value).order('updated_at', { ascending: false })
            .then(function (r) { refillChans(r.data || []); });
        });
      }
      function refillChans(chs) {
        chan.textContent = ''; chan.removeAttribute('data-new');
        if (!chs.length) chan.appendChild(h('option', { value: '', text: 'no channel' }));
        chs.forEach(function (c) { chan.appendChild(h('option', { value: c.id, text: c.title })); });
        paintChips();
      }
      var w = win('post', form, { onClose: opts.onClose });
    });
  }

  /* after a post: its buy link becomes a confirmed buy tag; with no link, the matches are offered once the describer has
     looked at it (it runs every ~20s), one tap to attach. then, once, a nudge to add your instagram */
  function afterPost(card, buyUrl) {
    if (!card || !card.id) return;
    if (buyUrl) rpc('fly_tag_item', { p_block: card.id, p_item_idx: null, p_url: buyUrl }).catch(function () {});
    else offerMatches(card);
    if (me && !me.instagram && !ls('fly_ig_asked')) {
      ls('fly_ig_asked', '1');
      setTimeout(function () { toast('add your instagram and it shows on every post you make.', [{ label: 'add it', href: '/pages/account?tab=settings' }]); }, 4000);
    }
  }
  function matchUrl(c) {
    if (c.kind === 'product' && c.handle) return location.origin + urls.product(c.handle);
    return safeUrl(c.buy || c.source_url);
  }
  function offerMatches(card) {
    var tries = 0;
    (function poll() {
      rpc('pieces_like', { p_block: card.id, p_limit: 3 }).then(function (r) {
        var list = ((r && r.items) || r || []).filter(function (c) { return c && matchUrl(c); }).slice(0, 3);
        if (!list.length) { if (++tries < 8) setTimeout(poll, 6000); return; }
        var body = h('div', { class: 'fl-post-match' }, h('p', { class: 'fl-desc', text: 'we found pieces like this. attach one?' }),
          h('p', { class: 'fl-mono', text: 'an attached piece makes your post shoppable.' }));
        var row = h('div', { class: 'fl-post-mrow' });
        list.forEach(function (c) {
          var btn = h('button', { class: 'btn-primary', type: 'button', text: 'attach', on: { click: function () {
            btn.disabled = true;
            rpc('fly_tag_item', { p_block: card.id, p_item_idx: null, p_url: matchUrl(c), p_label: c.title || null }).then(function () {
              mw.close(); toast('attached. your post is shoppable now.');
            }, function (e) { btn.disabled = false; toast(errText(e)); });
          } } });
          row.appendChild(h('div', { class: 'fl-post-m' }, h('span', { class: 'fl-pst-im' }, pic(c.img, 'fl-tile-img', c.title || '', c.w, c.h, '160px')),
            h('span', { class: 'fl-mono', text: [c.brand, c.price != null ? money(c.price, c.currency) : null].filter(Boolean).join(' \u00b7 ') }), btn));
        });
        body.appendChild(row);
        var mw = win('shop this', body);
      }, function () { if (++tries < 8) setTimeout(poll, 6000); });
    })();
  }

  /* ------------------------------------------------------------------ views */
  var views = {};

  /* a small tile for module rows: opens the closeup, and swiping there walks this row */
  function mini(c, ctx, list, note) {
    var isProd = c.kind === 'product' || c.kind === 'linkout_product';
    var a = h('a', { class: 'fl-mini-t fl-plain', href: c.kind === 'product' ? urls.product(c.handle) : urls.block(c.id), 'data-fly-id': c.id, 'data-fly-ctx': ctx },
      h('span', { class: 'fl-mini-im' }, pic(c.img, 'fl-mini-img' + (isProd ? ' is-prod' : ''), c.title || c.brand || '', c.w, c.h, '(max-width: 600px) 40vw, 220px'),
        isProd && c.price != null ? h('span', { class: 'fl-tile-price', text: money(c.price, c.currency) }) : null),
      note ? h('span', { class: 'fl-mono fl-mini-n', text: note }) : (c.brand ? h('span', { class: 'fl-mono fl-mini-n', text: c.brand }) : null));
    a.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault(); Closeup.open(c, ctx, null, function () { return list; });
    });
    Track.watch(a);
    return a;
  }
  function hrow(cards, ctx, cls) {
    return h('div', { class: 'fl-hrow' + (cls ? ' ' + cls : '') }, cards.map(function (c) { return mini(c, ctx, cards); }));
  }
  /* the modules that break the scroll, one every twelve tiles: channels three times out of four (a featured one, one like
     what you save, one you follow), and every fourth one of the others in turn. each falls back when it has nothing */
  var CHAN_MODS = ['chan_featured', 'chan_related', 'chan_followed'], OTHER_MODS = ['because', 'brand', 'connecting', 'fit'];
  function modKinds(i) {
    if (i % 4 !== 3) return [CHAN_MODS[i % 4], 'chan_featured'];
    var o = OTHER_MODS[Math.floor(i / 4) % OTHER_MODS.length];
    return [o].concat(OTHER_MODS.filter(function (k) { return k !== o; }), ['chan_featured']);
  }
  var CHAN_LABEL = { chan_featured: 'featured channel', chan_related: 'a channel like what you save', chan_followed: 'from a channel you follow' };
  function modEl(m) {
    if (!m || !m.kind) return null;
    var items = m.items || [];
    if (m.kind === 'channel' && m.channel) {
      var cc = m.channel;
      return h('section', { class: 'fl-mod' }, h('p', { class: 'fl-mod-k', text: CHAN_LABEL[m.src] || 'channel' }),
        h('a', { class: 'fl-plain fl-chmod', href: urls.channel(cc.slug) }, h('span', { class: 'fl-mod-t', text: cc.title }),
          h('span', { class: 'fl-chmod-row' }, items.slice(0, 6).map(function (c) {
            return h('span', { class: 'fl-chmod-im' }, pic(c.img, 'fl-mini-img' + (c.kind !== 'image' ? ' is-prod' : ''), '', c.w, c.h, '(max-width: 600px) 30vw, 200px'));
          }))),
        h('p', { class: 'fl-mono' }, cc.owner && cc.owner.handle ? ['by ', userLink(cc.owner.handle), ' · '] : null, String(cc.count || items.length) + ' blocks'));
    }
    if (m.kind === 'spotlight' && m.channel) {
      var ch = m.channel;
      return h('section', { class: 'fl-mod' }, h('p', { class: 'fl-mod-k', text: 'channel spotlight' }),
        h('a', { class: 'fl-mod-t fl-plain', href: urls.channel(ch.slug), text: ch.title }),
        h('p', { class: 'fl-mono' }, ch.owner && ch.owner.handle ? ['by ', userLink(ch.owner.handle), ' · '] : null, String(ch.count || items.length) + ' blocks'),
        hrow(items, 'module', 'is-four'));
    }
    if (m.kind === 'because') {
      var verb = { saved: 'saved', wanted: 'wanted', picked: 'picked' }[m.verb] || 'saved';
      return h('section', { class: 'fl-mod' }, h('p', { class: 'fl-mod-k' }, 'because you ' + verb + ' ', h('a', { href: urls.block(m.seed.id), text: '“' + m.seed.title + '”' })),
        hrow(items, 'module'));
    }
    if (m.kind === 'brand') {
      return h('section', { class: 'fl-mod' }, h('p', { class: 'fl-mod-k' }, 'new from ', h('a', { href: urls.brand(m.brand), text: m.brand })),
        hrow(items, 'module'));
    }
    if (m.kind === 'connecting') {
      return h('section', { class: 'fl-mod' }, h('p', { class: 'fl-mod-k', text: 'people are saving this' }),
        h('div', { class: 'fl-hrow is-three' }, items.map(function (c) { return mini(c, 'module', items, 'saved ' + (c.connected || 1) + (c.connected === 1 ? ' time' : ' times')); })));
    }
    if (m.kind === 'fit' && m.block) {
      var fb = m.block;
      var im = h('span', { class: 'fl-imgwrap' }, pic(fb.img, 'fl-modfit-img', fb.title || '', fb.w, fb.h, '(max-width: 600px) 100vw, 40vw'));
      var dots = h('span', { class: 'fl-fit-dots' });
      im.appendChild(dots);
      var list = h('ol', { class: 'fl-fit-rows' });
      var spots = dotSpots(m.items || []);
      (m.items || []).forEach(function (it, i) {
        if (spots[i]) dots.appendChild(h('span', { class: 'fl-dot-n', style: 'left:' + spots[i].x + '%;top:' + spots[i].y + '%', text: String(i + 1) }));
        var c = it.match;
        list.appendChild(h('li', { class: 'fl-fit-row' }, h('span', { class: 'fl-fit-n', text: String(i + 1) }),
          h('div', { class: 'fl-fit-main' }, h('p', { class: 'fl-fit-l', text: it.label }), c ? matchRow(fb, [c], 'in_this_fit') : null)));
      });
      var open = h('a', { class: 'fl-plain fl-modfit-im', href: urls.block(fb.id) }, im);
      open.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; e.preventDefault(); Closeup.open(fb, 'module'); });
      return h('section', { class: 'fl-mod' }, h('p', { class: 'fl-mod-k', text: 'in this fit' }), h('div', { class: 'fl-modfit' }, open, list));
    }
    return null;
  }
  /* the brands mien lists, rendered into the feed section as a <template> by fly-app.liquid (snippets/mien-brand-handles) */
  var brandsCache = null;
  function brandList() {
    if (brandsCache) return brandsCache.slice();
    brandsCache = [];
    var t = document.getElementById('fl-brands');
    if (t && t.content) Array.prototype.forEach.call(t.content.querySelectorAll('[data-b]'), function (a) {
      var img = a.querySelector('img');
      brandsCache.push({ tag: a.getAttribute('data-b'), name: a.getAttribute('data-n'), logo: img ? img.getAttribute('src') : null });
    });
    return brandsCache.slice();
  }
  function greeting() {
    var hr = new Date().getHours();
    return (hr < 5 ? 'up late' : hr < 12 ? 'morning' : hr < 17 ? 'afternoon' : hr < 22 ? 'evening' : 'up late');
  }

  views.feed = function (root) {
    var fc = qp('fcat'), cq = qp('cat'), fm = qp('feed');
    /* no category filter on the feed (2026-10-26): mien covers too wide a range for a fixed list of words, so the top
       of the feed is search and the tabs. old ?cat= / ?fcat= links just open the feed */
    var params = { cat: null, q: qp('q') || '',
      mode: fm === 'following' || fm === 'latest' ? fm : 'for_you' };
    var inviteCode = qp('invite') || ls('fly_invite');
    var invited = h('p', { class: 'fl-invited fl-mono', hidden: true });
    if (inviteCode) rpc('get_invite', { p_code: inviteCode }).then(function (r) {
      if (r && r.valid && r.inviter && !me) { add(invited, ['shared by ', userLink(r.inviter), '. scroll first, then make it yours.']); invited.hidden = false; }
    });

    /* the top of the feed (2026-10-26): the tabs (for you, latest, following), then the board. search is the box in the
       header pill, on every page; on the feed it searches in place (fly:search) and the results page gets a line saying
       what was searched, two rows of filter chips, channels, then the same board */
    document.body.classList.add('fl-home');
    var EXAMPLES = ['search mien', 'cool bracelets', 'worn in denim', 'football shirts', 'objects for a desk'];
    var heroIn = document.querySelector('.mhd-search-in') || h('input');
    heroIn.value = params.q;
    /* the pill's placeholder cycles through examples while it is empty and nobody is typing */
    var exI = 0;
    setInterval(function () {
      if (document.activeElement === heroIn || heroIn.value || !root.isConnected) return;
      exI = (exI + 1) % EXAMPLES.length; heroIn.setAttribute('placeholder', EXAMPLES[exI]);
    }, 2600);
    var sKind = 'all', sPrice = '', sCat = '';
    function paintChips() {
      Array.prototype.forEach.call(resBar.querySelectorAll('.fl-chips'), function (row) {
        var cur = row._get();
        Array.prototype.forEach.call(row.children, function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === cur)); });
      });
    }
    function chipRow(list, get, set, label) {
      var row = h('div', { class: 'fl-chips', role: 'group', 'aria-label': label });
      row._get = get;
      list.forEach(function (x) {
        row.appendChild(h('button', { class: 'fl-chip', type: 'button', 'aria-pressed': String(get() === x[0]), 'data-v': x[0], text: x[1], on: { click: function () {
          set(x[0]); Array.prototype.forEach.call(row.children, function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === x[0])); });
          restart(); jumpTo(0);
        } } }));
      });
      return row;
    }
    var resCount = h('p', { class: 'fl-mono fl-res-n' });
    var resQ = h('h1', { class: 'fl-res-q' });
    var resBar = h('div', { class: 'fl-res-bar', hidden: !params.q },
      h('div', { class: 'fl-res-top' }, resQ, h('button', { class: 'fl-res-x', type: 'button', text: 'back to the feed', on: { click: function () { heroIn.value = ''; search(''); } } })),
      chipRow([['all', 'all'], ['native', 'buy on mien'], ['brand', 'buy from brand'], ['images', 'images'], ['channels', 'channels']],
        function () { return sKind; }, function (v) { sKind = v; }, 'what'),
      chipRow([['', 'any price'], ['0-100', 'under $100'], ['100-300', '$100–300'], ['300-', '$300+']],
        function () { return sPrice; }, function (v) { sPrice = v; }, 'price'),
      resCount);
    function filters() {
      var f = {}, pr = sPrice.split('-');
      if (sKind !== 'all') f.kind = sKind;
      if (sPrice) { if (pr[0]) f.min = pr[0]; if (pr[1]) f.max = pr[1]; }
      if (sCat) f.cat = sCat;
      return f;
    }
    function search(q) {
      q = String(q || '').trim().replace(/\s+/g, ' ');
      if (q === params.q) { if (q) { restart(); jumpTo(0); } return; }
      params.q = q;
      history.pushState({ flyQ: q }, '', q ? '/?q=' + encodeURIComponent(q) : '/');
      sync(); restart(); jumpTo(0);
    }
    /* back and forward between the feed and a search */
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.flyCu) return;
      var q = qp('q') || '';
      if (q !== params.q) { params.q = q; heroIn.value = q; sync(); restart(); }
    });

    /* the tabs: for you, latest, following */
    var tabBtns = {};
    var tabs = h('div', { class: 'fl-ftabs', role: 'tablist', 'aria-label': 'feed' }, [['for_you', 'for you'], ['latest', 'latest'], ['following', 'following']].map(function (t) {
      return (tabBtns[t[0]] = h('button', { class: 'fl-ftab', type: 'button', role: 'tab', text: t[1], on: { click: function () {
        params.mode = t[0]; params.q = ''; sync(); restart(); jumpTo(0);
      } } }));
    }));
    /* the tabs are not shown (2026-10-26): for you, latest and following are in the side menu. latest and following
       get a quiet title so you know where you are */
    var bar = h('p', { class: 'fl-mode' });
    var newRow = h('section', { class: 'fl-new', hidden: true });
    var chanHits = h('div', { class: 'fl-chans fl-hits', hidden: true });
    /* a tap on a channel in the results counts as a click on the search, sent so it survives the page change */
    chanHits.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.fl-chan-link');
      if (!a || !params.q || !st || !st.sid) return;
      token().then(function (t) {
        try {
          fetch(MIEN.url + '/rest/v1/rpc/fly_search_click', { method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'application/json', apikey: MIEN.key, Authorization: 'Bearer ' + (t || MIEN.key) },
            body: JSON.stringify({ p_search: st.sid, p_session: Track.session() }) });
        } catch (x) {}
      });
    });
    var stream = h('div', { class: 'fl-stream' });
    var wrap = h('div');
    root.appendChild(h('h1', { class: 'fl-sr', text: 'mien' }));
    root.appendChild(resBar);
    root.appendChild(invited);
    root.appendChild(bar);
    root.appendChild(newRow);
    root.appendChild(chanHits);
    root.appendChild(wrap);
    wrap.appendChild(stream);

    /* new since your last visit: a count and a row, for anyone coming back after an hour or more */
    var lastSeen = Number(ls('fly_last_seen') || 0);
    if (!lastSeen) ls('fly_last_seen', String(Date.now()));
    if (lastSeen && Date.now() - lastSeen > 3600e3 && !params.q) {
      rpc('get_new_since', { p_since: new Date(lastSeen).toISOString(), p_session: Track.session(), p_taste: tasteParam() }).then(function (r) {
        if (!r || !r.count || !r.items || !r.items.length) return;
        newRow.appendChild(h('p', { class: 'fl-mod-k', text: (r.count > 99 ? '99+' : r.count) + ' new since your last visit' }));
        newRow.appendChild(hrow(r.items, 'new'));
        newRow.hidden = false;
      }, function () {});
    }

    function sync() {
      Object.keys(tabBtns).forEach(function (k) { tabBtns[k].setAttribute('aria-selected', String(params.mode === k && !params.q)); tabBtns[k].classList.toggle('is-on', params.mode === k && !params.q); });
      bar.textContent = params.mode === 'for_you' ? '' : params.mode;
      var u = new URL(location.href);
      ['fcat', 'fcol', 'cat', 'q', 'feed'].forEach(function (k) { u.searchParams.delete(k); });
      if (params.mode !== 'for_you') u.searchParams.set('feed', params.mode);
      if (params.cat) u.searchParams.set('cat', params.cat);
      if (params.q) u.searchParams.set('q', params.q);
      history.replaceState(history.state, '', u.pathname + u.search);
      /* a search page shows the search; the feed's own header comes back with the feed */
      var on = !!params.q;
      resBar.hidden = !on; resQ.textContent = on ? '\u201c' + params.q + '\u201d' : ''; bar.hidden = on; newRow.hidden = on || !newRow.children.length;
      invited.hidden = on || !invited.textContent;
      if (heroIn.value.trim() !== params.q) heroIn.value = params.q;
    }
    sync();
    /* the header pill's search box drives this feed's search without a reload */
    document.addEventListener('fly:search', function (e) { heroIn.value = e.detail || ''; search(e.detail || ''); });
    /* onboarding finished: the feed is yours now */
    document.addEventListener('fly:taste', function () { params.mode = 'for_you'; params.q = ''; heroIn.value = ''; sync(); restart(); jumpTo(0); });

    /* state: what has been shown (so the server never repeats it this visit), the stream's parts (stretches of
       tiles and the modules between them) for restoring on back, and the order of tiles for swiping */
    /* one continuous board (2026-10-26): with the module rows off, stretches only left ragged column ends (white holes)
       between them, so the whole feed is a single masonry */
    var SEG = 1e9;
    var st, seg, loader;
    function nav() { return st.list; }
    function newSeg(cards) {
      var el = h('div', { class: 'fl-seg' }); stream.appendChild(el);
      st.segIdx++; st.segN = 0;
      /* one calm board (2026-10-26): every piece at its own shape, no hero, wide or tall crops */
      seg = Masonry(el, { ctx: params.q ? 'search' : 'feed', start: st.served.length, nav: nav,
        onOpen: params.q ? function () { if (st.sid) rpc('fly_search_click', { p_search: st.sid, p_session: Track.session() }).catch(function () {}); } : null });
      st.blocks.push({ t: 'seg', cards: cards ? cards.slice() : [] });
      if (cards) { seg.add(cards); st.segN = cards.length; cards.forEach(function (c) { if (!isMix(c)) st.list.push(c); }); }
    }
    function addCards(cards) {
      cards.forEach(function (c) { if (isMix(c)) return; st.served.push({ id: c.id, k: c.kind === 'product' ? 'p' : 'i' }); st.list.push(c); });
      seg.add(cards);
      var last = st.blocks[st.blocks.length - 1];
      last.cards = last.cards.concat(cards);
      st.segN += cards.length;
    }
    function modSlot(gen) {
      var slot = h('div', { class: 'fl-modslot' });
      stream.appendChild(slot);
      var rec = { t: 'mod', data: null };
      st.blocks.push(rec);
      var kinds = modKinds(st.modIdx++), tries = 0;
      (function next() {
        if (tries >= kinds.length) { slot.remove(); return; }
        var kind = kinds[tries++];
        rpc('feed_module', { p_kind: kind, p_session: Track.session(), p_taste: tasteParam(), p_skip: st.modSkip, p_seed: Track.seed() }).then(function (m) {
          if (st !== gen) return;
          var el = m ? modEl(m) : null;
          if (!el) { next(); return; }
          st.modSkip.push(String(m.key));
          rec.data = m;
          slot.appendChild(el);
        }, function () { if (st === gen) next(); });
      })();
    }
    /* the discovery mix: on the plain feed (no search, not following) a labelled channel or brand tile drops in every
       ten to sixteen pieces, at a random spot; everything else on the board is a piece you can buy */
    function isMix(c) { return c.kind === 'x_channel' || c.kind === 'x_brand' || c.kind === 'x_spot' || c.kind === 'x_picked'; }
    /* 2026-10-27: a "posters to follow" tile every ~40 pieces, and one "picked by mien" tile early on */
    var mixPool = { ch: null, br: null, gap: 4, n: 0, spot: null, spotSkip: [], picked: null };
    function nextSpot() {
      rpc('get_spotlight', { p_skip: mixPool.spotSkip }).then(function (r) {
        if (r && r.owner && r.items && r.items.length >= 4) { mixPool.spot = r; mixPool.spotSkip.push(r.owner.id); }
      }, function () {});
    }
    function loadMix() {
      if (mixPool.ch) return;
      mixPool.ch = [];
      nextSpot();
      rpc('get_picked', { p_limit: 12 }).then(function (r) { mixPool.picked = (r || []).length ? r : null; }, function () {});
      mixPool.br = shuffle(brandList());
      rpc('browse_channels', { p_offset: 0, p_limit: 48 }).then(function (chs) {
        mixPool.ch = shuffle((chs || []).filter(function (c) { return c.count >= 3 && c.preview && c.preview.length >= 3; }));
      }, function () {});
    }
    function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
    function nextMix() {
      var useCh = mixPool.ch.length && (!mixPool.br.length || Math.random() < 0.55);
      if (useCh) { var ch = mixPool.ch.shift(); return { kind: 'x_channel', id: 'ch:' + ch.id, slug: ch.slug, title: ch.title, count: ch.count, preview: ch.preview.slice(0, 3) }; }
      if (mixPool.br.length) { var b = mixPool.br.shift(); return { kind: 'x_brand', id: 'br:' + b.tag, tag: b.tag, name: b.name, logo: b.logo }; }
      return null;
    }
    function sprinkle(cards) {
      /* latest stays strictly newest first: no picked or poster tiles mixed in */
      if (params.q || params.cat || params.mode === 'following' || params.mode === 'latest' || !mixPool.ch) return cards;
      var out = [];
      cards.forEach(function (c) {
        out.push(c);
        mixPool.n++;
        if (mixPool.picked && mixPool.n >= 10) { out.push({ kind: 'x_picked', id: 'picked', items: mixPool.picked }); mixPool.picked = false; }
        if (mixPool.spot && mixPool.n % 40 === 20) {
          var sp = mixPool.spot; mixPool.spot = null;
          out.push({ kind: 'x_spot', id: 'spot:' + sp.owner.id, handle: sp.owner.handle, items: sp.items });
          nextSpot();
        }
        if (--mixPool.gap > 0) return;
        mixPool.gap = 10 + Math.floor(Math.random() * 7);
        var m = nextMix();
        if (m) out.push(m);
      });
      return out;
    }
    /* cards go into stretches of twelve; each full stretch is followed by a module */
    function pushCards(cards, gen) {
      cards = sprinkle(cards);
      /* the full-width module rows are off (2026-10-26): they broke the board into pieces that read as clutter.
         channels come in as tiles instead (sprinkle) */
      var i = 0, mods = false;
      while (i < cards.length) {
        if (st.segN >= SEG) { if (mods) modSlot(gen); newSeg(); }
        var take = cards.slice(i, i + (SEG - st.segN));
        addCards(take); i += take.length;
      }
    }
    function exclude() {
      /* products may come back after 48 more pieces; everything else never repeats in a visit */
      var n = st.served.length;
      return st.served.filter(function (s, i) { return s.k !== 'p' || n - i < 48; }).map(function (s) { return s.id; }).slice(-1500);
    }
    /* following, with nothing to show: the channels worth following, each with its own follow button, right here.
       a follow (signed out: join first) reloads the tab with what that channel has */
    function followPicker(text) {
      var box = h('section', { class: 'fl-follow' }, h('p', { class: 'fl-follow-t', text: text }));
      var grid = h('div', { class: 'fl-chans' });
      box.appendChild(grid);
      rpc('browse_channels', { p_offset: 0, p_limit: 24 }).then(function (chs) {
        (chs || []).filter(function (c) { return c.count >= 3; }).slice(0, 12).forEach(function (c) {
          var card = chanCard(c);
          var on = false;
          var b = h('button', { class: 'fl-btn fl-follow-b', type: 'button', text: 'follow', on: { click: function () {
            requireAuth(function () {
              on = !on;
              rpc('follow_channel', { p_channel: c.id, p_on: on }).then(function () {
                b.textContent = on ? 'following' : 'follow'; b.classList.toggle('fl-solid', on); box.classList.add('is-dirty');
              }, function (e) { on = !on; toast(errText(e)); });
            });
          } } });
          card.appendChild(b);
          grid.appendChild(card);
        });
      }, function () {});
      box.appendChild(h('div', { class: 'fl-btns' }, h('button', { class: 'btn-primary', type: 'button', text: 'show what they posted', on: { click: function () { restart(); jumpTo(0); } } }),
        h('a', { class: 'btn-secondary', href: '/pages/channels', text: 'all channels' })));
      return box;
    }
    function emptyLine(text, btnText, run, href) {
      return h('div', { class: 'empty-line' }, h('p', { text: text }),
        href ? h('a', { class: 'btn-primary', href: href, text: btnText }) : h('button', { class: 'btn-primary', type: 'button', text: btnText, on: { click: run } }));
    }
    /* st is replaced on every restart, so it doubles as the generation: a response for an older
       stream (a tab tapped or a search sent while a page was loading) is dropped */
    function loadPage() {
      var gen = st;
      if (params.q) {
        return fn('search', { q: params.q, filters: filters(), offset: st.offset, limit: 40, session: Track.session() }).catch(function () { return null; }).then(function (r) {
          if (st !== gen) return false;
          clearSkel();
          if (!r || r.error) {
            if (!st.served.length) stream.appendChild(emptyLine('search did not answer. try again.', 'try again', function () { restart(); }));
            return false;
          }
          var chans = r.channels || [], items = r.items || [];
          if (st.offset === 0) {
            st.sid = r.search_id || null;
            var nch = chans.length + (chans.length === 1 ? ' channel' : ' channels');
            resCount.textContent = sKind === 'channels' ? nch : (r.total || 0) + (r.total === 1 ? ' result' : ' results') + (chans.length ? ' and ' + nch : '');
            if (chans.length) {
              chanHits.className = sKind === 'channels' ? 'fl-chans fl-hits' : 'fl-feat fl-hits';
              chans.forEach(function (c) { chanHits.appendChild(chanCard(c)); }); chanHits.hidden = false;
            }
          }
          st.offset += items.length; pushCards(items, gen);
          if (!st.served.length && !chans.length) {
            /* with filters on, the filters are what to change */
            if (Object.keys(filters()).length) stream.appendChild(emptyLine('nothing for \u201c' + params.q + '\u201d with these filters.', 'clear the filters', function () {
              sKind = 'all'; sPrice = ''; sCat = ''; paintChips(); restart();
            }));
            else stream.appendChild(emptyLine('nothing for \u201c' + params.q + '\u201d yet.', 'see everything', function () { heroIn.value = ''; search(''); }));
            return false;
          }
          return !!r.more && items.length > 0;
        });
      }
      if (params.mode === 'following') {
        if (!me) {
          clearSkel();
          stream.appendChild(followPicker('follow channels and their newest finds land here.'));
          return Promise.resolve(false);
        }
        return rpc('get_following', { p_exclude: exclude(), p_limit: 30 }).then(function (r) {
          if (st !== gen) return false;
          clearSkel();
          var items = (r && r.items) || [];
          pushCards(items, gen);
          if (!st.served.length) {
            stream.appendChild(followPicker(r && r.following ? 'nothing new in the channels you follow yet. follow a few more:' : 'you follow no channels yet. pick a few and their newest finds land here.'));
            return false;
          }
          return items.length >= 30;
        });
      }
      var call = params.mode === 'latest'
        ? rpc('get_latest', { p_exclude: exclude(), p_limit: 30, p_category: params.cat })
        : rpc('get_feed_v2', { p_exclude: exclude(), p_limit: 30, p_category: params.cat, p_session: Track.session(), p_taste: tasteParam(), p_seed: Track.seed(), p_mode: 'for_you' });
      /* if the ranked feed ever errors, fall back to the plain one: the homepage must never be empty */
      return call.catch(function () {
          return rpc('get_feed', { p_cursor: st.fallback || {}, p_limit: 30, p_category: params.cat }).then(function (r) {
            if (st !== gen) return { items: [] };
            st.fallback = r.cursor; return { items: r.items, more: !r.done };
          });
        }).then(function (r) {
        if (st !== gen) return false;
        var items = r.items || [];
        if (!items.length && st.served.length && !st.recycled) {
          /* seen everything: start again, keeping only the last stretch out, so the feed never ends */
          st.recycled = true; st.served = st.served.slice(-120);
          return true;
        }
        st.recycled = false;
        clearSkel();
        if (params.mode === 'latest') items.forEach(function (c) { c._when = true; });
        pushCards(items, gen);
        st.page++;
        if (!st.served.length) {
          /* an empty category is an invitation, not a dead end */
          stream.appendChild(params.cat ? emptyLine('nothing in ' + params.cat + ' yet.', 'see everything', function () { params.cat = null; sync(); restart(); })
            : emptyLine('nothing here yet.', '+ post', function () { addWin(); }));
          return false;
        }
        return items.length > 0;
      });
    }
    function restart(restore) {
      if (loader) loader.stop();
      loadMix(); mixPool.gap = 6; mixPool.n = 0;
      stream.textContent = ''; chanHits.hidden = true; chanHits.textContent = ''; resCount.textContent = '';
      st = { served: [], blocks: [], list: [], page: 0, offset: 0, recycled: false, segIdx: 0, segN: 0, modIdx: 0, modSkip: [] };
      if (restore) {
        st.served = restore.served || []; st.page = restore.page || 0; st.offset = restore.offset || 0;
        if (restore.search) {
          sKind = restore.search.kind || 'all'; sPrice = restore.search.price || ''; sCat = restore.search.cat || ''; paintChips();
          st.sid = restore.search.sid || null; resCount.textContent = restore.search.count || '';
        }
        st.modIdx = restore.modIdx || 0; st.modSkip = restore.modSkip || [];
        seg = null;
        (restore.blocks || []).forEach(function (b) {
          if (b.t === 'seg') newSeg(b.cards);
          else if (b.t === 'mod') { var el = modEl(b.data); if (el) { stream.appendChild(el); st.blocks.push(b); } }
        });
        if (!seg) newSeg();
      } else { newSeg(); skeleton(); }
      loader = moreLoader(wrap, function () { return loadPage().catch(function (e) { clearSkel(); throw e; }); }, 2200);
      /* the first page starts now, not on the observer's first frame (a tab opened in the background
         renders no frames, so it would sit on placeholders until it was looked at) */
      loader.kick();
    }
    /* placeholder blocks until the first page lands, the same shape as the grid, so nothing jumps */
    var skel = null;
    function skeleton() {
      var n = colsFor(stream.clientWidth || window.innerWidth), rs = [1.3, 1.0, 1.5, 1.2, 0.9, 1.4];
      skel = h('div', { class: 'fl-grid fl-skel', 'aria-hidden': 'true', style: 'grid-template-columns:repeat(' + n + ',minmax(0,1fr))' });
      for (var i = 0; i < n; i++) {
        var col = h('div', { class: 'fl-col' });
        for (var j = 0; j < 3; j++) col.appendChild(h('span', { class: 'fl-skel-t', style: 'aspect-ratio:1/' + rs[(i + j * 2) % rs.length] }));
        skel.appendChild(col);
      }
      stream.appendChild(skel);
    }
    function clearSkel() { if (skel) { skel.remove(); skel = null; } }

    /* coming back to the feed (back button from a product page or another site) puts you exactly
       where you were: same pieces, same order, same scroll. keyed by the feed's own tab, category and
       search, never by location: when the page hides, the url can be a closeup's address */
    function feedKey() { return 'fly_feed_' + params.mode + '|' + (params.cat || '') + '|' + (params.q || '') + (params.q ? '|' + JSON.stringify(filters()) : ''); }
    var navE = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var saved = null;
    try { saved = JSON.parse(ss(feedKey()) || 'null'); } catch (e) {}
    if (saved && navE.type === 'back_forward' && saved.blocks && saved.blocks.length) {
      restart(saved);
      /* older parts are dropped on save, so the scroll is put back against the tile that was
         at the top of the screen, and the raw y is only the fallback */
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        var a = saved.anchor, el = null, ts = stream.querySelectorAll('.fl-tile[data-fly-id]');
        if (a) for (var i = ts.length - 1; i >= 0; i--) { if (ts[i].getAttribute('data-fly-id') === a.id) { el = ts[i]; break; } }
        jumpTo(el ? el.getBoundingClientRect().top + window.scrollY - a.top : (saved.y || 0));
      }); });
    } else restart();
    window.addEventListener('pagehide', function () {
      ls('fly_last_seen', String(Date.now()));
      try {
        var anc = null, ts = stream.querySelectorAll('.fl-tile[data-fly-id]');
        /* never a product: products are the only tiles that come back in a visit, so their id is not unique */
        for (var i = 0; i < ts.length; i++) { var r = ts[i].getBoundingClientRect(); if (r.bottom > 0 && !ts[i].classList.contains('is-prod')) { anc = { id: ts[i].getAttribute('data-fly-id'), top: r.top }; break; } }
        ss(feedKey(), JSON.stringify({ y: window.scrollY, anchor: anc, served: st.served.slice(-600), page: st.page, offset: st.offset,
          modIdx: st.modIdx, modSkip: st.modSkip.slice(-40),
          search: params.q ? { kind: sKind, price: sPrice, cat: sCat, sid: st.sid || null, count: resCount.textContent } : null,
          blocks: st.blocks.slice(-10).map(function (b) { return b.t === 'seg' ? { t: 'seg', cards: b.cards.slice(-120) } : b; }) }));
      } catch (e) {}
    });
    fab();
    nudgeBar(inviteCode);
  };

  views.channel = function (root) {
    var slug = qp('c');
    if (!slug) { root.appendChild(h('p', { class: 'fl-empty', text: 'no channel here.' })); return; }
    rpc('get_channel', { p_slug: slug, p_offset: 0, p_limit: 120 }).then(function (ch) {
      if (!ch) { root.appendChild(h('p', { class: 'fl-empty' }, "that channel doesn't exist or isn't public. ", h('a', { href: '/', text: 'back to the feed' }))); return; }
      document.title = ch.title + ' · ' + document.title.split(' · ').pop();
      var follow = h('button', { class: 'fl-btn' + (ch.following ? ' is-on' : ''), type: 'button', text: ch.following ? 'following' : 'follow' });
      follow.addEventListener('click', function () {
        requireAuth(function () {
          var on = !follow.classList.contains('is-on');
          rpc('follow_channel', { p_channel: ch.id, p_on: on }).then(function () {
            follow.classList.toggle('is-on', on); follow.textContent = on ? 'following' : 'follow';
          });
        });
      });
      var share = h('button', { class: 'fl-btn', type: 'button', text: 'copy link', on: { click: function () {
        copy(location.origin + urls.channel(ch.slug)); share.textContent = 'copied';
      } } });
      var btns = h('div', { class: 'fl-btns' });
      if (ch.is_owner) {
        btns.appendChild(h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'add a block', on: { click: function () {
          /* a post the screen said no to keeps its toast (the reason) on screen instead of reloading it away */
          addWin({ channelId: ch.id, onPosted: function (card) { if (card.status !== 'rejected') location.reload(); } });
        } } }));
        btns.appendChild(h('button', { class: 'fl-btn', type: 'button', text: 'edit', on: { click: function () { editChannelWin(ch); } } }));
      } else btns.appendChild(follow);
      if (ch.visibility === 'public') btns.appendChild(share);
      root.appendChild(h('div', { class: 'fl-head' },
        h('span', { class: 'fl-q', text: ch.is_default ? 'saved' : 'channel' }),
        h('h1', { class: 'fl-h1', text: ch.title }),
        h('p', { class: 'fl-meta' }, 'by ', userLink(ch.owner && ch.owner.handle),
          ' · ' + ch.count + ' blocks · updated ' + ago(ch.updated_at) + (ch.visibility === 'private' ? ' · private' : '')),
        ch.description ? h('p', { class: 'fl-desc', text: ch.description }) : null,
        btns));
      /* curation meets commerce: anything buyable in this channel, in one quiet row up top */
      var pieces = ch.blocks.filter(function (x) { return x.kind === 'product' && x.status === 'approved'; });
      if (pieces.length) {
        root.appendChild(h('section', { class: 'fl-mod fl-shop' }, h('h2', { class: 'fl-sec', text: 'pieces in this channel' }),
          h('div', { class: 'fl-shoprow' }, pieces.slice(0, 12).map(function (x) {
            return h('a', { class: 'fl-piece', href: urls.product(x.handle), on: { click: function (e) {
              if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; e.preventDefault(); Closeup.open(x, 'channel'); } } },
              h('span', { class: 'fl-piece-im' }, pic(x.img, 'fl-piece-img', x.title || '', x.w, x.h, '160px')),
              h('span', { class: 'fl-piece-l' }, h('span', { text: x.brand || '' }), x.price != null ? h('span', { text: money(x.price, x.currency) }) : null));
          }))));
      }
      var gridEl = h('div', { class: 'fl-seg' }); root.appendChild(gridEl);
      var grid = Masonry(gridEl, ch.is_owner ? { ctx: 'channel', onRemove: function (c, el) {
        rpc('disconnect_block', { p_block: c.id, p_channel: ch.id }).then(function () { grid.remove(el); });
      } } : { ctx: 'channel' });
      grid.add(ch.blocks);
      if (!ch.blocks.length) root.appendChild(h('p', { class: 'fl-empty', text: ch.is_owner ? 'empty. hit save on anything and pick this channel.' : 'nothing saved here yet.' }));
      var off = ch.blocks.length;
      var tail = h('div'); root.appendChild(tail);
      function related() {
        rpc('suggest_channels', { p_session: Track.session(), p_taste: tasteParam(), p_exclude: [ch.id], p_limit: 10 }).then(function (chs) {
          if (!chs || !chs.length) return;
          tail.appendChild(h('section', { class: 'fl-mod' }, h('h2', { class: 'fl-sec', text: 'more channels' }), h('div', { class: 'fl-feat' }, chs.map(chanCard))));
        });
      }
      if (off >= 120) moreLoader(root, function () {
        return rpc('get_channel', { p_slug: slug, p_offset: off, p_limit: 120 }).then(function (more) {
          off += more.blocks.length; grid.add(more.blocks);
          if (!more.blocks.length) related();
          return more.blocks.length > 0;
        });
      });
      else related();
    });
  };

  /* "keep looking" under the bag (sections/mien-cart): one page of for-you pieces on the feed's own board */
  views.more = function (root) {
    root.appendChild(h('h2', { class: 'fl-more-h', text: 'keep looking' }));
    var g = h('div'); root.appendChild(g);
    var m = Masonry(g, { ctx: 'more', nav: function () { return m.cards(); } });
    rpc('get_feed_v2', { p_exclude: [], p_limit: 24, p_session: Track.session(), p_taste: tasteParam(), p_seed: Track.seed(), p_mode: 'for_you' })
      .then(function (r) { m.add((r && r.items) || []); }, function () { root.remove(); });
  };

  /* ------------------------------------------------------------------ shop your taste
     /pages/taste. drop 3 to 10 things you'd wear or own, get 24 pieces from the live feed with a line on why. uploads are
     shrunk here and sent in the request, never stored; pasted links go through link-preview. taste inputs are never
     published. signed out sees results; saving runs through the signup modal and then finishes. */
  var TASTE_MIN = 3, TASTE_MAX = 10, TASTE_MB = 15;
  function tasteKey() {
    var k = ls('fly_taste_sk');
    if (!k) { k = (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36)); ls('fly_taste_sk', k); }
    return k;
  }
  function shrinkPhoto(file) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var k = Math.min(1, 1024 / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas'); c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); x.drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        var d = c.toDataURL('image/jpeg', 0.85);
        res({ preview: d, data: d.split(',')[1], media: 'image/jpeg' });
      };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('this browser can\'t open that file. try a jpg or png.')); };
      img.src = url;
    });
  }
  /* the drop step, used by /pages/taste and by the last onboarding screen */
  function TasteDrop(root, opts) {
    var inputs = [];
    var msg = h('p', { class: 'fl-small fl-taste-msg', role: 'status' });
    var chips = h('div', { class: 'fl-taste-chips' });
    var count = h('span', { class: 'fl-taste-count' });
    var file = h('input', { type: 'file', accept: 'image/*', multiple: true, hidden: true, on: { change: function () { addFiles(file.files); file.value = ''; } } });
    var drop = h('button', { class: 'fl-taste-drop', type: 'button', on: { click: function () { file.click(); },
      dragover: function (e) { e.preventDefault(); drop.classList.add('is-over'); }, dragleave: function () { drop.classList.remove('is-over'); },
      drop: function (e) { e.preventDefault(); drop.classList.remove('is-over'); addFiles(e.dataTransfer.files); } } },
      h('b', { text: 'drop photos here' }), h('span', { text: 'or tap to choose. anything you\'d wear or own.' }));
    var link = h('input', { class: 'fl-in', type: 'url', inputmode: 'url', placeholder: 'or paste a link to a product', 'aria-label': 'paste a product link', on: {
      keydown: function (e) { if (e.key === 'Enter') { e.preventDefault(); addLink(); } }, paste: function () { setTimeout(addLink, 0); } } });
    var go = h('button', { class: 'btn-primary', type: 'button', text: 'build my edit', disabled: true, on: { click: run } });
    root.appendChild(h('div', { class: 'fl-taste-box' }, drop, file, link, msg, chips, h('div', { class: 'fl-btns' }, go, count)));
    function paint() {
      chips.textContent = '';
      inputs.forEach(function (it) {
        chips.appendChild(h('span', { class: 'fl-taste-chip' + (it.busy ? ' is-busy' : '') },
          it.preview ? h('img', { src: it.preview, alt: '' }) : h('i', { text: '...' }),
          h('button', { type: 'button', 'aria-label': 'remove', text: '×', on: { click: function () { inputs.splice(inputs.indexOf(it), 1); paint(); } } })));
      });
      var ready = inputs.filter(function (i) { return !i.busy; }).length;
      go.disabled = ready < TASTE_MIN || inputs.length !== ready;
      count.textContent = ready < TASTE_MIN ? (TASTE_MIN - ready) + ' more to go' : ready + ' of ' + TASTE_MAX;
    }
    function room() { if (inputs.length < TASTE_MAX) return true; msg.textContent = '10 is the most. remove one to add another.'; return false; }
    function addFiles(list) {
      msg.textContent = '';
      Array.prototype.forEach.call(list, function (f) {
        if (!room()) return;
        if (f.size > TASTE_MB * 1048576) { msg.textContent = f.name + ' is over 15MB.'; return; }
        var it = { busy: true }; inputs.push(it); paint();
        shrinkPhoto(f).then(function (r) { it.busy = false; it.preview = r.preview; it.data = r.data; it.media = r.media; paint(); },
          function (e) { inputs.splice(inputs.indexOf(it), 1); msg.textContent = e.message; paint(); });
      });
    }
    function addLink() {
      var url = link.value.trim();
      if (!url) return;
      if (!room()) return;
      if (!/^https?:\/\//i.test(url)) url = 'https://' + url;
      link.value = ''; msg.textContent = '';
      var it = { busy: true, page_url: url }; inputs.push(it); paint();
      if (/\.(jpe?g|png|webp)(\?|$)/i.test(url)) { it.busy = false; it.url = url; it.preview = url; paint(); return; }
      fn('link-preview?forceFunctionRegion=us-east-1', { url: url }).then(function (r) {
        if (!r || !r.image_url) throw new Error((r && r.error === 'invalid url') ? 'that link can\'t be used.' : 'we couldn\'t find a picture on that page. try uploading one.');
        it.busy = false; it.url = r.image_url; it.preview = r.image_url; paint();
      }).catch(function (e) { inputs.splice(inputs.indexOf(it), 1); msg.textContent = e.message || 'that link didn\'t work.'; paint(); });
    }
    function run() {
      var lines = ['looking at what you dropped', 'going through the feed', 'keeping it varied', 'writing it up'], i = 0;
      root.textContent = '';
      var line = h('p', { class: 'fl-taste-wait-t', text: lines[0] });
      root.appendChild(h('div', { class: 'fl-taste-wait', role: 'status' }, h('div', { class: 'fl-taste-wait-g', 'aria-hidden': 'true' }, [0, 1, 2, 3, 4, 5].map(function (n) { return h('span', { style: 'animation-delay:' + n * 120 + 'ms' }); })), line));
      var t = setInterval(function () { i = Math.min(i + 1, lines.length - 1); line.textContent = lines[i]; }, 1800);
      fn('taste-match', { session_key: tasteKey(), images: inputs.map(function (x) { return x.data ? { data: x.data, media: x.media } : { url: x.url, page_url: x.page_url }; }) }).then(function (r) {
        clearInterval(t);
        if (!r || !r.run_id) throw new Error((r && r.error) || 'something went wrong building your edit. try again.');
        opts.onResult(r);
      }).catch(function (e) {
        clearInterval(t);
        root.textContent = '';
        TasteDrop(root, opts);
        root.querySelector('.fl-taste-msg').textContent = e.message || 'something went wrong. try again.';
      });
    }
    paint();
  }
  views.taste = function (root) {
    root.classList.add('fl-taste');
    function start() {
      root.textContent = '';
      root.appendChild(h('h1', { class: 'fl-taste-h', text: 'shop your taste' }));
      root.appendChild(h('p', { class: 'fl-taste-sub', text: 'drop 5 to 10 things you\'d wear or own. we\'ll find what sits next to them.' }));
      var box = h('div'); root.appendChild(box);
      TasteDrop(box, { onResult: function (r) { ss('fly_taste_last', JSON.stringify(r)); results(r); window.scrollTo(0, 0); } });
    }
    function results(r) {
      var items = (r.items || []).slice(), page = 0, more = r.more, facet = 'all';
      function claim() { return rpc('taste_claim_run', { p_run: r.run_id, p_session: tasteKey() }).catch(function () {}); }
      (meReady || loadMe()).then(function () { if (me) claim(); });
      root.textContent = '';
      var saveBtn = h('button', { class: 'btn-primary', type: 'button', text: 'save my edit', on: { click: function () {
        requireAuth(function () {
          saveBtn.disabled = true;
          claim().then(function () { return rpc('fly_build_taste_channel', { p_blocks: items.map(function (c) { return c.id; }) }); }).then(function (ch) {
            saveBtn.textContent = 'saved';
            toast('saved to your channel "my taste"');
            ss('fly_taste_last', JSON.stringify({ run_id: r.run_id, items: items, more: more }));
            return ch;
          }, function (e) { saveBtn.disabled = false; toast(errText(e)); });
        });
      } } });
      root.appendChild(h('header', { class: 'fl-taste-head' },
        h('h1', { class: 'fl-taste-h', text: 'your mien edit' }),
        h('div', { class: 'fl-btns' }, saveBtn, h('button', { class: 'btn-secondary', type: 'button', text: 'redo my taste', on: { click: function () { try { sessionStorage.removeItem('fly_taste_last'); } catch (e) {} start(); } } }))));
      if (r.skipped && r.skipped.length) root.appendChild(h('p', { class: 'fl-small', text: 'we couldn\'t read ' + r.skipped.length + ' of what you added, so the edit is built from the rest.' }));
      var bar = h('div', { class: 'fl-chips fl-taste-facets', role: 'group', 'aria-label': 'filter by category' }), g = h('div'), foot = h('div', { class: 'fl-btns fl-taste-more' });
      root.appendChild(bar); root.appendChild(g); root.appendChild(foot);
      var m;
      function paint() {
        var names = []; items.forEach(function (c) { if (c.facet && names.indexOf(c.facet) < 0) names.push(c.facet); });
        bar.textContent = '';
        if (names.length > 1) ['all'].concat(names).forEach(function (n) {
          bar.appendChild(h('button', { class: 'fl-chip', type: 'button', 'aria-pressed': String(facet === n), text: n, on: { click: function () { facet = n; paint(); } } }));
        });
        g.textContent = '';
        m = Masonry(g, { ctx: 'taste', nav: function () { return m.cards(); } });
        m.add(items.filter(function (c) { return facet === 'all' || c.facet === facet; }));
        foot.textContent = '';
        if (more) foot.appendChild(shuffle);
      }
      var shuffle = h('button', { class: 'btn-secondary', type: 'button', text: 'shuffle more', on: { click: function () {
        shuffle.disabled = true; shuffle.textContent = 'finding more';
        fn('taste-match', { run_id: r.run_id, session_key: tasteKey(), page: page + 1 }).then(function (x) {
          if (!x || !x.items) throw new Error((x && x.error) || 'that didn\'t work. try again.');
          page++; more = x.more;
          var seen = {}; items.forEach(function (c) { seen[c.id] = 1; });
          items = items.concat(x.items.filter(function (c) { return !seen[c.id]; }));
          shuffle.disabled = false; shuffle.textContent = 'shuffle more'; paint();
        }).catch(function (e) { shuffle.disabled = false; shuffle.textContent = 'shuffle more'; toast(e.message); });
      } } });
      paint();
    }
    var last = null;
    try { last = JSON.parse(ss('fly_taste_last') || 'null'); } catch (e) {}
    if (last && last.run_id && !/[?&]redo=1/.test(location.search)) results(last); else start();
  };

  /* /pages/channels: featured first, then every public channel with something in it */
  views.channels = function (root) {
    root.appendChild(h('div', { class: 'fl-head' },
      h('span', { class: 'fl-q', text: 'channels' }),
      h('h1', { class: 'fl-h1', text: 'channels' }),
      h('p', { class: 'fl-desc', text: 'collections people build out of what they find. save anything into your own.' }),
      h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'start a channel', on: { click: function () { newChannelWin(); } } }))));
    var grid = h('div', { class: 'fl-chans' });
    root.appendChild(grid);
    var off = 0;
    moreLoader(root, function () {
      return rpc('browse_channels', { p_offset: off, p_limit: 48 }).then(function (chs) {
        if (!off && !chs.length) grid.appendChild(h('p', { class: 'fl-empty', text: 'no public channels yet.' }));
        off += chs.length;
        chs.forEach(function (c) { grid.appendChild(chanCard(c)); });
        return chs.length === 48;
      });
    });
    fab();
  };

  function newChannelWin() {
    requireMember(function () {
      var t = h('input', { class: 'fl-in', type: 'text', maxlength: '80', placeholder: 'name it' });
      var v = h('select', { class: 'fl-sel' }, h('option', { value: 'public', text: 'public' }), h('option', { value: 'private', text: 'private' }));
      var err = h('p', { class: 'fl-err', hidden: true });
      win('new_channel.exe', h('form', { on: { submit: function (e) {
        e.preventDefault();
        rpc('create_channel', { p_title: t.value, p_description: null, p_visibility: v.value }).then(function (ch) {
          location.href = urls.channel(ch.slug);
        }, function (x) { err.textContent = errText(x); err.hidden = false; });
      } } }, h('label', { class: 'fl-lbl', text: 'title' }), t, h('label', { class: 'fl-lbl', text: 'who can see it' }), v, err,
        h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'make it' }))));
    });
  }

  function editChannelWin(ch) {
    var t = h('input', { class: 'fl-in', type: 'text', maxlength: '80', value: ch.title });
    var d = h('textarea', { class: 'fl-ta', maxlength: '500' }); d.value = ch.description || '';
    var v = h('select', { class: 'fl-sel' }, h('option', { value: 'public', text: 'public' }), h('option', { value: 'private', text: 'private' }));
    v.value = ch.visibility;
    var err = h('p', { class: 'fl-err', hidden: true });
    var del = h('button', { class: 'fl-btn', type: 'button', text: 'delete channel', hidden: ch.is_default });
    del.addEventListener('click', function () {
      if (!confirm('delete "' + ch.title + '"? anything in it stays wherever else it is saved.')) return;
      MIEN.sb.from('fly_channels').delete().eq('id', ch.id).then(function (r) {
        if (r.error) { err.textContent = errText(r.error); err.hidden = false; return; }
        location.href = '/pages/account';
      });
    });
    var w = win('channel.cfg', h('form', { on: { submit: function (e) {
      e.preventDefault();
      MIEN.sb.from('fly_channels').update({ title: t.value.trim().slice(0, 80) || ch.title, description: d.value.trim() || null, visibility: v.value })
        .eq('id', ch.id).then(function (r) {
          if (r.error) { err.textContent = errText(r.error); err.hidden = false; return; }
          w.close(); location.reload();
        });
    } } },
      h('label', { class: 'fl-lbl', text: 'title' }), t,
      h('label', { class: 'fl-lbl', text: 'description' }), d,
      h('label', { class: 'fl-lbl', text: 'who can see it' }), v, err,
      h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'save' }), del)));
  }

  function copy(text) {
    try { navigator.clipboard.writeText(text); } catch (e) {
      var ta = h('textarea'); ta.value = text; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (x) {} ta.remove();
    }
  }

  /* ------------------------------------------------------------------ closeup
     tapping a tile opens the block OVER the page instead of navigating away, so the feed, its
     scroll position and everything already loaded are still there when you close it. the url
     becomes /pages/block?id=..., so back closes it, forward reopens it and the link can be shared.
     under every closeup: an endless "more like this". */
  var Closeup = (function () {
    var layer = null, body = null, depth = 0, cur = null, openedAt = 0, scrollY = 0, lastFocus = null;
    /* each history entry carries its depth and which document pushed it, so forward, back and a
       reload all agree on how far close has to go. seq drops a late get_block after the user moved on. */
    var DOC = Date.now().toString(36) + Math.random().toString(36).slice(2), seq = 0, seenCards = {};
    /* the list the closeup was opened from (the feed, a module row, more like this): swipe or the arrow keys
       step through it. each step replaces the history entry, so back still closes the closeup */
    var navList = null;
    function step(dir) {
      if (!cur || !navList) return;
      var list = navList() || [], i = -1;
      for (var k = 0; k < list.length; k++) if (list[k].id === cur.id) { i = k; break; }
      var next = i > -1 ? list[i + dir] : null;
      if (!next || next.kind === 'pinterest_embed') return;
      seq++;
      seenCards[next.id] = next;
      Track.log(next.id, 'open', 'swipe');
      history.replaceState({ flyCu: next.id, d: depth, doc: DOC }, '', next.kind === 'product' ? urls.product(next.handle) : urls.block(next.id));
      body.classList.remove('is-from-left', 'is-from-right'); void body.offsetWidth;
      body.classList.add(dir > 0 ? 'is-from-right' : 'is-from-left');
      show(next);
    }
    function build() {
      body = h('div', { class: 'fl-cu-body' });
      var closeBtn = h('button', { class: 'fl-cu-x', type: 'button', 'aria-label': 'close', on: { click: function () { close(); } } }, h('span', { text: 'close' }), h('b', { text: '×' }));
      layer = h('div', { class: 'fl-cu', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'block', hidden: true },
        h('div', { class: 'fl-cu-bar' }, closeBtn), body);
      document.body.appendChild(layer);
      /* capture phase, so the auth modal and onboarding still count as open when this runs */
      document.addEventListener('keydown', function (e) {
        if (!cur || openWins.length) return;
        if ((window.MienAuthModal && MienAuthModal.isOpen && MienAuthModal.isOpen()) || document.querySelector('.fl-onb')) return;
        if (e.key === 'Escape') close();
        else if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !/INPUT|TEXTAREA|SELECT/.test((e.target && e.target.tagName) || '')) step(e.key === 'ArrowRight' ? 1 : -1);
      }, true);
      /* a sideways swipe moves to the next or previous block (not inside a row that scrolls sideways itself) */
      var sx = 0, sy = 0, st0 = 0, skip = false;
      layer.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st0 = Date.now();
        skip = !!(e.target.closest && e.target.closest('.fl-pl-row, .fl-hrow, .fl-fit, input, textarea, select'));
      }, { passive: true });
      layer.addEventListener('touchend', function (e) {
        if (skip || e.touches.length) return;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 70 && Math.abs(dx) > 2 * Math.abs(dy) && Date.now() - st0 < 700) step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    function endDwell() {
      if (cur && openedAt) Track.log(cur.id, 'dwell', 'closeup', null, Date.now() - openedAt);
      openedAt = 0;
    }
    function show(card) {
      if (!layer) build();
      endDwell();
      cur = card; openedAt = Date.now();
      body.textContent = '';
      renderBlock(body, card, { overlay: true });
      if (layer.hidden) {
        scrollY = window.scrollY; lastFocus = document.activeElement;
        layer.hidden = false;
        document.documentElement.classList.add('fl-cu-lock');
        setTimeout(function () { var x = layer.querySelector('.fl-cu-x'); if (x) x.focus({ preventScroll: true }); }, 30);
      }
      layer.scrollTop = 0;
    }
    function open(card, ctx, pos, nav) {
      navList = nav || null;
      seq++;
      Track.log(card.id, 'open', ctx || 'feed', pos);
      seenCards[card.id] = card;
      depth++;
      history.pushState({ flyCu: card.id, d: depth, doc: DOC }, '', card.kind === 'product' ? urls.product(card.handle) : urls.block(card.id));
      show(card);
    }
    function hide() {
      endDwell();
      cur = null;
      if (!layer || layer.hidden) return;
      layer.hidden = true; body.textContent = '';
      document.documentElement.classList.remove('fl-cu-lock');
      jumpTo(scrollY);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    function close() {
      if (depth > 0) { var d = depth; depth = 0; history.go(-d); } else hide();
    }
    window.addEventListener('popstate', function (e) {
      var st = e.state, my = ++seq;
      /* an entry pushed by an earlier document (before a reload) is this page's own base */
      if (st && st.flyCu && st.doc === DOC) {
        depth = st.d || 1;
        if (seenCards[st.flyCu]) { show(seenCards[st.flyCu]); return; }
        rpc('get_block', { p_id: st.flyCu }).then(function (b) { if (my !== seq) return; if (b) show(b); else hide(); },
          function () { if (my === seq) hide(); });
      } else { depth = 0; hide(); }
    });
    return { open: open, close: close, isOpen: function () { return !!cur; } };
  })();

  /* one renderer for the block page and the closeup: media, the side panel, then "more like this" */
  function renderBlock(root, b, opts) {
    opts = opts || {};
    var isProd = b.kind === 'product', isLink = b.kind === 'linkout_product';
    var media = b.kind === 'pinterest_embed'
      ? h('div', { class: 'fl-embed', style: 'padding:8px' }, h('a', { 'data-pin-do': 'embedPin', 'data-pin-width': 'large', href: safeUrl(b.embed_url) }))
      : h('div', { class: 'fl-block-media' }, pic(b.img, 'fl-block-img', b.title || b.brand || '', b.w, b.h, '(max-width: 860px) 100vw, 58vw', true));
    if (b.kind === 'pinterest_embed') loadPinit();
    var heading = b.title || b.source_title || (b.brand ? b.brand : 'untitled');
    var kv = h('dl', { class: 'fl-kv' });
    function row(k, v) { if (v) { kv.appendChild(h('dt', { text: k })); kv.appendChild(h('dd', null, v)); } }
    /* a link-out product goes out through its buy link (?ref=mien); anything else through its source */
    var src = safeUrl(isLink ? (b.buy || b.source_url) : b.source_url);
    var srcLink = null;
    if (src && !isProd) {
      /* the stored url may carry subid={click_id}; the href drops it so a copied link never shows
         braces, and mien-supabase.js appends the real subid (and logs tile_clicks) at click time */
      var shown = src.replace(/([?&])subid=(\{click_id\}|%7Bclick_id%7D)(&|$)/i, function (m, a, x, c) { return c ? a : ''; });
      srcLink = function (label, cls) {
        return h('a', { class: cls || null, href: shown, target: '_blank', rel: 'noopener nofollow', 'data-linkout': '', 'data-dest': src,
          'data-brand': b.brand || '', 'data-source': 'fly', 'data-block': b.id, 'data-handle': b.handle || null, text: label,
          on: { click: function () { Track.log(b.id, 'source_click', opts.overlay ? 'closeup' : 'related'); } } });
      };
      row('source', isLink && b.dead ? (hostOf(src) || null) : srcLink(hostOf(src) || 'link'));
    }
    /* unsplash asks for the photographer to be linked; the other sources credit through their source page */
    var cu = b.provider === 'unsplash' ? safeUrl(b.credit_url) : null;
    row('credit', b.own_photo ? h('span', null, 'own photo by ', userLink(b.owner && b.owner.handle))
      : (cu && b.credit ? h('a', { href: cu, target: '_blank', rel: 'noopener nofollow', text: b.credit }) : b.credit));
    row('brand', b.brand ? h('a', { href: urls.brand(b.brand), text: b.brand }) : null);
    row('category', b.category);
    row('posted by', b.owner && b.owner.handle ? h('span', null, userLink(b.owner.handle), b.owner.is_house && !isBot(b.owner.handle) ? ' (run by mien)' : '') : null);
    /* a creative commons license links to its deed, as the license asks */
    var lm = /^cc[- ](by(?:-sa)?)[- ](\d\.\d)(?:[- ]([a-z]{2,3}))?$/i.exec(b.license || '');
    row('license', lm ? h('a', { href: 'https://creativecommons.org/licenses/' + lm[1].toLowerCase() + '/' + lm[2] + '/' + (lm[3] ? lm[3].toLowerCase() + '/' : ''),
      target: '_blank', rel: 'noopener license', text: b.license }) : (b.license || null));
    /* only the owner (and admins) ever see a block that is not live; get_block carries the screen's note for them */
    if (b.status && b.status !== 'approved') row('status', b.status === 'pending' ? 'checking it. only you can see it for now.'
      : b.status === 'rejected' ? 'not posted: ' + (plainNote(b.rejection_note) || 'it did not pass the check') + '. only you can see it.'
      : b.status === 'removed' ? 'taken down.' : b.status);

    var saveBtn = h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'save', on: { click: function () { quickSave(b, saveBtn, 'closeup'); } } });
    var side = h('div', { class: 'fl-block-side' },
      h('span', { class: 'fl-q', text: isProd ? 'on mien' : isLink ? 'piece' : 'block' }),
      h('h1', { class: 'fl-h2', text: heading }),
      b.brand_note ? h('p', { class: 'fl-desc', text: b.brand_note }) : null);
    if (isProd) {
      side.appendChild(h('p', { class: 'fl-price', text: [b.brand, money(b.price, b.currency)].filter(Boolean).join(' · ') }));
      side.appendChild(buyBox(b));
    } else if (isLink) {
      side.appendChild(h('p', { class: 'fl-price', text: [b.brand, b.price != null ? money(b.price, b.currency) : null].filter(Boolean).join(' · ') }));
      if (b.dead || b.available === false) side.appendChild(h('p', { class: 'fl-small', text: b.dead ? 'gone from the brand. it stays in your saves.' : 'sold out at the brand for now.' }));
      else if (srcLink) side.appendChild(h('div', { class: 'fl-btns' }, srcLink('buy at ' + (hostOf(src) || b.brand || 'the brand'), 'fl-btn fl-solid')));
    } else if (srcLink) {
      side.appendChild(h('div', { class: 'fl-btns' }, srcLink('see it at ' + (hostOf(src) || 'the source'), 'fl-btn fl-solid')));
    }
    side.appendChild(h('div', { class: 'fl-btns' },
      saveBtn,
      h('button', { class: 'fl-btn', type: 'button', text: 'copy link', on: { click: function (e) {
        copy(location.origin + (isProd ? urls.product(b.handle) : urls.block(b.id))); e.target.textContent = 'copied';
      } } }),
      isProd ? h('a', { class: 'fl-btn', href: urls.product(b.handle), text: 'full page' }) : null));
    side.appendChild(kv);
    var chanBox = h('div', { class: 'fl-block-chans' });
    side.appendChild(chanBox);
    /* report (anyone signed in, not on your own block, not on mien's products) sits before the takedown link once
       get_block says who owns it; copyright and "it's mine" still go to the takedown page, read by a person */
    var foot = h('p', { class: 'fl-small fl-block-foot' },
      h('a', { href: '/pages/takedown?block=' + encodeURIComponent(b.id), text: 'this is mine / copyright' }));
    side.appendChild(foot);
    root.appendChild(h('div', { class: 'fl-block' }, h('div', { class: 'fl-block-main' }, media, insights(b, opts.overlay, media)), side));

    /* the card from the grid has no channel list: fetch the full block for the discovery path */
    var full = b.channels ? Promise.resolve(b) : rpc('get_block', { p_id: b.id });
    full.then(function (fb) {
      if (!fb) return;
      if (!fb.is_owner && !isProd) {
        foot.insertBefore(document.createTextNode(' · '), foot.firstChild);
        foot.insertBefore(h('button', { class: 'fl-link', type: 'button', text: 'report', on: { click: function () { reportWin(fb); } } }), foot.firstChild);
      }
      if (fb.is_owner && !isProd) {
        var mine = h('p', { class: 'fl-mono fl-pst-own' }, h('button', { class: 'fl-link', type: 'button', text: 'your stats', on: { click: function () { postSheet(b); } } }), ': ');
        side.insertBefore(mine, chanBox);
        rpc('get_my_post_stats', { p_range: 'all', p_block: b.id }).then(function (n) { mine.appendChild(document.createTextNode(statLine(n))); }, function () { mine.remove(); });
      }
      if (me && me.is_admin && !isProd) {
        /* admin only: a mien pick gets the "picked by mien" label on its tile, a spot in the picked row, and its poster is told */
        var pkText = function (on) { return on ? 'in mien picks, remove' : 'add to mien picks'; };
        var pk = h('button', { class: 'fl-btn' + (fb.picked ? ' fl-solid' : ''), type: 'button', text: pkText(fb.picked), on: { click: function () {
          var on = !pk.classList.contains('fl-solid');
          rpc('fly_pick_block', { p_block: b.id, p_on: on }).then(function () { pk.classList.toggle('fl-solid', on); pk.textContent = pkText(on); }, function (e) { toast(errText(e)); });
        } } });
        side.insertBefore(h('div', { class: 'fl-btns' }, pk, h('p', { class: 'fl-mono fl-pick-note', text: 'only you see this. a pick gets the "picked by mien" label, a spot in the picked row, and the poster hears about it.' })), chanBox);
      }
      if (fb.is_owner && !isProd) {
        foot.appendChild(document.createTextNode(' · '));
        foot.appendChild(h('button', { class: 'fl-link', type: 'button', text: 'delete', on: { click: function () {
          if (!confirm('delete this block everywhere?')) return;
          MIEN.sb.from('fly_blocks').delete().eq('id', fb.id).then(function () { location.href = '/pages/account'; });
        } } }));
      }
      var chs = fb.channels || [];
      chanBox.appendChild(h('p', { class: 'fl-meta' }, h('span', { class: 'fl-q', text: 'saved' }), ' in ' + chs.length + ' channel' + (chs.length === 1 ? '' : 's')));
      if (chs.length) {
        var ol = h('ol', { class: 'fl-ol' });
        chs.slice(0, 12).forEach(function (c) {
          ol.appendChild(h('li', null, h('a', { href: urls.channel(c.slug), text: c.title }), c.owner ? [' by ', userLink(c.owner)] : null));
        });
        chanBox.appendChild(ol);
      }
    });

    /* more like this, forever */
    var rel = h('section', { class: 'fl-rel' }, h('h2', { class: 'fl-sec', text: 'more like this' }));
    root.appendChild(rel);
    var gridEl = h('div'); rel.appendChild(gridEl);
    var grid = Masonry(gridEl, { ctx: 'related', nav: function () { return grid.cards(); } });
    var shown2 = [b.id];
    var relLoader = moreLoader(rel, function () {
      return rpc('get_related', { p_block: b.id, p_exclude: shown2, p_limit: 24, p_session: Track.session() }).then(function (cards) {
        cards.forEach(function (c) { shown2.push(c.id); });
        grid.add(cards);
        return cards.length > 0 && shown2.length < 400;
      });
    }, 1200);
    relLoader.kick();
  }

  /* report: one tap per reason. fly_report sends the block back through the screen straight away */
  var REPORT_REASONS = [['explicit', 'sexual or explicit'], ['hateful', 'hateful'], ['violent', 'violent or gory'],
    ['spam', 'spam or an ad'], ['off_topic', "doesn't belong on mien"], ['other', 'something else']];
  function reportWin(b) {
    requireMember(function () {
      var err = h('p', { class: 'fl-err', hidden: true });
      var list = h('ul', { class: 'fl-chlist' });
      var w;
      function lock(on) { Array.prototype.forEach.call(list.querySelectorAll('button'), function (x) { x.disabled = on; }); }
      REPORT_REASONS.forEach(function (r) {
        list.appendChild(h('li', null, h('button', { type: 'button', text: r[1], on: { click: function () {
          lock(true); err.hidden = true;
          rpc('fly_report', { p_block: b.id, p_reason: r[0] }).then(function () {
            w.close(); toast('thanks. it gets checked again right away.');
          }, function (x) { lock(false); err.textContent = errText(x); err.hidden = false; });
        } } })));
      });
      w = win('report.exe', h('div', null, h('p', { class: 'fl-small', text: 'what is wrong with it?' }), list, err));
    });
  }

  /* ------------------------------------------------------------------ what's in this
     the ai analysis of a block (analyze-block): for a fit, numbered dots on the picture and a row per item with the
     closest pieces (or the poster's real tag); for an album, poster, book or object it is confident about, an
     "about this" window with where to get it; for anything else, pieces like this. nothing here ever names a
     person. outbound taps log to tile_clicks as in_this_fit / about_this; the rows log impressions once seen. */
  function outLink(href, label, source, b, extra, cls) {
    var dest = safeUrl(href);
    if (!dest) return null;
    var shown = dest.replace(/([?&])subid=(\{click_id\}|%7Bclick_id%7D)(&|$)/i, function (m, a, x, z) { return z ? a : ''; });
    var native = /^\/products\//.test(dest);
    return h('a', { class: cls || null, href: shown, target: native ? null : '_blank', rel: native ? null : 'noopener nofollow sponsored',
      'data-linkout': '', 'data-dest': dest, 'data-brand': (extra && extra.brand) || '', 'data-source': source, 'data-block': (extra && extra.block) || b.id,
      /* a match's tap lands on the matched piece; the post it came from rides along so its poster sees "led to" */
      'data-from-block': extra && extra.block && extra.block !== b.id ? b.id : null,
      'data-handle': (extra && extra.handle) || null }, label);
  }
  function logSeen(source, b, pairs) {
    pairs.slice(0, 20).forEach(function (pr, i) {
      seenOnce(pr.el, function () {
        Track.whenArmed(function () {
          var vk = null; try { vk = sessionStorage.getItem('mien_vs'); } catch (e) {}
          var c = pr.c;
          MIEN.sb.from('tile_impressions').insert({ source: source, block_id: b.id, item_block_id: c.id, brand: c.brand ? String(c.brand).slice(0, 80) : null,
            product_handle: c.handle || null, position: i, session_key: String(Track.session()).slice(0, 64), visit_key: vk ? vk.slice(0, 64) : null,
            user_id: me ? me.id : null }).then(function () {}, function () {});
        });
      });
    });
  }
  /* up to three pieces for one item. never "the" item: mien's own is "closest on mien", a brand's is "looks like" */
  function matchRow(b, cards, source) {
    var row = h('div', { class: 'fl-match' });
    row._pairs = [];
    (cards || []).slice(0, 3).forEach(function (c) {
      var native = c.kind === 'product';
      var a = outLink(native ? urls.product(c.handle) : (c.buy || c.source_url), [
        h('span', { class: 'fl-match-im' }, pic(c.img, 'fl-pl-img', c.title || c.brand || '', c.w, c.h, '120px')),
        h('span', { class: 'fl-match-k', text: native ? 'closest on mien' : 'looks like' }),
        h('span', { class: 'fl-match-l' }, h('span', { text: c.brand || '' }), c.price != null ? h('span', { text: money(c.price, c.currency) }) : null)
      ], source, b, { brand: c.brand, block: c.id, handle: c.handle }, 'fl-match-item');
      if (a) { row.appendChild(a); row._pairs.push({ c: c, el: a }); }
    });
    if (!row.children.length) row.appendChild(h('p', { class: 'fl-mono', text: 'nothing close on mien yet.' }));
    return row;
  }
  function tagLine(b, t, source) {
    var label = [t.title || t.site || t.domain || 'the exact piece', t.price != null ? money(t.price, t.currency) : null].filter(Boolean).join(' · ');
    var a = t.ok ? outLink(t.url, label, source, b, { brand: t.domain }, 'fl-tag-a') : h('span', { class: 'fl-tag-a', text: label });
    return h('div', { class: 'fl-tag' }, t.image && t.ok ? h('img', { class: 'fl-tag-im', src: t.image, alt: '', loading: 'lazy', referrerpolicy: 'no-referrer' }) : null,
      h('div', null, a, h('p', { class: 'fl-mono' }, t.ok ? ['tagged by ', userLink(t.by)] : (t.checked ? 'that link did not work' : 'checking the link'))));
  }
  /* where each item's dot goes: the middle of its box, nudged down when two would sit on top of each other */
  function dotSpots(items) {
    var placed = [];
    return items.map(function (it) {
      var bx = it.bbox; if (!bx) return null;
      var x = bx.x + bx.w / 2, y = bx.y + bx.h / 2, tries = 0;
      while (tries++ < 6 && placed.some(function (p) { return Math.abs(p.x - x) < 7 && Math.abs(p.y - y) < 6; })) y = Math.min(y + 7, 96);
      placed.push({ x: x, y: y });
      return { x: x, y: y };
    });
  }
  function fitSection(b, ins, media) {
    var sec = h('section', { class: 'fl-fit' }, h('h2', { class: 'fl-pl-h', text: 'in this fit' }));
    var img = media && media.querySelector('.fl-block-img');
    var dots = h('span', { class: 'fl-fit-dots' });
    if (img) {
      var old = media.querySelector('.fl-fit-dots'); if (old) old.remove();
      var wrap = img.parentNode.classList.contains('fl-imgwrap') ? img.parentNode : null;
      if (!wrap) { wrap = h('span', { class: 'fl-imgwrap' }); img.parentNode.insertBefore(wrap, img); wrap.appendChild(img); }
      wrap.appendChild(dots);
    }
    var rows = h('ol', { class: 'fl-fit-rows' }), dotEls = [], rowEls = [], pairs = [];
    function select(i, scroll) {
      dotEls.forEach(function (d, k) { if (d) d.classList.toggle('is-on', k === i); });
      rowEls.forEach(function (r, k) { r.classList.toggle('is-on', k === i); });
      if (scroll && rowEls[i]) rowEls[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    var spots = dotSpots(ins.items);
    ins.items.forEach(function (it, i) {
      var n = String(i + 1), sp = spots[i];
      dotEls.push(sp ? h('button', { class: 'fl-dot-n', type: 'button', style: 'left:' + sp.x + '%;top:' + sp.y + '%',
        'aria-label': 'item ' + n + ', ' + it.label, text: n, on: { click: function (e) { e.preventDefault(); e.stopPropagation(); select(i, true); } } }) : null);
      if (dotEls[i]) dots.appendChild(dotEls[i]);
      var mr = it.tag ? null : matchRow(b, it.matches, 'in_this_fit');
      var row = h('li', { class: 'fl-fit-row', on: { click: function (e) { if (!(e.target.closest && e.target.closest('a'))) select(i, false); } } },
        h('span', { class: 'fl-fit-n', text: n }),
        h('div', { class: 'fl-fit-main' }, h('p', { class: 'fl-fit-l', text: it.label }), it.tag ? tagLine(b, it.tag, 'in_this_fit') : mr));
      rowEls.push(row); rows.appendChild(row);
      if (mr) pairs = pairs.concat(mr._pairs);
    });
    (ins.extra || []).forEach(function (t) {
      rows.appendChild(h('li', { class: 'fl-fit-row' }, h('span', { class: 'fl-fit-n', text: '+' }),
        h('div', { class: 'fl-fit-main' }, h('p', { class: 'fl-fit-l', text: t.label || 'also in it' }), tagLine(b, t, 'in_this_fit'))));
    });
    sec.appendChild(rows);
    if (pairs.length) logSeen('in_this_fit', b, pairs);
    return sec;
  }
  function searchLinks(b, id) {
    var q = id.search || [id.maker, id.title].filter(Boolean).join(' ');
    var e = encodeURIComponent(q), out = [];
    if (id.block_type === 'album_cover' || id.kind === 'album') {
      out.push(outLink('https://www.discogs.com/search/?q=' + e + '&type=all', 'discogs', 'about_this', b, { brand: 'discogs.com' }, 'fl-btn'));
      out.push(outLink('https://bandcamp.com/search?q=' + e, 'bandcamp', 'about_this', b, { brand: 'bandcamp.com' }, 'fl-btn'));
    }
    out.push(outLink('https://www.ebay.com/sch/i.html?_nkw=' + e + '&ref=mien', 'ebay', 'about_this', b, { brand: 'ebay.com' }, 'fl-btn'));
    return out.filter(Boolean);
  }
  function aboutBox(b, id) {
    var mienRow = null;
    var body = h('div', { class: 'fl-win-body' },
      h('p', { class: 'fl-about-t', text: id.title }),
      h('p', { class: 'fl-mono', text: [id.maker, id.year].filter(Boolean).join(' · ') }),
      (id.about || []).length ? h('ul', { class: 'fl-about-l' }, id.about.map(function (l) { return h('li', { text: l }); })) : null,
      h('p', { class: 'fl-pl-h', text: 'where to get it' }),
      h('div', { class: 'fl-btns' }, searchLinks(b, id)),
      (id.mien || []).length ? h('div', null, h('p', { class: 'fl-mono', text: 'on mien' }), (mienRow = matchRow(b, id.mien, 'about_this'))) : null,
      h('p', { class: 'fl-mono fl-about-n', text: 'a guess by mien, ' + Math.round((id.confidence || 0) * 100) + '% sure. it can be wrong.' }));
    var sec = h('section', { class: 'fl-win fl-about' }, h('div', { class: 'fl-win-bar' }, h('span', { class: 'fl-win-t', text: 'about this' })), body);
    if (mienRow && mienRow._pairs.length) logSeen('about_this', b, mienRow._pairs);
    return sec;
  }
  function tagWin(b, ins, reload) {
    requireMember(function () {
      var mine = !!ins.is_owner;
      var items = ins.block_type === 'fit' ? (ins.items || []) : [];
      var sel = h('select', { class: 'fl-sel', 'aria-label': 'which item' },
        items.map(function (it, i) { return h('option', { value: String(it.idx), text: (i + 1) + '. ' + it.label }); }),
        h('option', { value: '', text: items.length ? 'something else' : 'the thing in the picture' }));
      var url = h('input', { class: 'fl-in', type: 'url', placeholder: 'https://', required: true, 'aria-label': 'link to the exact item' });
      var lab = h('input', { class: 'fl-in', type: 'text', maxlength: '80', placeholder: 'what it is (optional)', 'aria-label': 'what it is' });
      var err = h('p', { class: 'fl-err', hidden: true });
      var btn = h('button', { class: 'fl-btn fl-solid', type: 'submit', text: mine ? 'tag it' : 'send to the poster' });
      var w = win(mine ? 'tag the exact item' : 'suggest a tag', h('form', { on: { submit: function (e) {
        e.preventDefault(); err.hidden = true; btn.disabled = true;
        rpc('fly_tag_item', { p_block: b.id, p_item_idx: sel.value === '' ? null : Number(sel.value), p_url: url.value.trim(), p_label: lab.value.trim() || null })
          .then(function (r) {
            w.close();
            toast(r.status === 'confirmed' ? 'tagged. checking the link.' : 'sent. the poster decides.');
            fn('analyze-block', { tags: true }).catch(function () {});
            setTimeout(reload, 5000);
          }, function (x) {
            btn.disabled = false;
            err.textContent = /bad_url/.test(String(x && x.message)) ? 'that does not look like a link.' : /rate_limited/.test(String(x && x.message)) ? 'that is enough tags for today.' : errText(x);
            err.hidden = false;
          });
      } } },
        h('p', { class: 'fl-desc', text: mine ? 'paste the link to the exact piece. it replaces the guess for that item.' : 'paste the link to the exact piece. the poster sees it and decides.' }),
        items.length ? [h('label', { class: 'fl-lbl', text: 'which item' }), sel] : null,
        h('label', { class: 'fl-lbl', text: 'link' }), url,
        h('label', { class: 'fl-lbl', text: 'what it is' }), lab,
        err, h('div', { class: 'fl-btns' }, btn)));
    });
  }
  function tagFoot(b, ins, reload) {
    var foot = h('div', { class: 'fl-ins-foot' });
    if (b.kind !== 'image') return foot;
    foot.appendChild(h('button', { class: 'fl-link', type: 'button', text: ins.is_owner ? 'tag the exact item' : 'know the exact piece? suggest a tag',
      on: { click: function () { tagWin(b, ins, reload); } } }));
    (ins.pending || []).forEach(function (t) {
      var who = t.mine ? 'your suggestion, waiting on the poster' : ['suggested by ', userLink(t.by)];
      foot.appendChild(h('div', { class: 'fl-tag is-pending' },
        h('div', null, h('a', { href: safeUrl(t.url) || '#', target: '_blank', rel: 'noopener nofollow', text: t.title || t.domain || t.url }), h('p', { class: 'fl-mono' }, who)),
        ins.can_review ? h('div', { class: 'fl-btns' },
          h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'yes, that is it', on: { click: function () { rpc('fly_review_tag', { p_tag: t.id, p_approve: true }).then(reload); } } }),
          h('button', { class: 'fl-btn', type: 'button', text: 'no', on: { click: function () { rpc('fly_review_tag', { p_tag: t.id, p_approve: false }).then(reload); } } })) : null));
    });
    if (me && me.is_admin) foot.appendChild(h('button', { class: 'fl-link', type: 'button', text: 'run the analysis again', on: { click: function (e) {
      e.target.disabled = true; e.target.textContent = 'running';
      rpc('admin_rerun_analysis', { p_block: b.id }).then(function () { return fn('analyze-block', { ids: [b.id] }); }).then(reload, reload);
    } } }));
    return foot;
  }
  function insights(b, compact, media) {
    var box = h('div', { class: 'fl-ins' });
    if (b.kind === 'pinterest_embed') return box;
    function load() {
      rpc('block_insights', { p_block: b.id }).then(function (ins) {
        box.textContent = '';
        var d = media && media.querySelector('.fl-fit-dots'); if (d) d.remove();
        if (!ins) { box.appendChild(piecesLike(b, compact)); return; }
        var fit = ins.block_type === 'fit' && ins.items && ins.items.length;
        if (fit) box.appendChild(fitSection(b, ins, media));
        else {
          if (ins.identified) box.appendChild(aboutBox(b, ins.identified));
          if (ins.extra && ins.extra.length) {
            var tags = h('section', { class: 'fl-fit' }, h('h2', { class: 'fl-pl-h', text: 'tagged' }));
            ins.extra.forEach(function (t) { tags.appendChild(tagLine(b, t, 'in_this_fit')); });
            box.appendChild(tags);
          }
          if (!ins.identified) box.appendChild(piecesLike(b, compact));
        }
        box.appendChild(tagFoot(b, ins, load));
      }, function () { box.textContent = ''; box.appendChild(piecesLike(b, compact)); });
    }
    load();
    return box;
  }

  /* pieces like this: the nearest things to buy, mien's own first. link-outs go straight to the brand and native
     pieces open their page; both taps log to tile_clicks as source 'pieces_like', and the row's impressions go to
     tile_impressions once it has been on screen (and a real person is there) */
  function piecesLike(b, compact) {
    var sec = h('section', { class: 'fl-pl', hidden: true }, h('h2', { class: 'fl-pl-h', text: 'pieces like this' }));
    if (b.kind === 'pinterest_embed') return sec;
    var row = h('div', { class: 'fl-pl-row' });
    sec.appendChild(row);
    rpc('pieces_like', { p_block: b.id, p_limit: compact ? 6 : 8 }).then(function (items) {
      if (!items || !items.length) return;
      var rendered = [];
      items.forEach(function (c) {
        var native = c.kind === 'product';
        var dest = native ? urls.product(c.handle) : safeUrl(c.buy || c.source_url);
        if (!dest) return;
        var shown = dest.replace(/([?&])subid=(\{click_id\}|%7Bclick_id%7D)(&|$)/i, function (m, a, x, z) { return z ? a : ''; });
        var a = h('a', { class: 'fl-pl-item', href: shown, target: native ? null : '_blank', rel: native ? null : 'noopener nofollow sponsored',
          'data-linkout': '', 'data-dest': dest, 'data-brand': c.brand || '', 'data-source': 'pieces_like', 'data-block': c.id, 'data-handle': c.handle || null },
          h('span', { class: 'fl-pl-im' }, pic(c.img, 'fl-pl-img', c.title || c.brand || '', c.w, c.h, '(max-width: 860px) 42vw, 180px')),
          h('span', { class: 'fl-pl-l' }, h('span', { text: c.brand || '' }), c.price != null ? h('span', { text: money(c.price, c.currency) }) : null));
        row.appendChild(a);
        rendered.push({ c: c, el: a });
      });
      if (!row.children.length) return;
      sec.hidden = false;
      logSeen('pieces_like', b, rendered);
    }, function () {});
    return sec;
  }
  /* once an element has been at least half on screen for 0.8s (inside the closeup, its layer is the scroller) */
  function seenOnce(el, cb) {
    if (!('IntersectionObserver' in window)) return;
    var t = null, io = null;
    setTimeout(function () {
      io = new IntersectionObserver(function (es) {
        var e = es[0];
        if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!t) t = setTimeout(function () { io.disconnect(); cb(); }, 800); }
        else if (t) { clearTimeout(t); t = null; }
      }, { threshold: [0, 0.5], root: el.closest ? el.closest('.fl-cu') : null });
      io.observe(el);
    }, 0);
  }

  /* product: size picker + add to cart, without leaving the page. the header count updates and the
     toast offers checkout; the normal shopify cart and checkout take it from there. */
  function buyBox(b) {
    var box = h('div', { class: 'fl-btns fl-buy' });
    fetch('/products/' + encodeURIComponent(b.handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) { box.appendChild(h('a', { class: 'fl-btn', href: urls.product(b.handle), text: 'see the piece' })); return; }
      var avail = p.variants.filter(function (v) { return v.available; });
      if (!avail.length) { box.appendChild(h('span', { class: 'fl-small', text: 'gone for now. want it and we will tell you if it comes back.' })); return; }
      var sel = null;
      if (p.variants.length > 1) {
        sel = h('select', { class: 'fl-sel', 'aria-label': 'size' });
        p.variants.forEach(function (v) { sel.appendChild(h('option', { value: v.id, disabled: !v.available, text: v.title + (v.available ? '' : ' (gone)') })); });
        sel.value = avail[0].id; box.appendChild(sel);
      }
      var btn = h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'add to cart' });
      btn.addEventListener('click', function () {
        btn.disabled = true; btn.textContent = 'adding';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(sel ? sel.value : avail[0].id), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            btn.disabled = false; btn.textContent = 'add another';
            Track.log(b.id, 'add_to_cart', 'closeup');
            refreshCartCount();
            toast('in your cart', [{ label: 'checkout', href: '/cart' }]);
          })
          .catch(function () { btn.disabled = false; btn.textContent = 'add to cart'; toast('that size just went. try another.'); });
      });
      box.appendChild(btn);
    });
    return box;
  }

  views.block = function (root) {
    var id = qp('id');
    if (!id) { root.appendChild(h('p', { class: 'fl-empty', text: 'no block here.' })); return; }
    rpc('get_block', { p_id: id }).then(function (b) {
      if (!b) { root.appendChild(h('p', { class: 'fl-empty' }, "that block isn't here anymore. ", h('a', { href: '/', text: 'back to the feed' }))); return; }
      Track.log(b.id, 'open', 'closeup');
      renderBlock(root, b);
    });
  };

  views.user = function (root) {
    var hd = (qp('u') || '').replace(/^@/, '');
    rpc('get_user', { p_handle: hd }).then(function (u) {
      if (!u) { root.appendChild(h('p', { class: 'fl-empty' }, 'no one goes by that here. ', h('a', { href: '/', text: 'back to the feed' }))); return; }
      root.appendChild(h('div', { class: 'fl-head' },
        h('span', { class: 'fl-q', text: isBot(u.handle) ? 'bot' : u.is_house ? 'house account' : u.is_brand ? 'brand' : 'taste page' }),
        isBot(u.handle) ? h('span', { class: 'fl-botl', text: 'BOT' }) : u.is_house ? h('span', { class: 'fl-small', text: '  run by mien' }) : null,
        h('h1', { class: 'fl-h1', text: '@' + u.handle }),
        u.name ? h('p', { class: 'fl-meta', text: u.name }) : null,
        u.house_note ? h('p', { class: 'fl-desc', text: u.house_note }) : null,
        u.is_brand && u.brand ? h('p', { class: 'fl-meta' }, h('a', { href: urls.brand(u.brand), text: 'the ' + u.brand + ' archive' })) : null,
        u.instagram ? h('p', { class: 'fl-meta' }, h('a', { href: 'https://www.instagram.com/' + encodeURIComponent(String(u.instagram).replace(/^@/, '')) + '/', target: '_blank', rel: 'noopener', text: 'instagram @' + String(u.instagram).replace(/^@/, '') })) : null,
        u.is_me ? h('p', { class: 'fl-meta' }, h('a', { href: '/pages/account', text: 'this is you. go to your account.' })) : null,
        h('div', { class: 'fl-btns' }, h('button', { class: 'btn-primary', type: 'button', text: u.is_me ? 'share your taste page' : 'share', on: { click: function (e) {
          var link = location.origin + urls.user(u.handle) + (u.is_me ? '&invite=' + encodeURIComponent(u.handle) : '');
          if (navigator.share) navigator.share({ title: '@' + u.handle + ' on mien', url: link }).catch(function () {});
          else { copy(link); e.target.textContent = 'link copied'; }
        } } }))));
      /* picked by mien, first thing on the page when there is any */
      if (u.picked && u.picked.length) {
        var pkSec = h('section', { class: 'fl-taste-picked' }, h('h2', { class: 'fl-sec', text: 'picked by mien' }));
        var pg = h('div'); pkSec.appendChild(pg); root.appendChild(pkSec);
        Masonry(pg, { ctx: 'user' }).add(u.picked);
      }
      tabs(root, [
        { k: 'channels', label: 'channels (' + u.channels.length + ')', render: function (p) {
          if (!u.channels.length) { p.appendChild(h('p', { class: 'fl-empty', text: 'no public channels yet.' })); return; }
          var g = h('div', { class: 'fl-chans' }); u.channels.forEach(function (c) { g.appendChild(chanCard(c)); }); p.appendChild(g);
        } },
        { k: 'posts', label: 'posts', render: function (p) {
          if (!u.blocks.length) { p.appendChild(h('p', { class: 'fl-empty', text: 'nothing posted yet.' })); return; }
          var g = h('div'); p.appendChild(g); Masonry(g, { ctx: 'user' }).add(u.blocks);
        } }
      ]);
    });
  };

  views.brand = function (root) {
    var tag = qp('b');
    rpc('get_brand', { p_tag: tag }).then(function (br) {
      if (!br) { root.appendChild(h('p', { class: 'fl-empty', text: 'no brand here.' })); return; }
      var head = h('div', { class: 'fl-head' },
        h('span', { class: 'fl-q', text: 'archive' }),
        h('h1', { class: 'fl-h1', text: br.tag }));
      if (br.on_mien) {
        head.appendChild(h('p', { class: 'fl-meta' }, 'on mien. ', br.profile && br.profile.handle ? h('a', { href: urls.user(br.profile.handle), text: '@' + br.profile.handle }) : null));
      } else {
        head.appendChild(h('p', { class: 'fl-desc' }, 'not selling on mien yet, so nothing here can be bought on mien. these are things people saved and tagged ' + br.tag + '. ',
          h('a', { href: '/pages/sell', text: 'is this your brand? come sell here.' })));
      }
      root.appendChild(head);
      if (br.channels.length) {
        var g = h('div', { class: 'fl-chans', style: 'margin:0 0 16px' }); br.channels.forEach(function (c) { g.appendChild(chanCard(c)); }); root.appendChild(g);
      }
      root.appendChild(h('hr', { class: 'fl-rule' }));
      var gridEl = h('div'); root.appendChild(gridEl);
      Masonry(gridEl, { ctx: 'brand' }).add(br.blocks);
      if (!br.blocks.length) root.appendChild(h('p', { class: 'fl-empty', text: 'nothing tagged ' + br.tag + ' yet.' }));
    });
  };

  function tabs(root, list, start) {
    var bar = h('div', { class: 'fl-tabs', role: 'tablist' });
    var panel = h('div', { role: 'tabpanel' });
    var btns = {};
    function show(k) {
      Object.keys(btns).forEach(function (x) { btns[x].setAttribute('aria-selected', String(x === k)); });
      panel.textContent = '';
      var t = list.filter(function (x) { return x.k === k; })[0];
      if (t) t.render(panel);
      try { var u = new URL(location.href); u.searchParams.set('tab', k); history.replaceState(null, '', u.pathname + u.search); } catch (e) {}
    }
    list.forEach(function (t) {
      btns[t.k] = h('button', { class: 'fl-tab', type: 'button', role: 'tab', 'aria-selected': 'false', on: { click: function () { show(t.k); } } }, t.label,
        t.dot ? h('span', { class: 'fl-dot', 'aria-label': 'new' }) : null);
      bar.appendChild(btns[t.k]);
    });
    root.appendChild(bar); root.appendChild(panel);
    var want = qp('tab');
    if (want === 'invites') want = 'share'; /* old links */
    show(list.some(function (t) { return t.k === want; }) ? want : (start || list[0].k));
    return { show: show };
  }

  /* ------------------------------------------------------------------ account */
  views.account = function (root) {
    loadMe().then(function () {
      if (!me) {
        /* signed out: one warm card, nothing else */
        root.appendChild(h('div', { class: 'fl-home-out' },
          h('div', null,
            h('span', { class: 'fl-home-av', 'aria-hidden': 'true', text: 'm' }),
            h('h1', { class: 'fl-h1', text: 'your corner of mien' }),
            h('p', { class: 'fl-desc', text: 'save what you like, build channels, follow people with taste, post your own finds.' }),
            h('div', { class: 'fl-btns' },
              h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'create account', on: { click: function () {
                MienAuthModal.open({ mode: 'create', onSuccess: function () { location.reload(); } });
              } } }),
              h('button', { class: 'fl-btn', type: 'button', text: 'sign in', on: { click: function () {
                MienAuthModal.open({ mode: 'signin', onSuccess: function () { location.reload(); } });
              } } })),
            h('p', { class: 'fl-small' }, 'new here? ', h('button', { class: 'fl-link', type: 'button', text: 'find your taste in five taps', on: { click: function () { Onboarding.start(); } } }), '.'))));
        return;
      }
      finishPendingOnboarding();
      /* the account page as a home (2026-10-26): your picture or initial, a hello, your numbers, then your stuff */
      var av = h('span', { class: 'fl-home-av', 'aria-hidden': 'true' });
      if (safeUrl(me.avatar)) av.appendChild(h('img', { src: me.avatar, alt: '' })); else av.textContent = String(me.handle || me.name || 'm').charAt(0);
      var stats = h('div', { class: 'fl-home-stats' });
      var head = h('div', { class: 'fl-home-head' }, av,
        h('div', { class: 'fl-home-who' },
          h('p', { class: 'fl-home-hi', text: greeting() + (me.name ? ', ' + me.name.split(' ')[0].toLowerCase() : '') + '.' }),
          h('h1', { class: 'fl-h1', text: me.handle ? '@' + me.handle : 'your account' }),
          me.is_brand || me.is_admin ? h('p', { class: 'fl-mono', text: me.is_brand ? 'brand account' : 'admin' }) : null,
          stats,
          h('div', { class: 'fl-btns' },
            h('button', { class: 'btn-primary', type: 'button', text: '+ post', on: { click: function () { addWin({ onPosted: function () { location.href = '/pages/account?tab=posted'; } }); } } }),
            me.handle ? h('a', { class: 'btn-secondary', href: urls.user(me.handle), text: 'your public page' }) : null,
            h('a', { class: 'btn-secondary', href: '/pages/taste?redo=1', text: 'redo my taste' }),
            !me.can_act && !me.paused ? h('button', { class: 'btn-secondary', type: 'button', text: 'enter an invite code', on: { click: function () { inviteWin(function () { location.reload(); }); } } }) : null)));
      rpc('my_fly_counts').then(function (n) {
        if (!n) return;
        [['saved', 'saved'], ['posts', 'posts'], ['channels', 'channels'], ['following', 'following']].forEach(function (x) {
          stats.appendChild(h('span', { class: 'fl-home-stat' }, h('b', { text: String(n[x[0]] || 0) }), h('span', { text: x[1] })));
        });
      }, function () {});
      root.appendChild(head);
      if (!me.handle) root.appendChild(handleForm());
      var list = [
        { k: 'channels', label: 'channels', render: accChannels },
        { k: 'want', label: 'saves', render: accWant },
        { k: 'posted', label: 'posts', render: accPosts },
        { k: 'notifications', label: 'notifications', dot: me.unread > 0, render: accNotes },
        { k: 'share', label: 'invite', render: accShare }
      ];
      if (me.is_brand) list.push({ k: 'demand', label: q('demand'), render: accBrand });
      list.push({ k: 'settings', label: 'settings', render: accSettings });
      tabs(root, list);
      if (qp('post') === '1') {
        try { var pu = new URL(location.href); pu.searchParams.delete('post'); history.replaceState(null, '', pu.pathname + pu.search); } catch (e) {}
        addWin({ onPosted: function () { location.href = '/pages/account?tab=posted'; } });
      }
      fab();
    });
  };
  function q(t) { return '\u201c' + t + '\u201d'; }

  function handleForm() {
    var i = h('input', { class: 'fl-in', type: 'text', placeholder: 'pick a handle', maxlength: '24', autocapitalize: 'off', autocomplete: 'off', style: 'max-width:320px' });
    var err = h('p', { class: 'fl-err', hidden: true });
    return h('form', { style: 'margin:0 0 14px', on: { submit: function (e) {
      e.preventDefault();
      var v = i.value.trim().toLowerCase().replace(/^@/, '');
      if (!/^[a-z0-9._]{2,24}$/.test(v)) { err.textContent = errText('profiles_handle_format'); err.hidden = false; return; }
      MIEN.setHandle(v).then(function (r) { if (r && r.error) { err.textContent = errText(r.error); err.hidden = false; } else location.reload(); });
    } } }, h('label', { class: 'fl-lbl', text: 'your handle (your page and your share link use it)' }),
      h('div', { class: 'fl-row', style: 'max-width:460px' }, i, h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'save', style: 'flex:0 0 auto' })), err);
  }

  function accChannels(p) {
    p.appendChild(h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn', type: 'button', text: '+ new channel', on: { click: newChannelWin } })));
    rpc('my_channels').then(function (chs) {
      if (!chs.length) { p.appendChild(h('p', { class: 'fl-empty', text: 'no channels yet. hit + on anything in the feed to start one.' })); return; }
      var g = h('div', { class: 'fl-chans' }); chs.forEach(function (c) { g.appendChild(chanCard(c)); }); p.appendChild(g);
    });
  }

  /* saves: everything saved to your profile (the private "saved" channel), newest first, on the feed's own board.
     the older want list (pieces mien sells, with restock notes) follows when it has anything in it */
  function accWant(p) {
    var gridEl = h('div', { class: 'fl-seg' }), wants = h('div');
    p.appendChild(gridEl); p.appendChild(wants);
    rpc('my_channels').then(function (chs) {
      var def = chs.filter(function (x) { return x.is_default; })[0];
      return def && def.slug ? rpc('get_channel', { p_slug: def.slug, p_offset: 0, p_limit: 120 }).then(function (ch) { return { ch: ch, def: def }; }) : { ch: null, def: null };
    }).then(function (r) {
      var blocks = (r.ch && r.ch.blocks) || [];
      if (!blocks.length) { gridEl.appendChild(h('p', { class: 'fl-empty', text: 'nothing saved yet. hit save on anything you like and pick "save to your profile".' })); return; }
      var grid = Masonry(gridEl, { ctx: 'channel', onRemove: function (c, el) {
        rpc('disconnect_block', { p_block: c.id, p_channel: r.def.id }).then(function () { grid.remove(el); });
      } });
      grid.add(blocks);
    }, function () {});
    MIEN.closetListFull().then(function (rows) {
      if (!rows.length) return;
      wants.appendChild(h('h2', { class: 'fl-sec', text: 'pieces you want' }));
      wants.appendChild(h('p', { class: 'fl-small', text: 'we tell you when one restocks, runs low, or the brand adds something new.' }));
      var ol = h('ol', { class: 'fl-ol', style: 'padding:0;list-style:none' });
      rows.forEach(function (r) {
        var buy = h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'buy' });
        buy.addEventListener('click', function () { oneTapBuy(r.product_handle, buy); });
        var rm = h('button', { class: 'fl-btn', type: 'button', text: 'remove' });
        var li = h('li', { class: 'fl-note' },
          r.image_url ? h('img', { src: r.image_url, alt: '' }) : h('span', { class: 'fl-ph' }),
          h('div', null, h('a', { href: urls.product(r.product_handle), text: r.title || r.product_handle }),
            h('div', { class: 'fl-small', text: [r.brand, r.price].filter(Boolean).join(' · ') + (r.product_gone ? ' · no longer on mien' : '') }),
            h('div', { class: 'fl-btns', style: 'margin:6px 0 0' }, r.product_gone ? null : buy, rm)));
        rm.addEventListener('click', function () { MIEN.closetRemove(r.product_handle).then(function () { li.remove(); }); });
        ol.appendChild(li);
      });
      wants.appendChild(h('div', { class: 'fl-notes' }, ol));
    });
  }

  /* one tap: a single available size goes straight to the cart, otherwise the product page picks it */
  function oneTapBuy(handle, btn) {
    btn.disabled = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      /* only a piece mien sells (the native tags, as snippets/mien-is-native) goes in mien's cart; a link-out opens its page */
      var tags = p ? (p.tags || []).map(function (t) { return String(t).toLowerCase(); }) : [];
      var native = tags.indexOf('state:dead') < 0 && tags.some(function (t) { return t === 'source:collective' || t === 'shopify collective' || t === 'source:native'; });
      var avail = p && native ? p.variants.filter(function (v) { return v.available; }) : [];
      if (avail.length !== 1) { location.href = urls.product(handle); return; }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: avail[0].id, quantity: 1 }] }) }).then(function (r) {
        location.href = r.ok ? '/cart' : urls.product(handle);
      });
    }).catch(function () { location.href = urls.product(handle); });
  }

  function accPosts(p) {
    rpc('my_posted_blocks').then(function (bs) {
      if (bs.length) {
        var n = { approved: 0, pending: 0, rejected: 0 };
        bs.forEach(function (b) { if (n[b.status] != null) n[b.status]++; });
        p.appendChild(h('p', { class: 'fl-meta', text: n.approved + ' live \u00b7 ' + n.pending + ' checking' + (n.rejected ? ' \u00b7 ' + n.rejected + ' not posted' : '') }));
      }
      if (!bs.length) { p.appendChild(h('p', { class: 'fl-empty', text: 'nothing posted yet.' })); return; }
      /* 2026-10-27: private stats, only ever shown to you. the last 7 days in big numbers, how buyable posts do against
         the rest, then every post with its own line; tap one for the breakdown */
      var top = h('div', { class: 'fl-pst-top' }), cmp = h('p', { class: 'fl-mono fl-pst-cmp' }), g = h('div', { class: 'fl-pst-grid' });
      p.appendChild(top); p.appendChild(cmp); p.appendChild(g);
      rpc('get_my_post_stats', { p_range: 'all' }).then(function (st) {
        var d7 = (st && st.totals && st.totals.d7) || {};
        top.appendChild(h('p', { class: 'fl-mono', text: 'last 7 days. only you see these.' }));
        top.appendChild(h('div', { class: 'fl-pst-big' }, [['views', 'views'], ['clicks', 'clicks'], ['saves', 'saves']].map(function (k) {
          return h('span', null, h('b', { text: String(d7[k[0]] || 0) }), h('span', { text: k[1] }));
        })));
        var cb = st && st.compare && st.compare.buyable, ci = st && st.compare && st.compare.inspiration;
        if (cb && ci && cb.posts && ci.posts) cmp.textContent = 'posts with a buy link average ' + (cb.avg_clicks || 0) + ' clicks. the rest average ' + (ci.avg_clicks || 0) + '. add where to buy it.';
        else cmp.textContent = 'add where to buy it when you post. buyable posts get seen more.';
        ((st && st.posts) || []).forEach(function (c) {
          var n = c.stats || {};
          var cell = h('button', { class: 'fl-pst', type: 'button', on: { click: function () { postSheet(c); } } },
            h('span', { class: 'fl-pst-im' }, pic(c.img, 'fl-tile-img', '', c.w, c.h, '(max-width: 600px) 50vw, 240px'),
              c.status && c.status !== 'approved' ? h('span', { class: 'fl-tile-st', text: ST_LABEL[c.status] || c.status }) : null,
              c.picked ? h('span', { class: 'fl-tile-pick', text: 'picked by mien' }) : null),
            h('span', { class: 'fl-mono fl-pst-line', text: statLine(n) }));
          g.appendChild(cell);
        });
      }, function () { var g2 = h('div'); p.appendChild(g2); Masonry(g2, { status: true, ctx: 'user' }).add(bs); });
      /* why the screen said no, one row per post it kept off */
      var rej = bs.filter(function (b) { return b.status === 'rejected'; });
      if (!rej.length) return;
      var ul = h('ul', { class: 'fl-notes', style: 'margin-top:var(--s-5)' });
      rej.forEach(function (b) {
        ul.appendChild(h('li', { class: 'fl-note' }, b.img ? h('img', { src: b.img, alt: '' }) : h('span', { class: 'fl-ph' }),
          h('div', null, h('a', { href: urls.block(b.id), text: 'not posted: ' + (plainNote(b.rejection_note) || 'it did not pass the check') }))));
      });
      p.appendChild(ul);
    });
  }

  /* each notification renders as nodes, so a handle in it is its own link */
  var NOTE_COPY = {
    block_connected: function (n, see) { return [n.payload.by ? userLink(n.payload.by, true) : 'someone', ' saved ', see('your post'),
      n.payload.channel ? [" into '", h('a', { href: urls.channel(n.payload.slug), text: n.payload.channel }), "'"] : null, '.']; },
    want_restock: function (n, see) { return [see(n.payload.title || 'a piece you want'), ' is back in stock.']; },
    want_low_stock: function (n, see) { return [see(n.payload.title || 'a piece you want'), ' is down to its last size.']; },
    brand_new_piece: function (n, see) { return [h('a', { href: urls.brand(n.payload.brand), text: n.payload.brand }), ' added a new piece: ', see(n.payload.title || 'see it'), '.']; },
    channel_new_blocks: function (n, see) { return [(n.payload.count || 1) + ' new in ', see(n.payload.channel), '.']; },
    tag_suggested: function (n, see) { var p = n.payload || {};
      return [p.by ? userLink(p.by, true) : 'someone', ' suggested a piece for ', see(p.title || 'your post'), '.']; },
    tag_confirmed: function (n, see) { var p = n.payload || {};
      return p.block_id ? [see('a tag you suggested'), ' was confirmed.'] : 'a tag you suggested was confirmed.'; },
    /* the screen said no, or took a post down later. the block may be gone, so it links to your posts */
    picked: function (n, see) { return ['your post ', see(n.payload.title ? "'" + n.payload.title + "'" : 'got noticed'), ' got picked by mien.']; },
    milestone: function (n, see) { var p = n.payload || {};
      return [see('your post'), ' passed ' + p.n + ' ' + (p.kind === 'views' ? 'views' : p.kind === 'clicks' ? 'clicks' : 'saves') + '.']; },
    weekly_recap: function (n, see) { var p = n.payload || {};
      return ['your posts this week: ', see((p.views || 0) + ' views, ' + (p.clicks || 0) + ' clicks, ' + (p.saves || 0) + ' saves'), '.']; },
    post_not_published: function (n, see) { var p = n.payload || {};
      return [see('your post'), p.title ? [" '", p.title, "'"] : null, " didn't go up: ", plainNote(p.note) || 'it did not pass the check', '.']; },
    account_paused: function (n, see) { var p = n.payload || {};
      return [see('posting is paused on your account'), p.until && day(p.until) ? ' until ' + day(p.until) : '', p.reason ? ': ' + plainNote(p.reason) : '', '.']; }
  };
  /* one post's numbers as one quiet line, and the sheet that breaks them down (yours only) */
  function statLine(n) {
    return (n.views || 0) + ' views \u00b7 ' + (n.clicks || 0) + ' clicks \u00b7 ' + (n.saves || 0) + ' saves' + (n.connections ? ' \u00b7 in ' + n.connections + ' channel' + (n.connections === 1 ? '' : 's') : '');
  }
  function postSheet(c) {
    var body = h('div', { class: 'fl-pst-sheet' }, h('p', { class: 'fl-mono', text: 'loading' }));
    var w = win('your post', body);
    rpc('get_my_post_stats', { p_range: 'all', p_block: c.id }).then(function (n) {
      body.textContent = '';
      body.appendChild(h('div', { class: 'fl-pst-head' }, h('span', { class: 'fl-pst-im' }, pic(c.img, 'fl-tile-img', '', c.w, c.h, '160px')),
        h('div', null, n.picked ? h('p', { class: 'fl-mono', text: 'picked by mien' }) : null,
          h('p', { class: 'fl-mono', text: n.buyable ? 'buyable post' : 'no buy link yet' }),
          h('a', { class: 'btn-secondary', href: urls.block(c.id), text: 'open the post' }))));
      var rows = [['views', 'times it was on someone\'s screen'], ['opens', 'opened'], ['clicks', 'taps out to buy or to the source'],
        ['led_to', 'taps on the pieces matched to it'], ['saves', 'saved'], ['connections', 'saved into channels']];
      body.appendChild(h('dl', { class: 'fl-pst-dl' }, rows.map(function (r) { return [h('dt', { text: String(n[r[0]] || 0) }), h('dd', { text: r[1] })]; })));
      if (n.channels && n.channels.length) {
        body.appendChild(h('p', { class: 'fl-mono', text: 'saved into' }));
        body.appendChild(h('ul', { class: 'fl-pst-ch' }, n.channels.map(function (ch) { return h('li', null, h('a', { href: urls.channel(ch.slug), text: ch.title })); })));
      }
      body.appendChild(h('p', { class: 'fl-small', text: 'only you see these numbers. your own views and taps never count.' }));
    }, function (e) { body.textContent = errText(e); });
    return w;
  }
  function noteHref(n) {
    var p = n.payload || {};
    if (n.type === 'block_connected' || n.type === 'picked' || n.type === 'milestone') return urls.block(p.block_id);
    if (n.type === 'weekly_recap') return '/pages/account?tab=posted';
    if (n.type === 'channel_new_blocks') return urls.channel(p.slug);
    if (n.type === 'post_not_published' || n.type === 'account_paused') return '/pages/account?tab=posted';
    if ((n.type === 'tag_suggested' || n.type === 'tag_confirmed') && p.block_id) return urls.block(p.block_id);
    if (p.handle) return urls.product(p.handle);
    return '/pages/account';
  }
  function accNotes(p) {
    rpc('my_notifications', { p_limit: 60 }).then(function (ns) {
      if (!ns.length) { p.appendChild(h('p', { class: 'fl-empty', text: 'nothing yet. post something people want to keep.' })); return; }
      var ul = h('ul', { class: 'fl-notes' });
      /* invites are gone (the site is open); old "you have more invites" notes stay hidden */
      ns.filter(function (n) { return n.type !== 'invites_unlocked'; }).forEach(function (n) {
        var copyFn = NOTE_COPY[n.type];
        var see = function (t) { return h('a', { href: noteHref(n), text: t }); };
        ul.appendChild(h('li', { class: 'fl-note' + (n.read_at ? '' : ' is-unread') },
          n.payload && n.payload.img ? h('img', { src: n.payload.img, alt: '' }) : h('span', { class: 'fl-ph' }),
          h('div', null, h('span', null, copyFn ? copyFn(n, see) : see(n.type)), h('time', { text: ago(n.created_at) }))));
      });
      p.appendChild(ul);
      if (me.unread) rpc('mark_notifications_read').then(function () { me.unread = 0; paintDot(); });
    });
  }

  /* share: your taste card, your personal link, and how many people joined through it. the link carries
     ?invite=you for attribution only; nobody needs it to get in. */
  function accShare(p) {
    var link = me.handle ? location.origin + '/?invite=' + encodeURIComponent(me.handle) : null;
    var stat = h('b', { text: '·' });
    p.appendChild(h('div', { class: 'fl-stats' }, h('div', { class: 'fl-stat' }, stat, h('span', { text: 'joined through your link' }))));
    var who = h('p', { class: 'fl-meta', hidden: true });
    p.appendChild(who);
    rpc('my_share').then(function (r) {
      stat.textContent = String((r && r.joined) || 0);
      if (r && r.recent && r.recent.length) { add(who, ['most recent: ', r.recent.map(function (x, i) { return [i ? ', ' : '', userLink(x)]; })]); who.hidden = false; }
    }, function () { stat.textContent = '0'; });
    if (!link) { p.appendChild(h('p', { class: 'fl-small', text: 'pick a handle first. your share link uses it.' })); return; }
    p.appendChild(h('p', { class: 'fl-meta' }, 'your link: ', h('a', { href: link, text: link.replace(/^https?:\/\//, '') })));
    var prev = h('img', { class: 'fl-card-prev', alt: 'your taste card', hidden: true });
    var status = h('p', { class: 'fl-small', text: 'drawing your taste card' });
    var btns = h('div', { class: 'fl-btns' },
      h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'copy link', on: { click: function (e) { copy(link); e.target.textContent = 'copied'; } } }));
    p.appendChild(btns); p.appendChild(status); p.appendChild(prev);
    Onboarding.drawCard().then(function (res) {
      var hasTaste = !!(me.taste_picks && me.taste_picks.picked && me.taste_picks.picked.length);
      status.textContent = hasTaste ? 'send it to friends. they see what you are into.' : 'this one is drawn from the feed. find your own taste and it becomes yours.';
      prev.src = res.url; prev.hidden = false;
      btns.appendChild(h('a', { class: 'fl-btn', href: res.url, download: 'my-taste.png', text: 'download card' }));
      btns.appendChild(h('button', { class: 'fl-btn', type: 'button', text: 'share card', on: { click: function () {
        var f = new File([res.blob], 'my-taste.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [f] })) navigator.share({ files: [f], text: 'how to get fly', url: res.link }).catch(function () {});
        else { copy(res.link); status.textContent = 'link copied.'; }
      } } }));
      if (!hasTaste) btns.appendChild(h('button', { class: 'fl-btn', type: 'button', text: 'find my taste', on: { click: function () { Onboarding.start('taste'); } } }));
    }, function () { status.textContent = ''; });
  }

  function accBrand(p) {
    rpc('brand_demand_for_me', { p_weeks: 12 }).then(function (d) {
      var t = d.totals || {};
      p.appendChild(h('p', { class: 'fl-small', text: 'private to you. what people do with ' + d.brand + ' on mien.' }));
      p.appendChild(h('div', { class: 'fl-stats' },
        [['saves', t.saves], ['channel saves', t.connections], ['wants', t.wants], ['blocks', t.blocks]].map(function (x) {
          return h('div', { class: 'fl-stat' }, h('b', { text: String(x[1] || 0) }), h('span', { text: x[0] }));
        })));
      var weeks = d.weeks || [];
      var max = Math.max.apply(null, weeks.map(function (w) { return w.saves + w.connections + w.wants; }).concat([1]));
      var bars = h('div', { class: 'fl-bars', role: 'img', 'aria-label': 'activity per week, last 12 weeks' });
      weeks.forEach(function (w) { var v = w.saves + w.connections + w.wants; bars.appendChild(h('i', { style: 'height:' + Math.round(v / max * 100) + '%', title: v + ' that week' })); });
      p.appendChild(bars);
      p.appendChild(h('p', { class: 'fl-small', text: 'saves + channel saves + wants, per week, last 12 weeks' }));
      if (d.pieces && d.pieces.length) {
        var tb = h('tbody');
        d.pieces.forEach(function (x) { tb.appendChild(h('tr', null, h('td', null, h('a', { href: urls.product(x.handle), text: x.title || x.handle })), h('td', { text: String(x.connections) }), h('td', { text: String(x.wants) }))); });
        p.appendChild(h('div', { class: 'fl-tablewrap' }, h('table', { class: 'fl-table' }, h('thead', null, h('tr', null, h('th', { text: 'piece' }), h('th', { text: 'channel saves' }), h('th', { text: 'wants' }))), tb)));
      }
      p.appendChild(h('div', { class: 'fl-btns' },
        h('a', { class: 'fl-btn fl-solid', href: '/pages/sell', text: 'list a piece to sell' }),
        h('button', { class: 'fl-btn', type: 'button', text: 'post to your archive', on: { click: function () { addWin(); } } }),
        h('a', { class: 'fl-btn', href: urls.brand(d.brand), text: 'see your archive' })));
    }, function (x) { p.appendChild(h('p', { class: 'fl-err', text: errText(x) })); });
  }

  function accSettings(p) {
    MIEN.profile().then(function (pr) {
      pr = pr || {};
      var name = h('input', { class: 'fl-in', type: 'text', maxlength: '60', value: pr.display_name || '' });
      var hd = h('input', { class: 'fl-in', type: 'text', maxlength: '24', value: pr.handle || '', autocapitalize: 'off' });
      var ig = h('input', { class: 'fl-in', type: 'text', maxlength: '60', value: '', placeholder: '@you', autocapitalize: 'off' });
      MIEN.sb.from('profiles').select('instagram').eq('id', me.id).maybeSingle().then(function (r) { if (r.data && r.data.instagram) ig.value = r.data.instagram; });
      var msg = h('p', { class: 'fl-ok', hidden: true });
      p.appendChild(h('form', { style: 'max-width:460px', on: { submit: function (e) {
        e.preventDefault(); msg.hidden = true; msg.className = 'fl-ok';
        var v = hd.value.trim().toLowerCase().replace(/^@/, '');
        if (v && !/^[a-z0-9._]{2,24}$/.test(v)) { msg.className = 'fl-err'; msg.textContent = errText('profiles_handle_format'); msg.hidden = false; return; }
        /* a pasted profile link becomes the bare handle: no https://instagram.com/, nothing after / ? or #, no @ */
        var igv = ig.value.trim().replace(/^(https?:\/\/)?(www\.)?instagram\.com\//i, '').replace(/[/?#].*$/, '').replace(/^@/, '');
        ig.value = igv;
        MIEN.setProfile({ display_name: name.value.trim() || null, handle: v || null, instagram: igv || null }).then(function (r) {
          if (r && r.error) { msg.className = 'fl-err'; msg.textContent = errText(r.error); } else msg.textContent = 'saved.';
          msg.hidden = false;
        });
      } } },
        h('label', { class: 'fl-lbl', text: 'handle' }), hd,
        h('label', { class: 'fl-lbl', text: 'name' }), name,
        h('label', { class: 'fl-lbl', text: 'instagram' }), ig, msg,
        h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'save' }))));
      /* the fly digest reads email_prefs.subscribed AND fly_weekly (its own switch; "weekly" is the
         thursday catalogue email). the browser may only touch the opt-in columns. */
      var dig = h('input', { type: 'checkbox' });
      var digMsg = h('span', { class: 'fl-small' });
      MIEN.sb.from('email_prefs').select('subscribed, fly_weekly').eq('user_id', me.id).maybeSingle().then(function (r) {
        dig.checked = !!(r.data && r.data.subscribed && r.data.fly_weekly);
      });
      dig.addEventListener('change', function () {
        var on = dig.checked;
        MIEN.sb.from('email_prefs').update(on ? { subscribed: true, fly_weekly: true, unsubscribed_at: null } : { fly_weekly: false })
          .eq('user_id', me.id).then(function (r) {
            if (r.error) { dig.checked = !on; digMsg.textContent = ' ' + errText(r.error); } else digMsg.textContent = on ? ' on.' : ' off.';
          });
      });
      p.appendChild(h('label', { class: 'fl-chk' }, dig, h('span', { text: 'weekly email digest: saves of your posts and new things in channels you follow' }), digMsg));
      p.appendChild(h('hr', { class: 'fl-rule' }));
      p.appendChild(h('div', { class: 'fl-btns' },
        h('a', { class: 'fl-btn', href: '/pages/taste?redo=1', text: 'redo my taste' }),
        h('button', { class: 'fl-btn', type: 'button', text: 'replay onboarding', on: { click: function () { Onboarding.start(); } } }),
        me.is_admin ? h('a', { class: 'fl-btn', href: '/pages/fly-admin', text: 'admin' }) : null,
        me.is_admin ? h('a', { class: 'fl-btn', href: '/pages/review', text: 'moderation' }) : null,
        h('button', { class: 'fl-btn', type: 'button', text: 'sign out', on: { click: function () { MIEN.signOut().then(function () { location.href = '/'; }); } } })));
    });
  }

  /* ------------------------------------------------------------------ takedown */
  views.takedown = function (root) {
    var block = qp('block') || '';
    var blk = h('input', { class: 'fl-in', type: 'text', value: block ? location.origin + urls.block(block) : '', placeholder: 'link to the block' });
    var email = h('input', { class: 'fl-in', type: 'email', required: true, placeholder: 'you@example.com' });
    var reason = h('textarea', { class: 'fl-ta', required: true, maxlength: '2000', placeholder: 'what is wrong, and if it is yours, how we can tell' });
    var mine = h('input', { type: 'checkbox' });
    var err = h('p', { class: 'fl-err', hidden: true });
    var btn = h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'send' });
    var form = h('form', { style: 'max-width:560px', on: { submit: function (e) {
      e.preventDefault(); err.hidden = true;
      var m = blk.value.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);
      btn.disabled = true;
      MIEN.sb.from('fly_takedowns').insert({ block_id: m ? m[0] : null, requester_email: email.value.trim(),
        reason: reason.value.trim() + (m ? '' : (blk.value ? '\n\nlink: ' + blk.value : '')), is_owner_claim: mine.checked }).then(function (r) {
        if (r.error) { btn.disabled = false; err.textContent = errText(r.error); err.hidden = false; return; }
        form.replaceWith(h('p', { class: 'fl-desc', text: 'got it. a person reads every one of these, usually within two days. if it is yours, it comes down.' }));
      });
    } } },
      h('label', { class: 'fl-lbl', text: 'which block' }), blk,
      h('label', { class: 'fl-lbl', text: 'your email' }), email,
      h('label', { class: 'fl-lbl', text: 'what is going on' }), reason,
      h('label', { class: 'fl-chk' }, mine, h('span', { text: 'this is mine. i own the rights to it.' })),
      err, h('div', { class: 'fl-btns' }, btn));
    root.appendChild(h('div', { class: 'fl-head' }, h('span', { class: 'fl-q', text: 'takedown' }), h('h1', { class: 'fl-h1', text: 'report a block' }),
      h('p', { class: 'fl-desc', text: 'everything on mien carries a source and a credit. if something here is yours and you want it gone, or it should not be here at all, tell us.' })));
    root.appendChild(form);
  };

  /* ------------------------------------------------------------------ moderation (admin)
     nobody approves posts by hand any more: the screen checks each one and it goes live or it doesn't. this is its
     log: whether it is keeping up and what it costs, what it kept off (put back anything it got wrong), what people
     reported, and the accounts it paused. on /pages/review and the admin tab of the same name */
  var OUTCOME_WORD = { reject: 'not posted', hard: 'blocked', remove: 'taken down', strip: 'text removed' };
  function moderationPanel(root) {
    var bodyEl = h('div');
    root.appendChild(h('div', { class: 'fl-head' }, h('span', { class: 'fl-q', text: 'moderation' }), h('h2', { class: 'fl-h2', text: 'what the screen did' }),
      h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn', type: 'button', text: 'refresh', on: { click: function () { load(); } } }))));
    root.appendChild(bodyEl);
    /* a button whose row turns into a small label ("restored", "kept") once its rpc lands. the label can be a function
       of the rpc's result that waits on a re-screen; a failure shows in err */
    function act(label, solid, call, doneLabel, row, err) {
      var b = h('button', { class: 'fl-btn' + (solid ? ' fl-solid' : ''), type: 'button', text: label });
      function lock(on) { Array.prototype.forEach.call(row.querySelectorAll('button'), function (x) { x.disabled = on; }); }
      b.addEventListener('click', function () {
        lock(true); err.hidden = true;
        call().then(function (res) { return typeof doneLabel === 'function' ? doneLabel(res) : doneLabel; })
          .then(function (t) { row.textContent = ''; row.appendChild(h('span', { class: 'fl-flag', text: t })); },
            function (x) { lock(false); err.textContent = errText(x); err.hidden = false; });
      });
      return b;
    }
    /* putting a post back hands it to the screen with the admin's word as the verdict (screen: true). it is up once
       that run says approved; otherwise the next sweep puts it up */
    function rescreen(id, upLabel, waitLabel) {
      return function (res) {
        if (res && res.ok === false) throw new Error("that didn't work. try again.");
        if (!res || !res.screen) return upLabel;
        return fn('screen', { block_id: res.block_id || id }).then(function (s) { return s && s.status === 'approved' ? upLabel : waitLabel; },
          function () { return waitLabel; });
      };
    }
    function health(hl) {
      var n = function (v) { return Number(v) || 0; };
      var paused = hl.paused_until && new Date(hl.paused_until).getTime() > Date.now();
      bodyEl.appendChild(h('p', { class: 'fl-meta', text: n(hl.pending) + ' checking now' + (n(hl.stuck) ? ' · ' + n(hl.stuck) + ' stuck' : '') +
        ' · ' + n(hl.screened_today) + ' checked today · ' + n(hl.rejected_today) + ' not posted · ' + n(hl.removed_today) + ' taken down · $' +
        n(hl.usd_today).toFixed(2) + ' of $' + n(hl.cap_usd) + (paused ? ' · paused until ' + day(hl.paused_until, true) : '') }));
      if (n(hl.stuck) > 0 || paused) bodyEl.appendChild(h('p', { class: 'fl-err', text: 'the screen is not keeping up: posts wait hidden until it can check them.' }));
    }
    function section(title, rows, mk, empty) {
      bodyEl.appendChild(h('h2', { class: 'fl-sec', text: title }));
      if (!rows.length) { bodyEl.appendChild(h('p', { class: 'fl-empty', text: empty })); return; }
      bodyEl.appendChild(h('div', { class: 'fl-rev' }, rows.map(function (r) { return mk(r); })));
    }
    function flags(list, bad) {
      return (list || []).map(function (x) { return h('span', { class: 'fl-flag' + (bad ? ' is-bad' : ''), text: String(x).replace(/_/g, ' ') }); });
    }
    /* what the screen kept off. a blocked (hard) post has had its file deleted: no picture, nothing to put back */
    function recentCard(r) {
      var word = OUTCOME_WORD[r.outcome] || r.outcome, isBlock = r.subject === 'block';
      var title = r.title || (isBlock ? 'untitled' : 'a ' + r.subject);
      var btns = h('div', { class: 'fl-btns' }), err = h('p', { class: 'fl-err', hidden: true });
      if (isBlock && r.outcome !== 'hard' && !r.overridden && (r.block_status === 'rejected' || r.block_status === 'removed')) {
        btns.appendChild(act('put it back', true, function () { return rpc('admin_restore_block', { p_id: r.subject_id }); },
          rescreen(r.subject_id, 'restored', 'restore pending'), btns, err));
      }
      return h('div', { class: 'fl-rev-card' },
        r.img && r.outcome !== 'hard' ? h('img', { src: r.img, alt: '', loading: 'lazy' }) : null,
        h('b', null, isBlock && r.block_status ? h('a', { href: urls.block(r.subject_id), target: '_blank', text: title }) : title),
        h('div', { class: 'fl-small' }, r.owner_handle ? userLink(r.owner_handle) : 'no owner', ' · ' + word + (isBlock || !r.title ? '' : ' · ' + r.subject) + ' · ' + ago(r.at)),
        (r.categories || []).length || r.overridden ? h('div', null, flags(r.categories, true), r.overridden ? h('span', { class: 'fl-flag', text: 'overridden' }) : null) : null,
        r.note ? h('p', { class: 'fl-small', text: r.note }) : null,
        btns.children.length ? btns : null, err);
    }
    /* reported blocks: each report already sent it back through the screen; this is the person's call on what is left */
    function reportCard(r) {
      var btns = h('div', { class: 'fl-btns' }), err = h('p', { class: 'fl-err', hidden: true });
      if (r.block_status !== 'removed') {
        btns.appendChild(act('take it down', true, function () { return rpc('admin_review_block', { p_id: r.block_id, p_decision: 'remove', p_note: 'taken down after reports' }); }, 'taken down', btns, err));
      }
      /* keep it also puts a post the reports hid back up, through the same re-screen as put it back. take it down is
         only the remove: clearing the reports after it would put the post back */
      btns.appendChild(act('keep it', false, function () { return rpc('admin_clear_reports', { p_block: r.block_id }); },
        rescreen(r.block_id, 'kept', 'kept'), btns, err));
      var cnt = Number(r.count) || 0;
      return h('div', { class: 'fl-rev-card' },
        r.img ? h('img', { src: r.img, alt: '', loading: 'lazy' }) : null,
        h('b', null, h('a', { href: urls.block(r.block_id), target: '_blank', text: r.title || 'untitled' })),
        h('div', { class: 'fl-small', text: cnt + (cnt === 1 ? ' report' : ' reports') + ' · last one ' + ago(r.last_at) +
          (r.block_status && r.block_status !== 'approved' ? ' · ' + (ST_LABEL[r.block_status] || r.block_status) : '') }),
        h('div', null, flags(r.reasons, false)),
        btns, err);
    }
    function paused(rows) {
      bodyEl.appendChild(h('h2', { class: 'fl-sec', text: 'paused accounts' }));
      if (!rows.length) { bodyEl.appendChild(h('p', { class: 'fl-empty', text: 'no one is paused.' })); return; }
      var tb = h('tbody');
      rows.forEach(function (u) {
        var cell = h('td'), err = h('p', { class: 'fl-err', hidden: true });
        cell.appendChild(act('lift', false, function () { return rpc('admin_set_suspension', { p_user: u.id, p_until: null }); }, 'lifted', cell, err));
        cell.appendChild(err);
        tb.appendChild(h('tr', null, h('td', null, userLink(u.handle)), h('td', { text: String(u.strikes || 0) }),
          h('td', { text: u.until ? day(u.until, true) : 'for good' }), cell));
      });
      bodyEl.appendChild(h('div', { class: 'fl-tablewrap' }, h('table', { class: 'fl-table' },
        h('thead', null, h('tr', null, ['account', 'strikes', 'until', ''].map(function (x) { return h('th', { text: x }); }))), tb)));
    }
    function load() {
      bodyEl.textContent = 'loading';
      rpc('admin_moderation', { p_limit: 120 }).then(function (m) {
        m = m || {};
        bodyEl.textContent = '';
        health(m.health || {});
        section('not posted or taken down', (m.recent || []).filter(function (r) { return r.outcome !== 'approve'; }), recentCard, 'nothing kept off lately.');
        section('reported', m.reports || [], reportCard, 'nothing reported.');
        paused(m.suspended || []);
      }, function (x) { bodyEl.textContent = ''; bodyEl.appendChild(h('p', { class: 'fl-err', text: errText(x) })); });
    }
    load();
  }

  views.review = function (root) {
    loadMe().then(function () { if (me && me.is_admin) { picksPanel(root); moderationPanel(root); } });
  };
  /* worth picking: the last 7 days' best clicks per view and connections. one tap picks (the poster is told) */
  function picksPanel(root) {
    var box = h('section', { class: 'fl-picks' }, h('h2', { class: 'fl-h2', text: 'worth a mien pick' }),
      h('p', { class: 'fl-small', text: 'the last 7 days: best clicks per view, then saves. buyable posts first among equals. a pick gets the "picked by mien" label on its tile and in the picked row, and the poster is told.' }));
    var grid = h('div', { class: 'fl-pst-grid' });
    box.appendChild(grid); root.appendChild(box);
    rpc('admin_pick_suggestions', { p_limit: 24 }).then(function (list) {
      if (!list.length) { grid.appendChild(h('p', { class: 'fl-empty', text: 'nothing has enough views yet.' })); return; }
      list.forEach(function (c) {
        var n = c.stats || {};
        var btn = h('button', { class: 'fl-btn', type: 'button', text: 'add to mien picks', on: { click: function () {
          rpc('fly_pick_block', { p_block: c.id, p_on: true }).then(function () { btn.textContent = 'in mien picks'; btn.classList.add('fl-solid'); btn.disabled = true; }, function (e) { toast(errText(e)); });
        } } });
        grid.appendChild(h('div', { class: 'fl-pst' },
          h('a', { class: 'fl-pst-im', href: urls.block(c.id) }, pic(c.img, 'fl-tile-img', '', c.w, c.h, '240px')),
          h('span', { class: 'fl-mono fl-pst-line', text: statLine(n) + (c.owner && c.owner.handle ? ' \u00b7 @' + c.owner.handle : '') }), btn));
      });
    }, function (e) { grid.appendChild(h('p', { class: 'fl-err', text: errText(e) })); });
  }

  /* ------------------------------------------------------------------ admin */
  views.admin = function (root) {
    loadMe().then(function () {
      if (!me || !me.is_admin) { root.appendChild(h('p', { class: 'fl-empty', text: 'admins only.' })); return; }
      root.appendChild(h('div', { class: 'fl-head' }, h('span', { class: 'fl-q', text: 'admin' }), h('h1', { class: 'fl-h1' }, 'how to get fly', h('span', { class: 'fl-tm', text: '™' }))));
      tabs(root, [
        { k: 'review', label: 'moderation', render: function (p) { moderationPanel(p); } },
        { k: 'seed', label: 'seeding', render: adminSeed },
        { k: 'taste', label: 'taste', render: adminTaste },
        { k: 'featured', label: 'featured', render: adminFeatured },
        { k: 'settings', label: 'settings', render: adminSettings },
        { k: 'brands', label: 'brands', render: adminBrands },
        { k: 'claims', label: 'claims', render: adminClaims },
        { k: 'takedowns', label: 'takedowns', render: adminTakedowns },
        { k: 'demand', label: 'demand', render: adminDemand },
        { k: 'funnel', label: 'funnel', render: adminFunnel },
        { k: 'bots', label: 'bots', render: function (p) { p.appendChild(h('p', { class: 'fl-meta' }, h('a', { href: '/pages/bots', text: 'open the bots page' }))); } }
      ]);
    });
  };

  function adminSeed(p) {
    var src = h('select', { class: 'fl-sel' },
      [['arena', 'are.na channels'], ['unsplash', 'unsplash search'], ['pinterest', 'pinterest pin urls'], ['native', 'native product photos'], ['catalog', 'curated catalogue (link-outs)']]
        .map(function (x) { return h('option', { value: x[0], text: x[1] }); }));
    var house = h('select', { class: 'fl-sel' }, h('option', { value: 'fly.guy.bot', text: '@fly.guy.bot' }), h('option', { value: 'mien.maker.bot', text: '@mien.maker.bot' }), h('option', { value: 'archive.bot', text: '@archive.bot' }));
    var chan = h('select', { class: 'fl-sel' });
    var input = h('textarea', { class: 'fl-ta', placeholder: 'are.na channel slugs or urls, one per line' });
    var limit = h('input', { class: 'fl-in', type: 'number', min: '1', max: '200', value: '30' });
    var newChan = h('input', { class: 'fl-in', type: 'text', placeholder: 'or make a new house channel', maxlength: '80' });
    var out = h('pre', { class: 'fl-small', style: 'white-space:pre-wrap' });
    var hint = h('p', { class: 'fl-small' });
    function hints() {
      var m = { arena: 'are.na channel slugs or urls, one per line. attribution and source links are kept.',
        unsplash: 'a search query. needs UNSPLASH_ACCESS_KEY set as a supabase secret.',
        pinterest: 'pin urls, one per line. stored as embeds, never rehosted.', native: 'extra photos of products that sell here.',
        catalog: 'per-brand count. already-imported images are skipped.' };
      hint.textContent = m[src.value]; input.hidden = src.value === 'native' || src.value === 'catalog';
      input.placeholder = src.value === 'unsplash' ? 'search words' : src.value === 'pinterest' ? 'https://www.pinterest.com/pin/...' : 'are-na-channel-slug';
    }
    src.addEventListener('change', hints); hints();
    function loadChans() {
      MIEN.sb.from('profiles').select('id, handle').eq('handle', house.value).maybeSingle().then(function (r) {
        if (!r.data) return;
        MIEN.sb.from('fly_channels').select('id, title').eq('owner_id', r.data.id).order('updated_at', { ascending: false }).then(function (c) {
          chan.textContent = ''; chan.appendChild(h('option', { value: '', text: 'no channel (pick one or make one)' }));
          (c.data || []).forEach(function (x) { chan.appendChild(h('option', { value: x.id, text: x.title })); });
        });
        house.setAttribute('data-id', r.data.id);
      });
    }
    house.addEventListener('change', loadChans); loadChans();
    var run = h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'run' });
    p.appendChild(h('form', { style: 'max-width:620px', on: { submit: function (e) {
      e.preventDefault(); run.disabled = true; out.textContent = 'running. scoring takes a few seconds per image.';
      var go = function (channelId) {
        var lines = input.value.split(/\n+/).map(function (s) { return s.trim(); }).filter(Boolean);
        var body = { source: src.value, house: house.value, channel_id: channelId || null, limit: Number(limit.value) || 30 };
        if (src.value === 'arena') body.channels = lines;
        if (src.value === 'unsplash') body.query = lines.join(' ');
        if (src.value === 'pinterest') body.urls = lines;
        if (src.value === 'catalog') { body.per_brand = Number(limit.value) || 40; body.auto_approve = true; }
        fn('fly-seed', body).then(function (r) {
          run.disabled = false; out.textContent = JSON.stringify(r, null, 2);
          /* seeded rows go through the same automatic screen as everything else */
          if (r && r.batch && !r.auto_approved) out.appendChild(h('a', { href: '/pages/review', text: '\nthe screen is checking this batch. see the moderation log' }));
        }, function () { run.disabled = false; out.textContent = 'failed'; });
      };
      if (newChan.value.trim()) {
        rpc('create_channel', { p_title: newChan.value.trim(), p_description: null, p_visibility: 'public', p_owner: house.getAttribute('data-id') })
          .then(function (ch) { go(ch.id); }, function (x) { run.disabled = false; out.textContent = errText(x); });
      } else go(chan.value);
    } } },
      h('label', { class: 'fl-lbl', text: 'source' }), src, hint,
      input,
      h('div', { class: 'fl-row' }, h('div', null, h('label', { class: 'fl-lbl', text: 'post as' }), house), h('div', null, h('label', { class: 'fl-lbl', text: 'how many' }), limit)),
      h('label', { class: 'fl-lbl', text: 'into channel' }), chan, newChan,
      h('div', { class: 'fl-btns' }, run)));
    p.appendChild(out);
    p.appendChild(h('hr', { class: 'fl-rule' }));
    p.appendChild(h('div', { class: 'fl-btns' },
      h('button', { class: 'fl-btn', type: 'button', text: 'sync native products now', on: { click: function (e) {
        e.target.textContent = 'syncing';
        fn('fly-sync', { action: 'all' }).then(function (r) { out.textContent = JSON.stringify(r, null, 2); e.target.textContent = 'sync native products now'; });
      } } })));
    var bl = h('ol', { class: 'fl-ol' });
    p.appendChild(h('p', { class: 'fl-meta' }, h('span', { class: 'fl-q', text: 'batches' })));
    p.appendChild(bl);
    rpc('admin_seed_batches').then(function (bs) {
      bs.slice(0, 30).forEach(function (b) {
        bl.appendChild(h('li', null, (b.source || 'seed') + ', ' + b.total + ' total, ' + b.pending + ' checking' + (b.channel ? ', into ' + b.channel : '') + ', ' + ago(b.started) + ' ',
          b.pending ? h('a', { href: '/pages/review', text: 'moderation log' }) : null));
      });
    });
  }

  function adminTaste(p) {
    var doc = h('textarea', { class: 'fl-ta', style: 'min-height:260px' });
    var msg = h('p', { class: 'fl-ok', hidden: true });
    var refs = h('div', { class: 'fl-mini' });
    var file = h('input', { type: 'file', accept: 'image/jpeg,image/png,image/webp', multiple: true });
    var paths = [];
    MIEN.sb.from('fly_taste').select('doc, reference_paths').eq('id', 1).single().then(function (r) {
      doc.value = (r.data && r.data.doc) || ''; paths = (r.data && r.data.reference_paths) || []; paintRefs();
    });
    function paintRefs() {
      refs.textContent = '';
      paths.forEach(function (pt) {
        MIEN.sb.storage.from('fly-taste').createSignedUrl(pt, 600).then(function (s) {
          var img = h('img', { src: s.data && s.data.signedUrl, alt: '', title: 'tap to remove', style: 'cursor:pointer' });
          img.addEventListener('click', function () {
            if (!confirm('remove this reference image?')) return;
            paths = paths.filter(function (x) { return x !== pt; });
            MIEN.sb.storage.from('fly-taste').remove([pt]);
            save(); paintRefs();
          });
          refs.appendChild(img);
        });
      });
    }
    function save() {
      return MIEN.sb.from('fly_taste').update({ doc: doc.value, reference_paths: paths, updated_at: new Date().toISOString() }).eq('id', 1)
        .then(function (r) { msg.className = r.error ? 'fl-err' : 'fl-ok'; msg.textContent = r.error ? errText(r.error) : 'saved.'; msg.hidden = false; });
    }
    file.addEventListener('change', function () {
      var fs = Array.prototype.slice.call(file.files || []);
      Promise.all(fs.map(function (f) {
        var pt = 'ref-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7) + '.' + (f.type.split('/')[1] || 'jpg');
        return MIEN.sb.storage.from('fly-taste').upload(pt, f, { contentType: f.type }).then(function (r) { if (!r.error) paths.push(pt); });
      })).then(function () { save(); paintRefs(); });
    });
    p.appendChild(h('p', { class: 'fl-small', text: 'the taste doc. the content check on every user post and the seeding scorer both read it. the first three reference images go along with every seeding score.' }));
    p.appendChild(doc);
    p.appendChild(h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'save doc', on: { click: save } })));
    p.appendChild(msg);
    p.appendChild(h('label', { class: 'fl-lbl', text: 'reference images' }));
    p.appendChild(file);
    p.appendChild(refs);
  }

  function adminFeatured(p) {
    p.appendChild(h('p', { class: 'fl-small', text: 'featured channels sit in the row at the top of the feed.' }));
    MIEN.sb.from('fly_channels').select('id, title, slug, is_featured, updated_at, owner_id').eq('visibility', 'public').order('is_featured', { ascending: false }).order('updated_at', { ascending: false }).limit(200)
      .then(function (r) {
        var tb = h('tbody');
        (r.data || []).forEach(function (c) {
          var cb = h('input', { type: 'checkbox' }); cb.checked = c.is_featured;
          cb.addEventListener('change', function () { MIEN.sb.from('fly_channels').update({ is_featured: cb.checked }).eq('id', c.id).then(function (x) { if (x.error) cb.checked = !cb.checked; }); });
          tb.appendChild(h('tr', null, h('td', null, cb), h('td', null, h('a', { href: urls.channel(c.slug), text: c.title })), h('td', { text: ago(c.updated_at) })));
        });
        p.appendChild(h('div', { class: 'fl-tablewrap' }, h('table', { class: 'fl-table' }, h('thead', null, h('tr', null, h('th', { text: 'featured' }), h('th', { text: 'channel' }), h('th', { text: 'updated' }))), tb)));
      });
  }

  function adminSettings(p) {
    MIEN.sb.from('fly_settings').select('*').eq('id', 1).single().then(function (r) {
      var s = r.data || {};
      var gate = h('input', { type: 'checkbox' }); gate.checked = !!s.invite_gate_on;
      var emb = h('input', { class: 'fl-in', type: 'number', step: '0.01', min: '0', max: '1', value: s.embed_max_share });
      var prod = h('input', { class: 'fl-in', type: 'number', step: '0.01', min: '0', max: '1', value: s.product_min_share });
      var cap = h('input', { class: 'fl-in', type: 'number', min: '1', max: '500', value: s.daily_post_cap });
      /* what the automatic screen may spend a day; the moderation tab shows today's spend against it */
      var screenUsd = h('input', { class: 'fl-in', type: 'number', step: '0.5', min: '0', max: '500', value: s.screen_daily_usd });
      var msg = h('p', { class: 'fl-ok', hidden: true });
      p.appendChild(h('form', { style: 'max-width:460px', on: { submit: function (e) {
        e.preventDefault();
        var upd = { invite_gate_on: gate.checked, embed_max_share: Number(emb.value), product_min_share: Number(prod.value),
          daily_post_cap: Number(cap.value), updated_at: new Date().toISOString() };
        /* an empty box (the column not loaded) must never save a $0 budget */
        if (screenUsd.value !== '') upd.screen_daily_usd = Number(screenUsd.value);
        MIEN.sb.from('fly_settings').update(upd).eq('id', 1)
          .then(function (x) { msg.className = x.error ? 'fl-err' : 'fl-ok'; msg.textContent = x.error ? errText(x.error) : 'saved.'; msg.hidden = false; });
      } } },
        h('label', { class: 'fl-chk' }, gate, h('span', { text: 'invite gate on (new accounts need an invite code)' })),
        h('label', { class: 'fl-lbl', text: 'pinterest embeds, max share of any feed page (0 to 1)' }), emb,
        h('label', { class: 'fl-lbl', text: 'products, min share of any feed page (0 to 1)' }), prod,
        h('label', { class: 'fl-lbl', text: 'posts per person per day' }), cap,
        h('label', { class: 'fl-lbl', text: 'screening budget a day ($)' }), screenUsd,
        msg, h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'save' }))));
    });
  }

  function adminBrands(p) {
    var who = h('input', { class: 'fl-in', type: 'text', placeholder: 'handle or email' });
    var vendor = h('input', { class: 'fl-in', type: 'text', placeholder: 'shopify vendor name, exactly' });
    var isBrand = h('input', { type: 'checkbox' }); var trusted = h('input', { type: 'checkbox' });
    var out = h('p', { class: 'fl-ok', hidden: true });
    p.appendChild(h('p', { class: 'fl-small', text: 'make an approved sell-intake brand a brand account. its product blocks move from @mien.maker to it, and it gets a private demand tab.' }));
    p.appendChild(h('form', { style: 'max-width:460px', on: { submit: function (e) {
      e.preventDefault();
      var flags = { is_brand: isBrand.checked, trusted_brand: trusted.checked };
      if (vendor.value.trim()) flags.brand_vendor = vendor.value.trim();
      rpc('admin_set_user_flags', { p_handle: who.value.trim().replace(/^@/, ''), p: flags }).then(function (r) {
        out.className = 'fl-ok'; out.textContent = 'saved: ' + JSON.stringify(r); out.hidden = false;
      }, function (x) { out.className = 'fl-err'; out.textContent = errText(x); out.hidden = false; });
    } } },
      h('label', { class: 'fl-lbl', text: 'account' }), who,
      h('label', { class: 'fl-lbl', text: 'vendor' }), vendor,
      h('label', { class: 'fl-chk' }, isBrand, h('span', { text: 'brand account' })),
      h('label', { class: 'fl-chk' }, trusted, h('span', { text: 'trusted brand' })),
      out,
      h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'save' }))));
  }

  function adminClaims(p) {
    p.appendChild(h('p', { class: 'fl-small', text: 'brands people keep tagging that are not on mien. most tagged first. this is your outreach list.' }));
    MIEN.sb.from('fly_brand_claims').select('*').order('tag_count', { ascending: false }).limit(300).then(function (r) {
      var rows = r.data || [];
      if (!rows.length) { p.appendChild(h('p', { class: 'fl-empty', text: 'no unsigned brand has been tagged yet.' })); return; }
      var tb = h('tbody');
      rows.forEach(function (c) {
        var cb = h('input', { type: 'checkbox' }); cb.checked = c.contacted;
        cb.addEventListener('change', function () { MIEN.sb.from('fly_brand_claims').update({ contacted: cb.checked }).eq('brand_tag', c.brand_tag); });
        tb.appendChild(h('tr', null, h('td', null, h('a', { href: urls.brand(c.brand_tag), text: c.brand_tag })), h('td', { text: String(c.tag_count) }),
          h('td', { text: ago(c.first_tagged_at) }), h('td', null, cb), h('td', { text: c.claimed_by ? 'claimed' : '' })));
      });
      p.appendChild(h('div', { class: 'fl-tablewrap' }, h('table', { class: 'fl-table' },
        h('thead', null, h('tr', null, ['brand', 'tags', 'first tagged', 'contacted', ''].map(function (x) { return h('th', { text: x }); }))), tb)));
    });
  }

  function adminTakedowns(p) {
    MIEN.sb.from('fly_takedowns').select('*').order('created_at', { ascending: false }).limit(200).then(function (r) {
      var rows = r.data || [];
      if (!rows.length) { p.appendChild(h('p', { class: 'fl-empty', text: 'no takedown requests.' })); return; }
      var ul = h('ul', { class: 'fl-notes' });
      rows.forEach(function (t) {
        var li = h('li', { style: 'padding:12px 0;border-bottom:1px solid #000' },
          h('p', { class: 'fl-meta' }, h('b', { text: t.status }), ' · ' + ago(t.created_at) + ' · ' + t.requester_email + (t.is_owner_claim ? ' · says it is theirs' : '')),
          h('p', { class: 'fl-small', style: 'white-space:pre-wrap', text: t.reason }),
          t.block_id ? h('a', { href: urls.block(t.block_id), target: '_blank', text: 'see the block' }) : null,
          t.status === 'open' ? h('div', { class: 'fl-btns' },
            h('button', { class: 'fl-btn fl-solid', type: 'button', text: 'take it down', on: { click: function () { rpc('admin_takedown_action', { p_id: t.id, p_remove: true }).then(function () { li.remove(); }); } } }),
            h('button', { class: 'fl-btn', type: 'button', text: 'dismiss', on: { click: function () { rpc('admin_takedown_action', { p_id: t.id, p_remove: false }).then(function () { li.remove(); }); } } })) : null);
        ul.appendChild(li);
      });
      p.appendChild(ul);
    });
  }

  function adminDemand(p) {
    rpc('admin_brand_demand', { p_days: 30 }).then(function (rows) {
      var tb = h('tbody');
      rows.forEach(function (r) { tb.appendChild(h('tr', null, h('td', null, h('a', { href: urls.brand(r.brand), text: r.brand })),
        ['saves', 'connections', 'wants', 'blocks'].map(function (k) { return h('td', { text: String(r[k]) }); }))); });
      p.appendChild(h('p', { class: 'fl-small', text: 'last 30 days, per brand tag.' }));
      p.appendChild(h('div', { class: 'fl-tablewrap' }, h('table', { class: 'fl-table' },
        h('thead', null, h('tr', null, ['brand', 'saves', 'channel saves', 'wants', 'blocks'].map(function (x) { return h('th', { text: x }); }))), tb)));
    });
  }

  function adminFunnel(p) {
    rpc('admin_signup_funnel', { p_days: 30 }).then(function (f) {
      var rows = f.steps || [];
      if (f.campaigns && f.campaigns.length) {
        var cb = h('tbody');
        f.campaigns.forEach(function (c) {
          cb.appendChild(h('tr', null, h('td', { text: c.campaign }), h('td', { text: String(c.starts) }), h('td', { text: String(c.completions) }), h('td', { text: String(c.signups) })));
        });
        p.appendChild(h('p', { class: 'fl-small', text: 'by campaign (utm_campaign of the link they came in on), last 30 days. starts = saw the taste picks, completions = reached the taste card.' }));
        p.appendChild(h('div', { class: 'fl-tablewrap' }, h('table', { class: 'fl-table' },
          h('thead', null, h('tr', null, ['campaign', 'onboarding starts', 'completions', 'signups'].map(function (x) { return h('th', { text: x }); }))), cb)));
      }
      if (!rows.length) { p.appendChild(h('p', { class: 'fl-empty', text: 'no onboarding sessions in the last 30 days.' })); return; }
      var first = rows[0].views || 1;
      var tb = h('tbody');
      rows.forEach(function (r) {
        tb.appendChild(h('tr', null, h('td', { text: r.step }), h('td', { text: String(r.views) }), h('td', { text: String(r.completes) }),
          h('td', { text: String(r.skips) }), h('td', { text: Math.round(r.completes / first * 100) + '%' })));
      });
      p.appendChild(h('p', { class: 'fl-small', text: 'sessions per onboarding step, last 30 days. the last column is completes as a share of everyone who saw step one.' }));
      p.appendChild(h('div', { class: 'fl-tablewrap' }, h('table', { class: 'fl-table' },
        h('thead', null, h('tr', null, ['step', 'saw it', 'did it', 'skipped', 'of start'].map(function (x) { return h('th', { text: x }); }))), tb)));
    });
  }

  /* ------------------------------------------------------------------ bots (admin) */
  var BOT_SOURCES = [['shop', 'brand stores (buyable)'], ['brand', 'mien catalogue imagery (buyable)'], ['wikimedia', 'wikimedia commons'],
    ['arena', 'are.na'], ['unsplash', 'unsplash (needs a key)'], ['pinterest', 'pinterest queue'],
    ['rijks', 'rijksmuseum (off by default)'], ['met', 'the met (off by default)'], ['artic', 'art institute of chicago (off by default)']];
  /* a table whose headers sort it (numbers high first, words a to z) */
  function sortTable(cols, rows, cell) {
    var tb = h('tbody'), key = null, dir = 1;
    function paint() {
      tb.textContent = '';
      var rs = rows.slice();
      if (key) rs.sort(function (a, b) {
        var x = a[key], y = b[key];
        if (typeof x === 'number' || typeof y === 'number') return ((Number(y) || 0) - (Number(x) || 0)) * dir;
        return String(x || '').localeCompare(String(y || '')) * dir;
      });
      rs.forEach(function (r) { tb.appendChild(h('tr', null, cols.map(function (c) { return h('td', null, cell(r, c[0])); }))); });
    }
    var head = h('tr', null, cols.map(function (c) {
      return h('th', null, h('button', { class: 'fl-link', type: 'button', text: c[1], on: { click: function () { dir = key === c[0] ? -dir : 1; key = c[0]; paint(); } } }));
    }));
    paint();
    return h('div', { class: 'fl-tablewrap' }, h('table', { class: 'fl-table' }, h('thead', null, head), tb));
  }
  /* brands bots may read: proposals from the bots and from people's brand tags land here; nothing is fetched
     from a domain until it is approved */
  function brandSources(box) {
    box.textContent = '';
    var dom = h('input', { class: 'fl-in', type: 'text', placeholder: 'domain, like noahny.com' });
    var nm = h('input', { class: 'fl-in', type: 'text', placeholder: 'brand name' });
    var msg = h('span', { class: 'fl-small' });
    box.appendChild(h('form', { class: 'fl-row', style: 'max-width:640px', on: { submit: function (e) {
      e.preventDefault();
      if (!dom.value.trim() || !nm.value.trim()) return;
      rpc('admin_add_brand_source', { p_domain: dom.value, p_brand_name: nm.value }).then(function () { brandSources(box); }, function (x) { msg.textContent = ' ' + errText(x); });
    } } }, dom, nm, h('button', { class: 'fl-btn', type: 'submit', text: 'add' }), msg));
    rpc('admin_brand_sources').then(function (rows) {
      box.appendChild(sortTable([['brand_name', 'brand'], ['domain', 'domain'], ['status', 'status'], ['proposed_by', 'from'], ['posted', 'posted'],
        ['products_seen', 'seen'], ['notes', 'notes'], ['act', '']], rows, function (r, k) {
        if (k === 'domain') return h('a', { href: 'https://' + r.domain, target: '_blank', rel: 'noopener', text: r.domain });
        if (k === 'notes') {
          var ev = r.evidence && (r.evidence.why || r.evidence.from) ? ' ' + (r.evidence.why || '') + (r.evidence.from ? ' (' + r.evidence.from + ')' : '') : '';
          return (r.last_error ? 'last error: ' + r.last_error + '. ' : '') + (r.notes || '') + ev + (r.platform !== 'shopify' ? ' not shopify.' : '');
        }
        if (k === 'act') {
          var set = function (st) { return function () { rpc('admin_set_brand_source', { p_id: r.id, p_status: st }).then(function () { brandSources(box); }); }; };
          return h('span', null,
            r.status !== 'approved' ? h('button', { class: 'fl-link', type: 'button', text: 'approve', on: { click: set('approved') } }) : null,
            r.status !== 'approved' && r.status !== 'rejected' ? ' · ' : null,
            r.status !== 'rejected' ? h('button', { class: 'fl-link', type: 'button', text: 'reject', on: { click: set('rejected') } }) : null);
        }
        return r[k] == null ? '' : String(r[k]);
      }));
    }, function (x) { box.appendChild(h('p', { class: 'fl-err', text: errText(x) })); });
  }
  /* the outreach list: what each link-out brand gets from mien */
  function brandLeverage(box) {
    rpc('admin_brand_leverage').then(function (rows) {
      if (!rows.length) { box.appendChild(h('p', { class: 'fl-empty', text: 'no link-out brands yet.' })); return; }
      box.appendChild(h('p', { class: 'fl-small', text: 'per brand: blocks live on the feed, pieces in the catalogue, saves and channel saves by people (not bots), wants, and clicks out to the brand. sort by any column.' }));
      box.appendChild(sortTable([['brand', 'brand'], ['live', 'live'], ['pieces', 'pieces'], ['saves', 'saves'], ['wants', 'wants'], ['connections', 'channel saves'],
        ['clicks_7d', 'clicks 7d'], ['clicks_30d', 'clicks 30d'], ['source_status', 'bots']], rows, function (r, k) {
        if (k === 'brand') return h('a', { href: urls.brand(r.brand), text: r.brand });
        return r[k] == null ? '' : String(r[k]);
      }));
    }, function (x) { box.appendChild(h('p', { class: 'fl-err', text: errText(x) })); });
  }
  /* stores the bots proposed, six of their pieces each, approve or reject in one tap */
  function proposals(box) {
    box.textContent = '';
    rpc('admin_brand_proposals').then(function (rows) {
      if (!rows.length) { box.appendChild(h('div', { class: 'empty-line' }, h('p', { text: 'no stores waiting. the bots propose new ones every day.' }))); return; }
      rows.forEach(function (r) {
        var ev = r.evidence || {};
        var err = h('p', { class: 'fl-err', hidden: true });
        var set = function (st) { return function () {
          yes.disabled = true; no.disabled = true; err.hidden = true;
          rpc('admin_set_brand_source', { p_id: r.id, p_status: st }).then(function () { card.remove(); if (!box.children.length) proposals(box); },
            function (x) { yes.disabled = false; no.disabled = false; err.textContent = errText(x); err.hidden = false; });
        }; };
        var yes = h('button', { class: 'btn-primary', type: 'button', text: 'approve' }), no = h('button', { class: 'btn-secondary', type: 'button', text: 'reject' });
        yes.addEventListener('click', set('approved')); no.addEventListener('click', set('rejected'));
        var pics = (r.preview || []).slice(0, 6);
        var card = h('div', { class: 'fl-prop' },
          h('div', { class: 'fl-prop-h' }, h('a', { class: 'fl-h3', href: 'https://' + r.domain, target: '_blank', rel: 'noopener', text: r.brand_name || r.domain }),
            h('span', { class: 'fl-mono', text: r.domain + (ev.why ? ' · ' + ev.why : '') + (ev.from ? ' · from ' + ev.from : '') })),
          pics.length ? h('div', { class: 'fl-prop-row' }, pics.map(function (x) {
            return h('a', { class: 'fl-plain fl-prop-im', href: safeUrl(x.url) || '#', target: '_blank', rel: 'noopener', title: x.title },
              h('img', { src: x.img + (String(x.img).indexOf('?') > -1 ? '&' : '?') + 'width=240', alt: x.title || '', loading: 'lazy' }),
              x.price ? h('span', { class: 'fl-tile-price', text: money(x.price, 'USD') }) : null);
          })) : h('p', { class: 'fl-mono', text: r.preview_at ? 'no pieces could be read (robots.txt or an empty store).' : 'samples come within the hour.' }),
          h('div', { class: 'fl-btns' }, yes, no), err);
        box.appendChild(card);
      });
    }, function (x) { box.appendChild(h('p', { class: 'fl-err', text: errText(x) })); });
  }
  /* how big the index is, per brand, category and type: the gaps are the sourcing list */
  function indexStats(box) {
    rpc('admin_index_stats').then(function (st) {
      box.appendChild(h('div', { class: 'fl-stats' }, [['searchable', st.searchable], ['in the index', st.index_live], ['sold out', st.index_sold_out],
        ['gone', st.index_gone], ['embedded', st.index_embedded + ' of ' + st.index], ['index in the feed', st.index_in_feed], ['in the feed', st.in_feed]]
        .map(function (x) { return h('div', { class: 'fl-stat' }, h('b', { text: String(x[1] == null ? '-' : x[1]) }), h('span', { text: x[0] })); })));
      var cats = st.categories || {};
      box.appendChild(h('p', { class: 'fl-meta', text: Object.keys(cats).sort(function (a, b) { return cats[b] - cats[a]; }).map(function (k) { return k + ': ' + cats[k]; }).join(' · ') }));
      box.appendChild(h('h3', { class: 'fl-h3', text: 'by type' }));
      box.appendChild(sortTable([['type', 'type'], ['category', 'category'], ['n', 'pieces']], st.types || [], function (r, k) { return String(r[k] == null ? '' : r[k]); }));
      box.appendChild(h('h3', { class: 'fl-h3', text: 'by brand' }));
      box.appendChild(sortTable([['brand', 'brand'], ['domain', 'domain'], ['live', 'live'], ['sold_out', 'sold out'], ['in_feed', 'in feed'], ['index_full_at', 'last full read'], ['index_error', 'error']],
        st.brands || [], function (r, k) { return k === 'index_full_at' ? (r[k] ? ago(r[k]) : '') : String(r[k] == null ? '' : r[k]); }));
    }, function (x) { box.appendChild(h('p', { class: 'fl-err', text: errText(x) })); });
  }
  /* what people search for; few or no results is the sourcing to-do list */
  function searchStats(box) {
    rpc('admin_search_stats', { p_days: 30 }).then(function (st) {
      box.appendChild(h('p', { class: 'fl-meta', text: 'last 30 days: ' + st.searches + ' searches, ' + st.queries + ' different queries. ' +
        (st.median_ms != null ? 'median ' + st.median_ms + 'ms, p95 ' + st.p95_ms + 'ms uncached; ' : '') + Math.round((st.cached_share || 0) * 100) + '% served from the cache.' }));
      var cols = [['q', 'query'], ['n', 'times'], ['results', 'results'], ['clicks', 'taps']];
      var cell = function (r, k) { return k === 'q' ? h('a', { href: '/?q=' + encodeURIComponent(r.q), text: r.q }) : String(r[k] == null ? '' : r[k]); };
      [['top searches', st.top], ['few results (the sourcing list)', st.few], ['no results', st.zero]].forEach(function (x) {
        box.appendChild(h('h3', { class: 'fl-h3', text: x[0] }));
        box.appendChild((x[1] || []).length ? sortTable(cols, x[1], cell) : h('p', { class: 'fl-mono', text: 'none yet.' }));
      });
    }, function (x) { box.appendChild(h('p', { class: 'fl-err', text: errText(x) })); });
  }
  function piecesStats(box) {
    rpc('admin_pieces_like_stats', { p_days: 30 }).then(function (st) {
      var ctr = st.impressions ? Math.round(st.taps / st.impressions * 1000) / 10 + '%' : '-';
      box.appendChild(h('p', { class: 'fl-meta', text: 'last 30 days: ' + st.impressions + ' times seen, ' + st.taps + ' taps, ' + ctr + ' tapped.' }));
      if (st.by_brand && st.by_brand.length) box.appendChild(sortTable([['brand', 'brand'], ['impressions', 'seen'], ['taps', 'taps']], st.by_brand,
        function (r, k) { return String(r[k] == null ? '' : r[k]); }));
    }, function () {});
  }
  views.bots = function (root) {
    loadMe().then(function () {
      if (!me || !me.is_admin) { root.appendChild(h('p', { class: 'fl-empty', text: 'admins only.' })); return; }
      root.appendChild(h('div', { class: 'fl-head' }, h('span', { class: 'fl-q', text: 'admin' }), h('h1', { class: 'fl-h1', text: 'bots' }),
        h('p', { class: 'fl-desc', text: 'bot accounts look for things on their own about every half hour, post the best into their channels, and are labelled as bots everywhere. about 70% of what they post is buyable (pieces from approved brand stores and the catalogue), the rest is inspiration. a cheap first pass screens everything, the judge scores the best, and they stop at the daily budget, spread through the day.' })));
      var global = h('div'); root.appendChild(global);
      var list = h('div', { class: 'fl-bots' }); root.appendChild(list);
      root.appendChild(h('h2', { class: 'fl-sec', text: 'stores to approve' }));
      var propBox = h('div'); root.appendChild(propBox);
      root.appendChild(h('h2', { class: 'fl-sec', text: 'the index' }));
      var idxBox = h('div'); root.appendChild(idxBox);
      root.appendChild(h('h2', { class: 'fl-sec', text: 'search' }));
      var srchBox = h('div'); root.appendChild(srchBox);
      proposals(propBox); indexStats(idxBox); searchStats(srchBox);
      root.appendChild(h('h2', { class: 'fl-sec', text: 'brands the bots read' }));
      var srcBox = h('div'); root.appendChild(srcBox);
      root.appendChild(h('h2', { class: 'fl-sec', text: 'brand leverage' }));
      var levBox = h('div'); root.appendChild(levBox);
      root.appendChild(h('h2', { class: 'fl-sec', text: 'pieces like this' }));
      var plBox = h('div'); root.appendChild(plBox);
      brandSources(srcBox); brandLeverage(levBox); piecesStats(plBox);
      root.appendChild(h('h2', { class: 'fl-sec', text: 'recent activity' }));
      var logBox = h('div', { class: 'fl-tablewrap' }); root.appendChild(logBox);

      Promise.all([
        MIEN.sb.from('fly_settings').select('bots_enabled, bot_auto_threshold, bot_share_max, bot_daily_usd, bot_judge_model, bot_screen_threshold').eq('id', 1).single(),
        rpc('admin_bot_spend')
      ]).then(function (res) {
        var st = res[0].data || {}, sp = res[1] || {};
        var on = h('input', { type: 'checkbox' }); on.checked = !!st.bots_enabled;
        function num(v, min, max, step) { return h('input', { class: 'fl-in', type: 'number', required: true, min: min, max: max, step: step || '1', value: v }); }
        var auto = num(st.bot_auto_threshold, '50', '100'), scr = num(st.bot_screen_threshold, '0', '100');
        var share = num(st.bot_share_max, '0', '1', '0.05'), usd = num(st.bot_daily_usd, '0', '200', '0.5');
        var model = h('select', { class: 'fl-sel' }, h('option', { value: 'claude-opus-5-5', text: 'opus 5.5 (best taste)' }), h('option', { value: 'claude-sonnet-5-5', text: 'sonnet 5.5 (about half the cost)' }));
        model.value = st.bot_judge_model || 'claude-opus-5-5';
        var msg = h('span', { class: 'fl-small' });
        global.appendChild(h('form', { class: 'fl-botcard', on: { submit: function (e) {
          e.preventDefault();
          if (!res[0].data) { msg.textContent = ' the settings did not load. reload first.'; return; }
          MIEN.sb.from('fly_settings').update({ bots_enabled: on.checked, bot_auto_threshold: Number(auto.value),
            bot_share_max: Number(share.value), bot_daily_usd: Number(usd.value), bot_judge_model: model.value, bot_screen_threshold: Number(scr.value),
            updated_at: new Date().toISOString() }).eq('id', 1)
            .then(function (x) { msg.textContent = x.error ? ' ' + errText(x.error) : ' saved.'; });
        } } },
          h('p', { class: 'fl-meta', text: 'today: $' + (sp.today || 0) + ' spent of $' + (st.bot_daily_usd || 0) + ', ' + (sp.calls_today || 0) + ' model calls, ' +
            (sp.posted_today || 0) + ' posted. last 7 days: $' + (sp.week || 0) + '.' }),
          h('label', { class: 'fl-chk' }, on, h('span', { text: 'bots on (the global switch: off stops every bot)' })),
          h('div', { class: 'fl-row' },
            h('div', null, h('label', { class: 'fl-lbl', text: 'daily budget, $' }), usd),
            h('div', null, h('label', { class: 'fl-lbl', text: 'judge' }), model),
            h('div', null, h('label', { class: 'fl-lbl', text: 'first pass keeps at score' }), scr)),
          h('div', { class: 'fl-row' },
            h('div', null, h('label', { class: 'fl-lbl', text: 'auto-post at score' }), auto),
            h('div', null, h('label', { class: 'fl-lbl', text: 'max bot share of a feed page' }), share)),
          h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'save' }), msg)));
      });

      function leadsBox(b) {
        var box = h('div', { class: 'fl-leads' });
        var lines = h('textarea', { class: 'fl-ta', placeholder: 'one per line. a plain line searches every museum source and wikimedia.\nor aim it: rijks: type=poster, wikicat: Work clothing, met: q=jacket&departmentId=8, brand: Parra' });
        var lmsg = h('span', { class: 'fl-small' });
        var table = h('div', { class: 'fl-tablewrap' });
        function load() {
          rpc('admin_bot_leads', { p_bot: b.id }).then(function (rows) {
            table.textContent = '';
            var tb = h('tbody');
            rows.slice(0, 60).forEach(function (l) {
              var tog = h('button', { class: 'fl-link', type: 'button', text: l.retired ? 'bring back' : 'retire', on: { click: function () {
                rpc('admin_update_lead', { p_id: l.id, p_retired: !l.retired }).then(load);
              } } });
              tb.appendChild(h('tr', { class: l.retired ? 'is-off' : null }, h('td', { text: l.kind }), h('td', { text: l.ref }), h('td', { text: l.origin }),
                h('td', { text: String(l.tries) }), h('td', { text: String(l.posted) }), h('td', { text: l.avg != null ? String(l.avg) : '' }), h('td', null, tog)));
            });
            table.appendChild(h('table', { class: 'fl-table' },
              h('thead', null, h('tr', null, ['source', 'search', 'from', 'looks', 'posted', 'avg score', ''].map(function (x) { return h('th', { text: x }); }))), tb));
            if (rows.length > 60) table.appendChild(h('p', { class: 'fl-small', text: 'showing 60 of ' + rows.length + '.' }));
          });
        }
        box.appendChild(h('label', { class: 'fl-lbl', text: 'add places to look' }));
        box.appendChild(lines);
        box.appendChild(h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn', type: 'button', text: 'add', on: { click: function () {
          var ls_ = lines.value.split(/\n+/).map(function (x) { return x.trim(); }).filter(Boolean);
          if (!ls_.length) return;
          rpc('admin_add_leads', { p_bot: b.id, p_lines: ls_ }).then(function (n) { lmsg.textContent = ' added ' + n + '.'; lines.value = ''; load(); },
            function (x) { lmsg.textContent = ' ' + errText(x); });
        } } }), lmsg));
        box.appendChild(h('label', { class: 'fl-lbl', text: 'where it looks (best first; weak ones retire on their own, strong finds add new ones)' }));
        box.appendChild(table);
        load();
        return box;
      }

      function card(b) {
        var on = h('input', { type: 'checkbox' }); on.checked = !!b.enabled;
        var persona = h('textarea', { class: 'fl-ta', maxlength: '600' }); persona.value = b.persona || '';
        var pins = h('textarea', { class: 'fl-ta', placeholder: 'https://www.pinterest.com/pin/...' }); pins.value = (b.pin_queue || []).join('\n');
        var srcBox = h('div', { class: 'fl-srcs' });
        var srcInputs = {};
        BOT_SOURCES.forEach(function (x) {
          var cb = h('input', { type: 'checkbox' });
          cb.checked = b.sources ? b.sources[x[0]] !== false : true;
          srcInputs[x[0]] = cb;
          srcBox.appendChild(h('label', { class: 'fl-chk' }, cb, h('span', { text: x[1] })));
        });
        function num(v, max) { return h('input', { class: 'fl-in', type: 'number', required: true, min: '0', max: max, step: '1', value: v }); }
        var cp = num(b.daily_posts, '500'), cr = num(b.posts_per_run, '20'), cc = num(b.daily_connects, '500'), ch = num(b.daily_channels, '20');
        /* an empty field keeps the stored value instead of saving 0 */
        function n(el) { return el.value === '' ? null : Number(el.value); }
        var t = b.today || {}, w = b.week || {}, ld = b.leads || {};
        var msg = h('span', { class: 'fl-small' });
        var out = h('pre', { class: 'fl-small fl-botout', hidden: true });
        var run = h('button', { class: 'fl-btn', type: 'button', text: 'run now' });
        run.addEventListener('click', function () {
          run.disabled = true; run.textContent = 'running'; out.hidden = false; out.textContent = 'looking, screening, judging, posting. about 10 to 60 seconds.';
          fn('bot-run', { bot: b.id, force: true }).then(function (r) {
            run.disabled = false; run.textContent = 'run now'; out.textContent = JSON.stringify(r, null, 2); loadLog();
          }, function () { run.disabled = false; run.textContent = 'run now'; out.textContent = 'failed'; });
        });
        return h('form', { class: 'fl-botcard', on: { submit: function (e) {
          e.preventDefault();
          var sources = {}; Object.keys(srcInputs).forEach(function (k) { sources[k] = srcInputs[k].checked; });
          rpc('admin_update_bot', { p_id: b.id, p: {
            enabled: on.checked, persona: persona.value.trim(), sources: sources,
            pin_queue: pins.value.split(/\n+/).map(function (x) { return x.trim(); }).filter(Boolean),
            daily_posts: n(cp), posts_per_run: n(cr), daily_connects: n(cc), daily_channels: n(ch) } })
            .then(function () { msg.textContent = ' saved.'; }, function (x) { msg.textContent = ' ' + errText(x); });
        } } },
          h('div', { class: 'fl-botcard-h' }, h('h2', { class: 'fl-h2' }, userLink(b.handle)),
            h('label', { class: 'fl-chk' }, on, h('span', { text: 'on' }))),
          h('p', { class: 'fl-meta', text: 'today: ' + (t.posted || 0) + ' posted, ' + (t.dropped || 0) + ' passed on, ' +
            (t.connected || 0) + ' saved into channels, ' + (t.created || 0) + ' channels, $' + (b.usd_today || 0) + '. this week: ' + (w.posted || 0) + ' posted.' +
            (b.last_run_at ? ' last ran ' + ago(b.last_run_at) + '.' : '') + ' ' + (ld.active || 0) + ' places to look (' + (ld.grown || 0) + ' it found itself).' }),
          h('p', { class: 'fl-meta' }, h('a', { href: urls.user(b.handle), text: 'its public page' })),
          h('label', { class: 'fl-lbl', text: 'persona' }), persona,
          h('label', { class: 'fl-lbl', text: 'sources' }), srcBox,
          h('div', { class: 'fl-row' },
            h('div', null, h('label', { class: 'fl-lbl', text: 'posts a day' }), cp),
            h('div', null, h('label', { class: 'fl-lbl', text: 'posts a run' }), cr),
            h('div', null, h('label', { class: 'fl-lbl', text: 'channel saves a day' }), cc),
            h('div', null, h('label', { class: 'fl-lbl', text: 'new channels a day' }), ch)),
          h('label', { class: 'fl-lbl', text: 'pinterest queue (pin urls, one per line; posted as embeds, never rehosted)' }), pins,
          h('div', { class: 'fl-btns' }, h('button', { class: 'fl-btn fl-solid', type: 'submit', text: 'save' }), run, msg), out,
          leadsBox(b));
      }
      rpc('admin_bots').then(function (bots) {
        if (!bots.length) { list.appendChild(h('p', { class: 'fl-empty', text: 'no bots yet. the first scheduled run creates them.' })); return; }
        bots.forEach(function (b) { list.appendChild(card(b)); });
      }, function (x) { list.appendChild(h('p', { class: 'fl-err', text: errText(x) })); });

      function loadLog() {
        rpc('admin_bot_log', { p_limit: 150 }).then(function (rows) {
          logBox.textContent = '';
          var tb = h('tbody');
          rows.filter(function (r) { return r.action !== 'run'; }).forEach(function (r) {
            var d = r.detail || {};
            var note = d.reason || d.why || d.title || d.error || d.channel || '';
            var src = safeUrl(r.url);
            tb.appendChild(h('tr', null, h('td', { text: ago(r.at) }), h('td', null, userLink(r.bot)), h('td', { text: r.action }),
              h('td', { text: r.outcome }), h('td', { text: r.score != null ? String(r.score) : '' }), h('td', { text: r.provider || '' }),
              h('td', null, d.block ? h('a', { href: urls.block(d.block), text: 'block' }) : (src ? h('a', { href: src, target: '_blank', rel: 'noopener', text: hostOf(src) }) : ''), note ? ' ' + note : '')));
          });
          logBox.appendChild(h('table', { class: 'fl-table' },
            h('thead', null, h('tr', null, ['when', 'bot', 'action', 'outcome', 'score', 'source', 'what'].map(function (x) { return h('th', { text: x }); }))), tb));
        });
      }
      loadLog();
    });
  };

  /* ------------------------------------------------------------------ onboarding */
  /* ------------------------------------------------------------------ onboarding
     four screens, each skippable, progress as 1/4: what mien is, five this-or-that taps, one real action (save
     three or post one, never forced; signed out, keeping the saves is where the account gets made), then the taste
     card and the feed, now ranked for you. "how mien works" in the menu reopens screen one as a window. */
  var ABOUT_LINES = ['post cool things you find, with where to buy them.', 'save them into your own channels.', 'everything here links to where you can buy it.', 'your posts get you seen. you\'ll see every click.'];
  function howWin() {
    var w = win('how mien works', h('div', { class: 'fl-how' },
      h('p', { class: 'fl-how-t' }, ['find it.', 'save it.', 'buy it.'].map(function (l) { return h('span', { text: l }); })),
      h('ul', { class: 'fl-how-l' }, ABOUT_LINES.map(function (l) { return h('li', { text: l }); })),
      h('div', { class: 'fl-btns' },
        h('button', { class: 'btn-primary', type: 'button', text: 'find my taste', on: { click: function () { w.close(); Onboarding.start('taste'); } } }),
        h('button', { class: 'btn-secondary', type: 'button', text: 'close', on: { click: function () { w.close(); } } }))));
  }
  var Onboarding = (function () {
    var STEPS = ['what', 'taste', 'action', 'card', 'edit'];
    var ROUNDS = 5;
    var el = null, body = null, stepLbl = null, skipBtn = null, state = null;
    function sk() { var k = ss('fly_onb_sk'); if (!k) { k = Math.random().toString(36).slice(2, 12); ss('fly_onb_sk', k); } return k; }
    /* the campaign a signup would record (mien-supabase.js picks source and campaign from the same visit) */
    function campaign() {
      var c = null;
      try { c = MIEN.signupMeta ? MIEN.signupMeta().signup_campaign : null; } catch (e) {}
      if (!c) try { var l = JSON.parse(ls('fly_signup_utm') || 'null'); c = l && l.campaign; } catch (e) {}
      return c ? String(c).slice(0, 120) : null;
    }
    function log(step, action) {
      try { MIEN.sb.from('fly_onboarding_events').insert({ session_key: sk(), user_id: me ? me.id : null, step: step, action: action, campaign: campaign() }).then(function () {}); } catch (e) {}
    }
    function close(toFeed) {
      if (el) el.remove(); el = null; document.documentElement.style.overflow = '';
      if (toFeed) {
        if (document.querySelector('[data-fly-view="feed"]')) document.dispatchEvent(new CustomEvent('fly:taste'));
        else location.href = '/';
      }
    }
    function shell() {
      if (el) el.remove();
      stepLbl = h('span', { class: 'fl-onb-step' });
      body = h('div', { class: 'fl-onb-body' });
      skipBtn = h('button', { class: 'fl-link fl-mono', type: 'button', text: 'skip', on: { click: function () { skip(); } } });
      el = h('div', { class: 'fl-onb', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'get started' },
        h('div', { class: 'fl-onb-bar' }, stepLbl, skipBtn,
          h('button', { class: 'fl-win-btn', type: 'button', 'aria-label': 'close', text: '×', on: { click: function () { skip(true); } } })),
        body);
      document.body.appendChild(el);
      document.documentElement.style.overflow = 'hidden';
    }
    function skip(all) {
      log(state.step, 'skip');
      var i = STEPS.indexOf(state.step);
      if (all === true || i === STEPS.length - 1) { close(true); return; }
      go(STEPS[i + 1]);
    }
    function go(step) {
      state.step = step;
      var i = STEPS.indexOf(step);
      stepLbl.textContent = (i + 1) + '/' + STEPS.length;
      body.textContent = '';
      body.scrollTop = 0;
      log(step, 'view');
      ({ what: what, taste: taste, action: action, card: card, edit: edit })[step]();
    }

    /* 1/4: what mien is */
    function what() {
      body.appendChild(h('h2', { class: 'fl-onb-h fl-how-t' }, ['find it.', 'save it.', 'buy it.'].map(function (l) { return h('span', { text: l }); })));
      body.appendChild(h('ul', { class: 'fl-how-l' }, ABOUT_LINES.map(function (l) { return h('li', { text: l }); })));
      body.appendChild(h('div', { class: 'fl-btns' }, h('button', { class: 'btn-primary fl-onb-go', type: 'button', text: 'start', on: { click: function () { log('what', 'complete'); go('taste'); } } })));
    }

    /* 2/4: five this-or-that taps */
    function taste() {
      body.appendChild(h('h2', { class: 'fl-onb-h', text: 'this or that' }));
      var count = h('p', { class: 'fl-mono' });
      var prog = h('div', { class: 'fl-prog' }, h('i', { style: 'width:0%' }));
      var pair = h('div', { class: 'fl-pair' });
      body.appendChild(count); body.appendChild(prog); body.appendChild(pair);
      rpc('fly_taste_deck', { p_n: 20 }).then(function (deck) {
        state.deck = deck; state.picks = [];
        var round = 0, rounds = Math.min(ROUNDS, Math.floor(deck.length / 2));
        if (!rounds) { go('action'); return; }
        function show() {
          if (round >= rounds) { log('taste', 'complete'); saveTaste(); go('action'); return; }
          count.textContent = 'tap the one you would keep. ' + (round + 1) + ' of ' + rounds;
          prog.firstChild.style.width = (round / rounds * 100) + '%';
          pair.textContent = '';
          [deck[round * 2], deck[round * 2 + 1]].forEach(function (c) {
            pair.appendChild(h('button', { class: 'fl-pick', type: 'button', 'aria-label': c.title || c.brand || 'this one', on: { click: function () {
              state.picks.push(c); round++; show();
            } } }, h('img', { src: sized(c.img, 600), alt: '' })));
          });
        }
        show();
      });
    }
    function tasteSummary() {
      var brands = {}, cats = {};
      (state.picks || []).forEach(function (c) { if (c.brand) brands[c.brand] = (brands[c.brand] || 0) + 1; if (c.category) cats[c.category] = (cats[c.category] || 0) + 1; });
      return { picked: (state.picks || []).map(function (c) { return c.id; }), brands: brands, categories: cats, at: new Date().toISOString() };
    }
    function saveTaste() {
      var t = tasteSummary();
      if (!t.picked.length) return;
      ls('fly_taste_picks', JSON.stringify(t));
      if (me) rpc('fly_save_taste', { p_picks: t }).catch(function () {});
    }

    /* 3/4: one real thing. save three (into a "my taste" channel that starts with the picks) or post one */
    function action() {
      body.appendChild(h('h2', { class: 'fl-onb-h', text: 'do one thing' }));
      body.appendChild(h('p', { class: 'fl-mono', text: 'save three you like, or post one thing you found. or skip.' }));
      var counter = h('p', { class: 'fl-mono fl-onb-count' });
      var grid = h('div', { class: 'fl-pair is-three' });
      var keep = h('div', { class: 'fl-onb-keep', hidden: true });
      var saved = [];
      body.appendChild(h('div', { class: 'fl-btns' }, h('button', { class: 'btn-primary fl-onb-go', type: 'button', text: '+ post one thing', on: { click: function () {
        requireMember(function () {
          ensureChannel().then(function () {
            /* a post the screen said no to is not the one thing yet: stay here to try again or save three */
            addWin({ channelId: state.channel && state.channel.id, onPosted: function (card) { if (card.status === 'rejected') return; log('action', 'complete'); go('card'); } });
          });
        });
      } } })));
      body.appendChild(counter); body.appendChild(grid); body.appendChild(keep);
      function paint() { counter.textContent = 'or save three: ' + saved.length + ' of 3'; }
      paint();
      function done() {
        log('action', 'complete');
        if (me) { setTimeout(function () { go('card'); }, 300); return; }
        accountForm(keep, saved);
      }
      var fill = function (list) {
        list.slice(0, 9).forEach(function (c) {
          var b = h('button', { class: 'fl-pick', type: 'button', 'aria-label': 'save this', 'aria-pressed': 'false' }, h('img', { src: sized(c.img, 400), alt: '' }), h('span', { class: 'fl-pick-s', text: 'saved' }));
          b.addEventListener('click', function () {
            if (b.disabled || saved.length >= 3) return;
            b.disabled = true; b.setAttribute('aria-pressed', 'true');
            saved.push(c); paint();
            if (me) ensureChannel().then(function () {
              if (state.channel) return rpc('fly_onboarding_connect', { p_block: c.id, p_channel: state.channel.id });
            }).catch(function () {});
            if (saved.length >= 3) done();
          });
          grid.appendChild(b);
        });
      };
      var deck = (state.deck || []).filter(function (c) { return (state.picks || []).indexOf(c) === -1; });
      if (deck.length >= 9) fill(deck); else rpc('fly_taste_deck', { p_n: 12 }).then(fill);
    }
    /* the "my taste" channel, made once from the picks */
    function ensureChannel() {
      if (state.channel || !me || !me.can_act) return Promise.resolve(state.channel);
      var ids = (state.picks || []).map(function (c) { return c.id; });
      if (!ids.length) return rpc('my_channels').then(function (chs) { state.channel = chs.filter(function (c) { return !c.is_default; })[0] || null; return state.channel; });
      return rpc('fly_build_taste_channel', { p_blocks: ids }).then(function (ch) { state.channel = ch; return ch; }, function () { return null; });
    }
    /* signed out: keeping the saves makes the account. the picks and saves wait on this device until the
       email is confirmed, then build the channel (finishPendingOnboarding) */
    function accountForm(box, saved) {
      box.hidden = false; box.textContent = '';
      var email = h('input', { class: 'fl-in', type: 'email', autocomplete: 'email', placeholder: 'email' });
      var pw = h('input', { class: 'fl-in', type: 'password', autocomplete: 'new-password', placeholder: 'password, 6 or more' });
      var hd = h('input', { class: 'fl-in', type: 'text', maxlength: '24', autocapitalize: 'off', placeholder: 'handle' });
      var err = h('p', { class: 'fl-err', hidden: true });
      var btn = h('button', { class: 'btn-primary', type: 'submit', text: 'keep them' });
      var code = (ls('fly_invite') || '').trim();
      box.appendChild(h('p', { class: 'fl-onb-sub', text: 'keep your saves' }));
      box.appendChild(h('form', { on: { submit: function (e) {
        e.preventDefault(); err.hidden = true;
        var handle = hd.value.trim().toLowerCase().replace(/^@/, '');
        if (!/^[a-z0-9._]{2,24}$/.test(handle)) { err.textContent = errText('profiles_handle_format'); err.hidden = false; return; }
        if (pw.value.length < 6) { err.textContent = 'passwords are 6 or more characters.'; err.hidden = false; return; }
        btn.disabled = true; btn.textContent = 'one sec';
        MIEN.sb.from('profiles').select('id').eq('handle', handle).maybeSingle().then(function (r) {
          if (r && r.data) throw { message: 'profiles_handle_key' };
          return MIEN.signUp(email.value.trim(), pw.value, { invite: code });
        }).then(function (r) {
          if (r && r.error) throw r.error;
          var ids = (state.picks || []).concat(saved).map(function (c) { return c.id; });
          ls('fly_pending_onb', JSON.stringify({ ids: ids, title: 'my taste', code: code, handle: handle }));
          if (!r.data || !r.data.session) {
            box.textContent = '';
            box.appendChild(h('p', { class: 'fl-onb-sub', text: 'check your email' }));
            box.appendChild(h('p', { class: 'fl-mono', text: 'confirm your address, then come back. your saves wait on this device.' }));
            box.appendChild(h('div', { class: 'fl-btns' }, h('button', { class: 'btn-primary', type: 'button', text: 'see my card', on: { click: function () { go('card'); } } })));
            return;
          }
          return loadMe().then(finishPendingOnboarding).then(function (ch) { if (ch) state.channel = ch; go('card'); });
        }).catch(function (x) { btn.disabled = false; btn.textContent = 'keep them'; err.textContent = errText(x); err.hidden = false; });
      } } },
        h('label', { class: 'fl-lbl', text: 'email' }), email,
        h('label', { class: 'fl-lbl', text: 'password' }), pw,
        h('label', { class: 'fl-lbl', text: 'handle' }), hd,
        err, h('div', { class: 'fl-btns' }, btn,
          h('button', { class: 'btn-secondary', type: 'button', text: 'later', on: { click: function () { go('card'); } } }),
          h('button', { class: 'fl-link fl-mono', type: 'button', text: 'i have an account', on: { click: function () {
            MienAuthModal.open({ mode: 'signin', onSuccess: function () { loadMe().then(function () {
              ensureChannel().then(function () {
                return Promise.all(saved.map(function (c) { return state.channel ? rpc('fly_onboarding_connect', { p_block: c.id, p_channel: state.channel.id }).catch(function () {}) : null; }));
              }).then(function () { saveTaste(); go('card'); });
            }); } });
          } } }))));
      box.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    /* 4/4: the taste card and the link to share it, then the feed */
    function card() {
      body.appendChild(h('h2', { class: 'fl-onb-h', text: 'your card' }));
      var prev = h('img', { class: 'fl-card-prev', alt: 'your taste card' });
      var status = h('p', { class: 'fl-mono', text: 'drawing it' });
      var btns = h('div', { class: 'fl-btns' });
      body.appendChild(status); body.appendChild(prev); body.appendChild(btns);
      skipBtn.hidden = true;
      var p = me ? rpc('fly_finish_onboarding', { p_picks: tasteSummary().picked.length ? tasteSummary() : null }).then(function (s) { me = s; }) : Promise.resolve();
      p.then(function () { return drawCard(); }).then(function (res) {
        status.textContent = res.plain ? 'some images would not draw, so this one is type only.' : 'send it to friends. they see what you are into.';
        prev.src = res.url;
        btns.appendChild(h('button', { class: 'btn-primary', type: 'button', text: 'share', on: { click: function () {
          var f = new File([res.blob], 'my-taste.png', { type: 'image/png' });
          if (navigator.canShare && navigator.canShare({ files: [f] })) navigator.share({ files: [f], text: 'my taste on mien', url: res.link }).catch(function () {});
          else { copy(res.link); status.textContent = 'link copied.'; }
        } } }));
        btns.appendChild(h('a', { class: 'btn-secondary', href: res.url, download: 'my-taste.png', text: 'save the image' }));
        btns.appendChild(h('button', { class: 'btn-secondary', type: 'button', text: 'next', on: { click: function () { log('card', 'complete'); go('edit'); } } }));
      });
    }
    /* 5/5, optional: drop a few things and get an edit. skip goes straight to the feed */
    function edit() {
      skipBtn.hidden = false;
      body.appendChild(h('h2', { class: 'fl-onb-h', text: 'shop your taste' }));
      body.appendChild(h('p', { class: 'fl-how-l', text: 'drop 5 to 10 things you\'d wear or own, and we\'ll build you an edit. or skip it, it lives in the search bar too.' }));
      var box = h('div'); body.appendChild(box);
      TasteDrop(box, { onResult: function (r) { ss('fly_taste_last', JSON.stringify(r)); log('edit', 'complete'); location.href = '/pages/taste'; } });
    }
    function loadImg(src) {
      return new Promise(function (res) {
        var i = new Image(); i.crossOrigin = 'anonymous';
        i.onload = function () { res(i); }; i.onerror = function () { res(null); };
        i.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'fly=1';
      });
    }
    function loadQR() {
      if (window.QRCode) return Promise.resolve();
      return new Promise(function (res) {
        var s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
        s.onload = res; s.onerror = res; document.head.appendChild(s);
      });
    }
    function drawCard() {
      var handle = me && me.handle ? me.handle : null;
      /* the card points at your taste page (2026-10-27), still carrying ?invite= for attribution */
      var link = location.origin + (handle ? urls.user(handle) + '&invite=' + encodeURIComponent(handle) : '/');
      var picks = (state && state.picks && state.picks.length) ? state.picks : [];
      /* outside onboarding the card uses the picks saved on the profile, else six from the feed */
      var saved = (me && me.taste_picks && me.taste_picks.picked) || [];
      var getPicks = picks.length ? Promise.resolve(picks)
        : saved.length ? Promise.all(saved.slice(0, 6).map(function (id) { return rpc('get_block', { p_id: id }).catch(function () { return null; }); }))
            .then(function (cs) { cs = cs.filter(Boolean); return cs.length ? cs : rpc('fly_taste_deck', { p_n: 6 }); })
        : rpc('fly_taste_deck', { p_n: 6 });
      return Promise.all([getPicks.then(function (ps) { return Promise.all(ps.slice(0, 6).map(function (c) { return loadImg(c.img); })).then(function (imgs) { return { ps: ps, imgs: imgs }; }); }), loadQR()])
        .then(function (r) { return paint(r[0].ps, r[0].imgs, true).catch(function () { return paint(r[0].ps, [], false); }); });
      function paint(ps, imgs, withImgs) {
        var cv = document.createElement('canvas'); cv.width = 1080; cv.height = 1920;
        var x = cv.getContext('2d');
        x.fillStyle = '#fff'; x.fillRect(0, 0, 1080, 1920);
        x.fillStyle = '#000';
        x.font = '36px "Courier Prime", "Courier New", monospace';
        x.fillText('mien', 64, 110);
        x.fillText(new Date().toLocaleDateString('en-US', { month: 'short', year: 'numeric' }).toLowerCase(), 760, 110);
        x.fillRect(64, 140, 952, 3);
        x.font = '800 132px "Helvetica Neue", Helvetica, Arial, sans-serif';
        var who = handle ? '@' + handle : 'my';
        x.fillText(who.length > 13 ? who.slice(0, 13) : who, 56, 300);
        x.fillText('taste', 56, 430);
        var gw = 308, gh = 390, g = 14, y0 = 500;
        if (withImgs) {
          imgs.forEach(function (im, i) {
            if (!im) return;
            var cx = 64 + (i % 3) * (gw + g), cy = y0 + Math.floor(i / 3) * (gh + g);
            var s = Math.max(gw / im.width, gh / im.height), w = im.width * s, hh = im.height * s;
            x.save(); x.beginPath();
            if (x.roundRect) x.roundRect(cx, cy, gw, gh, 14); else x.rect(cx, cy, gw, gh);
            x.clip(); x.drawImage(im, cx + (gw - w) / 2, cy + (gh - hh) / 2, w, hh); x.restore();
          });
        } else {
          x.strokeStyle = '#000'; x.lineWidth = 3;
          for (var i = 0; i < 6; i++) x.strokeRect(64 + (i % 3) * (gw + g), y0 + Math.floor(i / 3) * (gh + g), gw, gh);
        }
        var ly = y0 + 2 * (gh + g) + 60;
        x.fillRect(64, ly - 40, 952, 3);
        /* outside onboarding there is no state: the taste saved on the profile names the card */
        var t = (state && state.picks && state.picks.length) ? tasteSummary() : ((me && me.taste_picks) || {});
        t = { brands: t.brands || {}, categories: t.categories || {} };
        var top = Object.keys(t.brands).sort(function (a, b) { return t.brands[b] - t.brands[a]; }).concat(Object.keys(t.categories)).slice(0, 4);
        if (!top.length) top = ps.map(function (c) { return c.brand || c.category; }).filter(Boolean).slice(0, 4);
        x.font = '40px "Courier Prime", "Courier New", monospace';
        top.forEach(function (w, i) { x.fillText((i + 1) + '. ' + String(w).slice(0, 26), 64, ly + 30 + i * 58); });
        var qy = 1640;
        x.fillRect(64, qy - 30, 952, 3);
        x.font = '34px "Courier Prime", "Courier New", monospace';
        x.fillText('"share"', 64, qy + 40);
        x.font = '30px "Courier Prime", "Courier New", monospace';
        var shown = link.replace(/^https?:\/\//, '');
        x.fillText(shown.slice(0, 34), 64, qy + 100);
        if (shown.length > 34) x.fillText(shown.slice(34, 68), 64, qy + 142);
        x.fillText('scan or type it.', 64, qy + 220);
        try {
          if (window.QRCode) {
            var holder = document.createElement('div');
            new QRCode(holder, { text: link, width: 240, height: 240, colorDark: '#000000', colorLight: '#ffffff' });
            var qc = holder.querySelector('canvas');
            if (qc) x.drawImage(qc, 776, qy + 16, 240, 240);
          }
        } catch (e) {}
        return new Promise(function (res, rej) {
          try {
            cv.toBlob(function (blob) { if (!blob) { rej(new Error('blob')); return; } res({ blob: blob, url: URL.createObjectURL(blob), link: link, plain: !withImgs }); }, 'image/png');
          } catch (e) { rej(e); }
        });
      }
    }

    function start(at) {
      state = { step: null, picks: [], deck: null, channel: null };
      shell();
      (meReady || loadMe()).then(function () {
        if (at === 'card') { go('card'); return; }
        if (me && me.taste_picks && at === 'action') { go('action'); return; }
        go(at === 'taste' ? 'taste' : 'what');
      });
    }
    return { start: start, drawCard: drawCard, resumeAt: function (step, ch) { state = { step: null, picks: [], deck: null, channel: ch || null }; shell(); go(step); } };
  })();

  /* an account made in step two that needed an email confirmation finishes here */
  function finishPendingOnboarding() {
    var raw = ls('fly_pending_onb');
    if (!raw || !me) return Promise.resolve(null);
    var p; try { p = JSON.parse(raw); } catch (e) { ls('fly_pending_onb', null); return Promise.resolve(null); }
    ls('fly_pending_onb', null);
    ls('fly_invite', null); /* the pending record carries the code; the boot claim must not send it twice */
    var chain = Promise.resolve();
    if (p.code && !me.can_act) chain = chain.then(function () { return rpc('claim_invite', { p_code: p.code }).catch(function () {}); });
    if (p.handle && !me.handle) chain = chain.then(function () { return MIEN.setHandle(p.handle); });
    var taste = ls('fly_taste_picks');
    if (taste) chain = chain.then(function () { try { return rpc('fly_save_taste', { p_picks: JSON.parse(taste) }); } catch (e) {} });
    var ch = null;
    chain = chain.then(function () { return loadMe(); }).then(function () {
      if (!me.can_act || !p.ids || !p.ids.length) return null;
      return rpc('fly_build_taste_channel', { p_blocks: p.ids }).then(function (c) {
        ch = c;
        if (p.title && p.title !== 'my taste') return MIEN.sb.from('fly_channels').update({ title: p.title.slice(0, 80) }).eq('id', c.id);
      });
    }).then(function () { return ch; }, function () { return ch; });
    return chain;
  }

  /* ------------------------------------------------------------------ chrome: fab, nudge bar, nav dot */
  /* the floating + post button is gone (2026-10-26): posting lives in the side menu, so this is a no-op */
  function fab() {}
  function nudgeBar(inviteCode) {
    if (ls('fly_nudge_off') && Date.now() - Number(ls('fly_nudge_off')) < 7 * 864e5) return;
    var shown = false;
    function show(inviter) {
      if (shown || me) return; shown = true;
      var bar = h('div', { class: 'fl-bar' },
        h('p', { class: 'fl-mono' }, inviter ? ['shared by ', userLink(inviter), '. five taps to your taste.'] : 'new here? five taps to your taste.'),
        h('button', { class: 'btn-primary', type: 'button', text: 'start', on: { click: function () { bar.remove(); Onboarding.start(); } } }),
        h('button', { class: 'fl-win-btn', type: 'button', 'aria-label': 'dismiss', text: '×', style: 'border:1.5px solid #000', on: { click: function () {
          bar.remove(); ls('fly_nudge_off', String(Date.now()));
        } } }));
      document.body.appendChild(bar);
    }
    (meReady || loadMe()).then(function () {
      if (me) return;
      var inviterP = inviteCode ? rpc('get_invite', { p_code: inviteCode }).then(function (r) { return r && r.valid ? r.inviter : null; }, function () { return null; }) : Promise.resolve(null);
      inviterP.then(function (inviter) {
        var t = setTimeout(function () { show(inviter); }, inviter ? 12000 : 25000);
        var onScroll = function () { if (window.scrollY > window.innerHeight * (inviter ? 1.2 : 2.5)) { clearTimeout(t); window.removeEventListener('scroll', onScroll); show(inviter); } };
        window.addEventListener('scroll', onScroll, { passive: true });
      });
    });
  }
  function paintDot() {
    /* the menu's "you" group or its join button, now that we know */
    document.documentElement.classList.toggle('mhd-in', !!me);
    /* the account card at the top of the menu: your initial (or picture), name and handle */
    if (me) {
      var nm = me.name || (me.handle ? '@' + me.handle : 'your account');
      Array.prototype.forEach.call(document.querySelectorAll('[data-mhd-name]'), function (el) { el.textContent = nm; });
      Array.prototype.forEach.call(document.querySelectorAll('[data-mhd-handle]'), function (el) { el.textContent = me.handle && me.name ? '@' + me.handle : 'view your account'; });
      Array.prototype.forEach.call(document.querySelectorAll('[data-mhd-av]'), function (el) {
        el.textContent = '';
        if (safeUrl(me.avatar)) el.appendChild(h('img', { src: me.avatar, alt: '', style: 'width:100%;height:100%;object-fit:cover' }));
        else el.textContent = String(me.handle || me.name || 'm').replace(/^@/, '').charAt(0);
      });
    }
    var on = !!(me && me.unread > 0);
    var menu = document.querySelector('.mhd-menu');
    if (menu) menu.classList.toggle('fl-has-dot', on);
    Array.prototype.forEach.call(document.querySelectorAll('a.mhd-ov-item[data-mhd-here="notifications"]'), function (a) {
      var d = a.querySelector('.fl-dot');
      if (on && !d) a.appendChild(h('span', { class: 'fl-dot', 'aria-label': 'new notifications' }));
      if (!on && d) d.remove();
    });
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    var inv = qp('invite');
    if (inv) { var ic = inv.trim().toLowerCase(); if (ls('fly_invite') !== ic) { ls('fly_invite', ic); ls('fly_invite_at', String(Date.now())); } }
    /* ?start=1 (the onboarding entry link) opens the taste picks straight away, once */
    var startOnb = qp('start') === '1';
    if (startOnb) { try { var su = new URL(location.href); su.searchParams.delete('start'); history.replaceState(history.state, '', su.pathname + su.search + su.hash); } catch (e) {} }
    whenMien(function () {
      loadMe().then(function () {
        /* someone who already found their taste just gets the feed */
        if (startOnb && (!me || (!me.onboarded && !me.is_house)) && !document.querySelector('.fl-onb')) {
          ss('fly_onb_auto', '1'); Onboarding.start();
        }
        if (!me) return;
        /* a signup records its ?invite= on the server; this catches a member who arrived through a link
           but signed up another way. with the gate on, the old claim (which also grants entry) runs */
        /* a paused account is not waiting on an invite, so it never claims one */
        if (ls('fly_invite') && !ls('fly_pending_onb') && !me.paused) {
          if (!me.can_act) rpc('claim_invite', { p_code: ls('fly_invite') }).then(function () { ls('fly_invite', null); return loadMe(); }, function () {});
          /* credit a share link only if it was opened before this account was made */
          else MIEN.sb.auth.getSession().then(function (r) {
            var u = r && r.data && r.data.session && r.data.session.user;
            var made = u ? Date.parse(u.created_at) : NaN, at = Number(ls('fly_invite_at'));
            if (!(at && made && at <= made + 60000)) { ls('fly_invite', null); return; }
            return rpc('fly_claim_attribution', { p_code: ls('fly_invite') }).then(function () { ls('fly_invite', null); });
          }).catch(function () {});
        }
        if (ls('fly_pending_onb')) {
          finishPendingOnboarding().then(function (ch) { if (document.querySelector('[data-fly-view]')) Onboarding.resumeAt('card', ch); });
          return;
        }
        /* a signed-in member who never onboarded gets it once per session, on a fly page */
        if (!me.onboarded && !me.is_house && document.querySelector('[data-fly-view="feed"],[data-fly-view="account"]') && !ss('fly_onb_auto')) {
          ss('fly_onb_auto', '1'); Onboarding.start();
        }
      });
      MIEN.onChange(function () { loadMe(); });
      /* sign-out sends what is still queued under the old visitor key before the key is replaced */
      MIEN.flyFlush = function () { Track.flush(true); };
      Array.prototype.forEach.call(document.querySelectorAll('[data-fly-view]'), function (root) {
        var v = root.getAttribute('data-fly-view');
        document.body.classList.add('fl-on');
        ss('mien_popup_shown', '1'); /* fly has its own nudge; keep the timed signup popup quiet here */
        if (views[v]) views[v](root);
      });
    });
  }
  /* the header search box searches mien (blocks, brands, channels): on the feed it filters in
     place, anywhere else it lands on the feed with ?q= */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('.mhd-search, .mhd-ov-search')) return;
    var v = ((f.querySelector('[name="q"]') || {}).value || '').trim();
    e.preventDefault();
    if (document.querySelector('[data-fly-view="feed"]')) document.dispatchEvent(new CustomEvent('fly:search', { detail: v }));
    else location.href = '/' + (v ? '?q=' + encodeURIComponent(v) : '');
  }, true);

  /* "+ post" in the side menu, on any page: close the menu, then the add-block window
     (signed out: the signup modal first, then it continues) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-fly-post]');
    if (!a || !window.MIEN) return;
    e.preventDefault();
    var close = document.querySelector('.mhd-ov [data-mhd-close]');
    if (close) close.click();
    addWin();
  });
  /* "how mien works" in the menu: screen one of the onboarding, as a window */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-fly-how]');
    if (!a || !window.MIEN) return;
    e.preventDefault();
    var close = document.querySelector('.mhd-ov [data-mhd-close]');
    if (close) close.click();
    howWin();
  });
  window.Fly = { start: function (at) { Onboarding.start(at); }, add: function () { addWin(); }, save: saveWin, connect: saveWin, how: function () { howWin(); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
